// solarTermsData.js

// Solar terms mapping (English to Chinese)
export const solarTermsMap = {
  // Major terms (for month pillars)
  'Start of Spring': '立春',
  'Awakening of Insects': '惊蛰',
  'Pure Brightness': '清明',
  'Start of Summer': '立夏',
  'Grain in Ear': '芒种',
  'Minor Heat': '小暑',
  'Start of Autumn': '立秋',
  'White Dew': '白露',
  'Cold Dew': '寒露',
  'Start of Winter': '立冬',
  'Major Snow': '大雪',
  'Minor Cold': '小寒',
  
  // Minor terms
  'Rain Water': '雨水',
  'Spring Equinox': '春分',
  'Grain Rain': '谷雨',
  'Grain Buds': '小满',
  'Summer Solstice': '夏至',
  'Major Heat': '大暑',
  'End of Heat': '处暑',
  'Autumn Equinox': '秋分',
  'Frost\'s Descent': '霜降',
  'Minor Snow': '小雪',
  'Winter Solstice': '冬至',
  'Major Cold': '大寒'
};

// Complete solar terms data structure
export const solarTermsData = {
  // 1899
  1899: {
    "Minor Cold": "1900-01-06T02:03:57+08:00",
    "Major Cold": "1900-01-20T19:32:25+08:00"
  },

  // 1900
  1900: {
    "Start of Spring": "1900-02-04T13:51:31+08:00",
    "Rain Water": "1900-02-19T10:01:14+08:00",
    "Awakening of Insects": "1900-03-06T08:21:52+08:00",
    "Spring Equinox": "1900-03-21T09:39:01+08:00",
    "Pure Brightness": "1900-04-05T13:52:41+08:00",
    "Grain Rain": "1900-04-20T21:27:06+08:00",
    "Start of Summer": "1900-05-06T07:55:12+08:00",
    "Grain Buds": "1900-05-21T21:16:55+08:00",
    "Grain in Ear": "1900-06-06T12:38:55+08:00",
    "Summer Solstice": "1900-06-22T05:39:45+08:00",
    "Minor Heat": "1900-07-07T23:10:08+08:00",
    "Major Heat": "1900-07-23T16:36:07+08:00",
    "Start of Autumn": "1900-08-08T08:50:34+08:00",
    "End of Heat": "1900-08-23T23:19:49+08:00",
    "White Dew": "1900-09-08T11:16:38+08:00",
    "Autumn Equinox": "1900-09-23T20:20:11+08:00",
    "Cold Dew": "1900-10-09T02:13:09+08:00",
    "Frost's Descent": "1900-10-24T04:55:16+08:00",
    "Start of Winter": "1900-11-08T04:39:44+08:00",
    "Minor Snow": "1900-11-23T01:47:50+08:00",
    "Major Snow": "1900-12-07T20:55:50+08:00",
    "Winter Solstice": "1900-12-22T14:41:34+08:00",
    "Minor Cold": "1901-01-06T07:53:23+08:00",
    "Major Cold": "1901-01-21T01:16:28+08:00"
  },
  
  // 1901
  1901: {
    "Start of Spring": "1901-02-04T19:39:52+08:00",
    "Rain Water": "1901-02-19T15:44:54+08:00",
    "Awakening of Insects": "1901-03-06T14:10:53+08:00",
    "Spring Equinox": "1901-03-21T15:23:35+08:00",
    "Pure Brightness": "1901-04-05T19:44:21+08:00",
    "Grain Rain": "1901-04-21T03:13:26+08:00",
    "Start of Summer": "1901-05-06T13:50:24+08:00",
    "Grain Buds": "1901-05-22T03:04:39+08:00",
    "Grain in Ear": "1901-06-06T18:36:27+08:00",
    "Summer Solstice": "1901-06-22T11:27:46+08:00",
    "Minor Heat": "1901-07-08T05:07:34+08:00",
    "Major Heat": "1901-07-23T22:23:45+08:00",
    "Start of Autumn": "1901-08-08T14:46:06+08:00",
    "End of Heat": "1901-08-24T05:07:29+08:00",
    "White Dew": "1901-09-08T17:10:15+08:00",
    "Autumn Equinox": "1901-09-24T02:08:56+08:00",
    "Cold Dew": "1901-10-09T08:06:28+08:00",
    "Frost's Descent": "1901-10-24T10:46:14+08:00",
    "Start of Winter": "1901-11-08T10:34:29+08:00",
    "Minor Snow": "1901-11-23T07:41:13+08:00",
    "Major Snow": "1901-12-08T02:52:37+08:00",
    "Winter Solstice": "1901-12-22T20:36:35+08:00",
    "Minor Cold": "1902-01-06T13:51:33+08:00",
    "Major Cold": "1902-01-21T07:11:56+08:00"
  },
  
  // 1902
  1902: {
    "Start of Spring": "1902-02-05T01:38:10+08:00",
    "Rain Water": "1902-02-19T21:39:42+08:00",
    "Awakening of Insects": "1902-03-06T20:07:32+08:00",
    "Spring Equinox": "1902-03-21T21:16:33+08:00",
    "Pure Brightness": "1902-04-06T01:37:26+08:00",
    "Grain Rain": "1902-04-21T09:04:08+08:00",
    "Start of Summer": "1902-05-06T19:38:48+08:00",
    "Grain Buds": "1902-05-22T08:53:31+08:00",
    "Grain in Ear": "1902-06-07T00:19:47+08:00",
    "Summer Solstice": "1902-06-22T17:15:08+08:00",
    "Minor Heat": "1902-07-08T10:46:19+08:00",
    "Major Heat": "1902-07-24T04:09:52+08:00",
    "Start of Autumn": "1902-08-08T20:22:16+08:00",
    "End of Heat": "1902-08-24T10:53:03+08:00",
    "White Dew": "1902-09-08T22:46:25+08:00",
    "Autumn Equinox": "1902-09-24T07:55:20+08:00",
    "Cold Dew": "1902-10-09T13:45:10+08:00",
    "Frost's Descent": "1902-10-24T16:35:38+08:00",
    "Start of Winter": "1902-11-08T16:17:46+08:00",
    "Minor Snow": "1902-11-23T13:35:23+08:00",
    "Major Snow": "1902-12-08T08:41:01+08:00",
    "Winter Solstice": "1902-12-23T02:35:31+08:00",
    "Minor Cold": "1903-01-06T19:43:43+08:00",
    "Major Cold": "1903-01-21T13:13:32+08:00"
  },
  
  // 1903
  1903: {
    "Start of Spring": "1903-02-05T07:31:17+08:00",
    "Rain Water": "1903-02-20T03:40:48+08:00",
    "Awakening of Insects": "1903-03-07T01:58:52+08:00",
    "Spring Equinox": "1903-03-22T03:14:46+08:00",
    "Pure Brightness": "1903-04-06T07:25:53+08:00",
    "Grain Rain": "1903-04-21T14:58:39+08:00",
    "Start of Summer": "1903-05-07T01:25:22+08:00",
    "Grain Buds": "1903-05-22T14:45:01+08:00",
    "Grain in Ear": "1903-06-07T06:07:07+08:00",
    "Summer Solstice": "1903-06-22T23:04:55+08:00",
    "Minor Heat": "1903-07-08T16:36:36+08:00",
    "Major Heat": "1903-07-24T09:58:45+08:00",
    "Start of Autumn": "1903-08-09T02:15:50+08:00",
    "End of Heat": "1903-08-24T16:41:35+08:00",
    "White Dew": "1903-09-09T04:42:21+08:00",
    "Autumn Equinox": "1903-09-24T13:43:41+08:00",
    "Cold Dew": "1903-10-09T19:41:44+08:00",
    "Frost's Descent": "1903-10-24T22:23:03+08:00",
    "Start of Winter": "1903-11-08T22:13:23+08:00",
    "Minor Snow": "1903-11-23T19:21:24+08:00",
    "Major Snow": "1903-12-08T14:35:19+08:00",
    "Winter Solstice": "1903-12-23T08:20:25+08:00",
    "Minor Cold": "1904-01-07T01:37:02+08:00",
    "Major Cold": "1904-01-21T18:57:51+08:00"
  },
  
  // 1904
  1904: {
    "Start of Spring": "1904-02-05T13:24:07+08:00",
    "Rain Water": "1904-02-20T09:24:51+08:00",
    "Awakening of Insects": "1904-03-06T07:51:39+08:00",
    "Spring Equinox": "1904-03-21T08:58:34+08:00",
    "Pure Brightness": "1904-04-05T13:18:51+08:00",
    "Grain Rain": "1904-04-20T20:42:08+08:00",
    "Start of Summer": "1904-05-06T07:18:34+08:00",
    "Grain Buds": "1904-05-21T20:28:55+08:00",
    "Grain in Ear": "1904-06-06T12:00:58+08:00",
    "Summer Solstice": "1904-06-22T04:51:21+08:00",
    "Minor Heat": "1904-07-07T22:31:41+08:00",
    "Major Heat": "1904-07-23T15:49:35+08:00",
    "Start of Autumn": "1904-08-08T08:11:51+08:00",
    "End of Heat": "1904-08-23T22:36:24+08:00",
    "White Dew": "1904-09-08T10:37:58+08:00",
    "Autumn Equinox": "1904-09-23T19:40:12+08:00",
    "Cold Dew": "1904-10-09T01:35:34+08:00",
    "Frost's Descent": "1904-10-24T04:19:02+08:00",
    "Start of Winter": "1904-11-08T04:04:58+08:00",
    "Minor Snow": "1904-11-23T01:15:53+08:00",
    "Major Snow": "1904-12-07T20:25:20+08:00",
    "Winter Solstice": "1904-12-22T14:13:56+08:00",
    "Minor Cold": "1905-01-06T07:27:06+08:00",
    "Major Cold": "1905-01-21T00:51:56+08:00"
  },
  
  // 1905
  1905: {
    "Start of Spring": "1905-02-04T19:15:49+08:00",
    "Rain Water": "1905-02-19T15:20:58+08:00",
    "Awakening of Insects": "1905-03-06T13:45:36+08:00",
    "Spring Equinox": "1905-03-21T14:57:31+08:00",
    "Pure Brightness": "1905-04-05T19:14:28+08:00",
    "Grain Rain": "1905-04-21T02:43:45+08:00",
    "Start of Summer": "1905-05-06T13:14:04+08:00",
    "Grain Buds": "1905-05-22T02:31:16+08:00",
    "Grain in Ear": "1905-06-06T17:53:33+08:00",
    "Summer Solstice": "1905-06-22T10:51:22+08:00",
    "Minor Heat": "1905-07-08T04:19:59+08:00",
    "Major Heat": "1905-07-23T21:45:37+08:00",
    "Start of Autumn": "1905-08-08T13:56:57+08:00",
    "End of Heat": "1905-08-24T04:28:36+08:00",
    "White Dew": "1905-09-08T16:21:46+08:00",
    "Autumn Equinox": "1905-09-24T01:29:56+08:00",
    "Cold Dew": "1905-10-09T07:19:36+08:00",
    "Frost's Descent": "1905-10-24T10:07:55+08:00",
    "Start of Winter": "1905-11-08T09:49:46+08:00",
    "Minor Snow": "1905-11-23T07:04:53+08:00",
    "Major Snow": "1905-12-08T02:10:47+08:00",
    "Winter Solstice": "1905-12-22T20:03:41+08:00",
    "Minor Cold": "1906-01-06T13:13:27+08:00",
    "Major Cold": "1906-01-21T06:43:14+08:00"
  },
  
  // 1906
  1906: {
    "Start of Spring": "1906-02-05T01:03:54+08:00",
    "Rain Water": "1906-02-19T21:14:27+08:00",
    "Awakening of Insects": "1906-03-06T19:36:06+08:00",
    "Spring Equinox": "1906-03-21T20:52:47+08:00",
    "Pure Brightness": "1906-04-06T01:07:16+08:00",
    "Grain Rain": "1906-04-21T08:39:10+08:00",
    "Start of Summer": "1906-05-06T19:08:29+08:00",
    "Grain Buds": "1906-05-22T08:24:55+08:00",
    "Grain in Ear": "1906-06-06T23:48:54+08:00",
    "Summer Solstice": "1906-06-22T16:41:48+08:00",
    "Minor Heat": "1906-07-08T10:15:16+08:00",
    "Major Heat": "1906-07-24T03:32:32+08:00",
    "Start of Autumn": "1906-08-08T19:51:34+08:00",
    "End of Heat": "1906-08-24T10:13:32+08:00",
    "White Dew": "1906-09-08T22:16:12+08:00",
    "Autumn Equinox": "1906-09-24T07:14:59+08:00",
    "Cold Dew": "1906-10-09T13:14:53+08:00",
    "Frost's Descent": "1906-10-24T15:54:43+08:00",
    "Start of Winter": "1906-11-08T15:46:54+08:00",
    "Minor Snow": "1906-11-23T12:53:51+08:00",
    "Major Snow": "1906-12-08T08:09:25+08:00",
    "Winter Solstice": "1906-12-23T01:53:16+08:00",
    "Minor Cold": "1907-01-06T19:11:25+08:00",
    "Major Cold": "1907-01-21T12:30:47+08:00"
  },
  
  // 1907
  1907: {
    "Start of Spring": "1907-02-05T06:58:49+08:00",
    "Rain Water": "1907-02-20T02:58:18+08:00",
    "Awakening of Insects": "1907-03-07T01:27:05+08:00",
    "Spring Equinox": "1907-03-22T02:32:59+08:00",
    "Pure Brightness": "1907-04-06T06:54:47+08:00",
    "Grain Rain": "1907-04-21T14:17:13+08:00",
    "Start of Summer": "1907-05-07T00:53:35+08:00",
    "Grain Buds": "1907-05-22T14:03:14+08:00",
    "Grain in Ear": "1907-06-07T05:32:56+08:00",
    "Summer Solstice": "1907-06-22T22:22:59+08:00",
    "Minor Heat": "1907-07-08T15:59:10+08:00",
    "Major Heat": "1907-07-24T09:17:56+08:00",
    "Start of Autumn": "1907-08-09T01:35:58+08:00",
    "End of Heat": "1907-08-24T16:03:23+08:00",
    "White Dew": "1907-09-09T04:02:02+08:00",
    "Autumn Equinox": "1907-09-24T13:08:52+08:00",
    "Cold Dew": "1907-10-09T19:02:42+08:00",
    "Frost's Descent": "1907-10-24T21:51:30+08:00",
    "Start of Winter": "1907-11-08T21:36:17+08:00",
    "Minor Snow": "1907-11-23T18:52:03+08:00",
    "Major Snow": "1907-12-08T13:59:26+08:00",
    "Winter Solstice": "1907-12-23T07:51:32+08:00",
    "Minor Cold": "1908-01-07T01:01:07+08:00",
    "Major Cold": "1908-01-21T18:28:04+08:00"
  },
  
  // 1908
  1908: {
    "Start of Spring": "1908-02-05T12:47:13+08:00",
    "Rain Water": "1908-02-20T08:53:54+08:00",
    "Awakening of Insects": "1908-03-06T07:13:34+08:00",
    "Spring Equinox": "1908-03-21T08:27:14+08:00",
    "Pure Brightness": "1908-04-05T12:39:46+08:00",
    "Grain Rain": "1908-04-20T20:11:15+08:00",
    "Start of Summer": "1908-05-06T06:38:20+08:00",
    "Grain Buds": "1908-05-21T19:58:06+08:00",
    "Grain in Ear": "1908-06-06T11:19:03+08:00",
    "Summer Solstice": "1908-06-22T04:19:01+08:00",
    "Minor Heat": "1908-07-07T21:48:00+08:00",
    "Major Heat": "1908-07-23T15:14:05+08:00",
    "Start of Autumn": "1908-08-08T07:26:42+08:00",
    "End of Heat": "1908-08-23T21:56:59+08:00",
    "White Dew": "1908-09-08T09:52:16+08:00",
    "Autumn Equinox": "1908-09-23T18:58:15+08:00",
    "Cold Dew": "1908-10-09T00:50:51+08:00",
    "Frost's Descent": "1908-10-24T03:36:47+08:00",
    "Start of Winter": "1908-11-08T03:22:01+08:00",
    "Minor Snow": "1908-11-23T00:34:37+08:00",
    "Major Snow": "1908-12-07T19:43:37+08:00",
    "Winter Solstice": "1908-12-22T13:33:24+08:00",
    "Minor Cold": "1909-01-06T06:45:13+08:00",
    "Major Cold": "1909-01-21T00:10:55+08:00"
  },
  
  // 1909
  1909: {
    "Start of Spring": "1909-02-04T18:32:31+08:00",
    "Rain Water": "1909-02-19T14:38:19+08:00",
    "Awakening of Insects": "1909-03-06T13:00:47+08:00",
    "Spring Equinox": "1909-03-21T14:12:56+08:00",
    "Pure Brightness": "1909-04-05T18:29:25+08:00",
    "Grain Rain": "1909-04-21T01:57:44+08:00",
    "Start of Summer": "1909-05-06T12:30:50+08:00",
    "Grain Buds": "1909-05-22T01:44:52+08:00",
    "Grain in Ear": "1909-06-06T17:13:56+08:00",
    "Summer Solstice": "1909-06-22T10:05:31+08:00",
    "Minor Heat": "1909-07-08T03:43:57+08:00",
    "Major Heat": "1909-07-23T21:00:26+08:00",
    "Start of Autumn": "1909-08-08T13:22:28+08:00",
    "End of Heat": "1909-08-24T03:43:30+08:00",
    "White Dew": "1909-09-08T15:46:35+08:00",
    "Autumn Equinox": "1909-09-24T00:44:29+08:00",
    "Cold Dew": "1909-10-09T06:43:08+08:00",
    "Frost's Descent": "1909-10-24T09:22:30+08:00",
    "Start of Winter": "1909-11-08T09:13:03+08:00",
    "Minor Snow": "1909-11-23T06:20:15+08:00",
    "Major Snow": "1909-12-08T01:34:49+08:00",
    "Winter Solstice": "1909-12-22T19:19:47+08:00",
    "Minor Cold": "1910-01-06T12:37:57+08:00",
    "Major Cold": "1910-01-21T05:58:56+08:00"
  },
  
  // 1910
  1910: {
    "Start of Spring": "1910-02-05T00:27:22+08:00",
    "Rain Water": "1910-02-19T20:28:07+08:00",
    "Awakening of Insects": "1910-03-06T18:56:30+08:00",
    "Spring Equinox": "1910-03-21T20:02:52+08:00",
    "Pure Brightness": "1910-04-06T00:22:55+08:00",
    "Grain Rain": "1910-04-21T07:45:42+08:00",
    "Start of Summer": "1910-05-06T18:19:20+08:00",
    "Grain Buds": "1910-05-22T07:30:08+08:00",
    "Grain in Ear": "1910-06-06T22:56:20+08:00",
    "Summer Solstice": "1910-06-22T15:48:41+08:00",
    "Minor Heat": "1910-07-08T09:21:02+08:00",
    "Major Heat": "1910-07-24T02:42:56+08:00",
    "Start of Autumn": "1910-08-08T18:57:08+08:00",
    "End of Heat": "1910-08-24T09:27:20+08:00",
    "White Dew": "1910-09-08T21:22:10+08:00",
    "Autumn Equinox": "1910-09-24T06:30:44+08:00",
    "Cold Dew": "1910-10-09T12:21:05+08:00",
    "Frost's Descent": "1910-10-24T15:11:08+08:00",
    "Start of Winter": "1910-11-08T14:53:23+08:00",
    "Minor Snow": "1910-11-23T12:10:50+08:00",
    "Major Snow": "1910-12-08T07:16:53+08:00",
    "Winter Solstice": "1910-12-23T01:11:43+08:00",
    "Minor Cold": "1911-01-06T18:20:52+08:00",
    "Major Cold": "1911-01-21T11:51:23+08:00"
  },
  
  // 1911
  1911: {
    "Start of Spring": "1911-02-05T06:10:16+08:00",
    "Rain Water": "1911-02-20T02:20:16+08:00",
    "Awakening of Insects": "1911-03-07T00:38:50+08:00",
    "Spring Equinox": "1911-03-22T01:54:20+08:00",
    "Pure Brightness": "1911-04-06T06:04:32+08:00",
    "Grain Rain": "1911-04-21T13:35:55+08:00",
    "Start of Summer": "1911-05-07T00:00:18+08:00",
    "Grain Buds": "1911-05-22T13:18:33+08:00",
    "Grain in Ear": "1911-06-07T04:37:52+08:00",
    "Summer Solstice": "1911-06-22T21:35:30+08:00",
    "Minor Heat": "1911-07-08T15:04:55+08:00",
    "Major Heat": "1911-07-24T08:28:36+08:00",
    "Start of Autumn": "1911-08-09T00:44:25+08:00",
    "End of Heat": "1911-08-24T15:12:57+08:00",
    "White Dew": "1911-09-09T03:13:16+08:00",
    "Autumn Equinox": "1911-09-24T12:17:30+08:00",
    "Cold Dew": "1911-10-09T18:14:56+08:00",
    "Frost's Descent": "1911-10-24T20:58:11+08:00",
    "Start of Winter": "1911-11-08T20:47:00+08:00",
    "Minor Snow": "1911-11-23T17:55:53+08:00",
    "Major Snow": "1911-12-08T13:07:34+08:00",
    "Winter Solstice": "1911-12-23T06:53:09+08:00",
    "Minor Cold": "1912-01-07T00:07:29+08:00",
    "Major Cold": "1912-01-21T17:29:06+08:00"
  },
  
  // 1912
  1912: {
    "Start of Spring": "1912-02-05T11:53:31+08:00",
    "Rain Water": "1912-02-20T07:55:34+08:00",
    "Awakening of Insects": "1912-03-06T06:20:59+08:00",
    "Spring Equinox": "1912-03-21T07:29:19+08:00",
    "Pure Brightness": "1912-04-05T11:48:15+08:00",
    "Grain Rain": "1912-04-20T19:12:21+08:00",
    "Start of Summer": "1912-05-06T05:47:03+08:00",
    "Grain Buds": "1912-05-21T18:57:06+08:00",
    "Grain in Ear": "1912-06-06T10:27:29+08:00",
    "Summer Solstice": "1912-06-22T03:16:51+08:00",
    "Minor Heat": "1912-07-07T20:56:42+08:00",
    "Major Heat": "1912-07-23T14:13:40+08:00",
    "Start of Autumn": "1912-08-08T06:37:10+08:00",
    "End of Heat": "1912-08-23T21:01:19+08:00",
    "White Dew": "1912-09-08T09:05:39+08:00",
    "Autumn Equinox": "1912-09-23T18:07:59+08:00",
    "Cold Dew": "1912-10-09T00:06:42+08:00",
    "Frost's Descent": "1912-10-24T02:50:00+08:00",
    "Start of Winter": "1912-11-08T02:38:38+08:00",
    "Minor Snow": "1912-11-22T23:48:08+08:00",
    "Major Snow": "1912-12-07T18:58:53+08:00",
    "Winter Solstice": "1912-12-22T12:44:39+08:00",
    "Minor Cold": "1913-01-06T05:57:54+08:00",
    "Major Cold": "1913-01-20T23:19:04+08:00"
  },
  
  // 1913
  1913: {
    "Start of Spring": "1913-02-04T17:42:38+08:00",
    "Rain Water": "1913-02-19T13:44:12+08:00",
    "Awakening of Insects": "1913-03-06T12:08:58+08:00",
    "Spring Equinox": "1913-03-21T13:17:55+08:00",
    "Pure Brightness": "1913-04-05T17:35:51+08:00",
    "Grain Rain": "1913-04-21T01:02:51+08:00",
    "Start of Summer": "1913-05-06T11:34:39+08:00",
    "Grain Buds": "1913-05-22T00:49:51+08:00",
    "Grain in Ear": "1913-06-06T16:13:24+08:00",
    "Summer Solstice": "1913-06-22T09:09:26+08:00",
    "Minor Heat": "1913-07-08T02:38:52+08:00",
    "Major Heat": "1913-07-23T20:03:41+08:00",
    "Start of Autumn": "1913-08-08T12:15:47+08:00",
    "End of Heat": "1913-08-24T02:48:09+08:00",
    "White Dew": "1913-09-08T14:42:24+08:00",
    "Autumn Equinox": "1913-09-23T23:52:41+08:00",
    "Cold Dew": "1913-10-09T05:43:40+08:00",
    "Frost's Descent": "1913-10-24T08:34:49+08:00",
    "Start of Winter": "1913-11-08T08:17:42+08:00",
    "Minor Snow": "1913-11-23T05:35:12+08:00",
    "Major Snow": "1913-12-08T00:41:01+08:00",
    "Winter Solstice": "1913-12-22T18:34:51+08:00",
    "Minor Cold": "1914-01-06T11:42:51+08:00",
    "Major Cold": "1914-01-21T05:11:49+08:00"
  },
  
  // 1914
  1914: {
    "Start of Spring": "1914-02-04T23:29:16+08:00",
    "Rain Water": "1914-02-19T19:37:54+08:00",
    "Awakening of Insects": "1914-03-06T17:55:48+08:00",
    "Spring Equinox": "1914-03-21T19:10:42+08:00",
    "Pure Brightness": "1914-04-05T23:21:50+08:00",
    "Grain Rain": "1914-04-21T06:53:12+08:00",
    "Start of Summer": "1914-05-06T17:20:03+08:00",
    "Grain Buds": "1914-05-22T06:37:38+08:00",
    "Grain in Ear": "1914-06-06T21:59:56+08:00",
    "Summer Solstice": "1914-06-22T14:55:00+08:00",
    "Minor Heat": "1914-07-08T08:27:12+08:00",
    "Major Heat": "1914-07-24T01:46:52+08:00",
    "Start of Autumn": "1914-08-08T18:05:11+08:00",
    "End of Heat": "1914-08-24T08:29:34+08:00",
    "White Dew": "1914-09-08T20:32:26+08:00",
    "Autumn Equinox": "1914-09-24T05:33:47+08:00",
    "Cold Dew": "1914-10-09T11:34:47+08:00",
    "Frost's Descent": "1914-10-24T14:17:16+08:00",
    "Start of Winter": "1914-11-08T14:11:01+08:00",
    "Minor Snow": "1914-11-23T11:20:21+08:00",
    "Major Snow": "1914-12-08T06:37:05+08:00",
    "Winter Solstice": "1914-12-23T00:22:22+08:00",
    "Minor Cold": "1915-01-06T17:40:16+08:00",
    "Major Cold": "1915-01-21T10:59:30+08:00"
  },
  
  // 1915
  1915: {
    "Start of Spring": "1915-02-05T05:25:26+08:00",
    "Rain Water": "1915-02-20T01:23:03+08:00",
    "Awakening of Insects": "1915-03-06T23:48:16+08:00",
    "Spring Equinox": "1915-03-22T00:51:14+08:00",
    "Pure Brightness": "1915-04-06T05:09:15+08:00",
    "Grain Rain": "1915-04-21T12:28:46+08:00",
    "Start of Summer": "1915-05-06T23:02:44+08:00",
    "Grain Buds": "1915-05-22T12:10:23+08:00",
    "Grain in Ear": "1915-06-07T03:40:07+08:00",
    "Summer Solstice": "1915-06-22T20:29:20+08:00",
    "Minor Heat": "1915-07-08T14:07:45+08:00",
    "Major Heat": "1915-07-24T07:26:21+08:00",
    "Start of Autumn": "1915-08-08T23:47:41+08:00",
    "End of Heat": "1915-08-24T14:14:58+08:00",
    "White Dew": "1915-09-09T02:17:05+08:00",
    "Autumn Equinox": "1915-09-24T11:23:45+08:00",
    "Cold Dew": "1915-10-09T17:20:52+08:00",
    "Frost's Descent": "1915-10-24T20:09:39+08:00",
    "Start of Winter": "1915-11-08T19:57:38+08:00",
    "Minor Snow": "1915-11-23T17:13:26+08:00",
    "Major Snow": "1915-12-08T12:23:53+08:00",
    "Winter Solstice": "1915-12-23T06:15:44+08:00",
    "Minor Cold": "1916-01-06T23:27:47+08:00",
    "Major Cold": "1916-01-21T16:53:33+08:00"
  },
  
  // 1916
  1916: {
    "Start of Spring": "1916-02-05T11:13:58+08:00",
    "Rain Water": "1916-02-20T07:17:59+08:00",
    "Awakening of Insects": "1916-03-06T05:37:21+08:00",
    "Spring Equinox": "1916-03-21T06:46:50+08:00",
    "Pure Brightness": "1916-04-05T10:57:49+08:00",
    "Grain Rain": "1916-04-20T18:24:35+08:00",
    "Start of Summer": "1916-05-06T04:49:45+08:00",
    "Grain Buds": "1916-05-21T18:05:50+08:00",
    "Grain in Ear": "1916-06-06T09:25:39+08:00",
    "Summer Solstice": "1916-06-22T02:24:21+08:00",
    "Minor Heat": "1916-07-07T19:53:33+08:00",
    "Major Heat": "1916-07-23T13:21:08+08:00",
    "Start of Autumn": "1916-08-08T05:34:55+08:00",
    "End of Heat": "1916-08-23T20:08:31+08:00",
    "White Dew": "1916-09-08T08:04:59+08:00",
    "Autumn Equinox": "1916-09-23T17:14:43+08:00",
    "Cold Dew": "1916-10-08T23:07:51+08:00",
    "Frost's Descent": "1916-10-24T01:57:11+08:00",
    "Start of Winter": "1916-11-08T01:42:15+08:00",
    "Minor Snow": "1916-11-22T22:57:44+08:00",
    "Major Snow": "1916-12-07T18:06:09+08:00",
    "Winter Solstice": "1916-12-22T11:58:29+08:00",
    "Minor Cold": "1917-01-06T05:09:27+08:00",
    "Major Cold": "1917-01-20T22:37:18+08:00"
  },
  
  // 1917
  1917: {
    "Start of Spring": "1917-02-04T16:57:32+08:00", 
    "Rain Water": "1917-02-19T13:04:44+08:00", 
    "Awakening of Insects": "1917-03-06T11:24:48+08:00", 
    "Spring Equinox": "1917-03-21T12:37:11+08:00", 
    "Pure Brightness": "1917-04-05T16:49:54+08:00", 
    "Grain Rain": "1917-04-21T00:17:22+08:00", 
    "Start of Summer": "1917-05-06T10:45:42+08:00", 
    "Grain Buds": "1917-05-21T23:58:31+08:00", 
    "Grain in Ear": "1917-06-06T15:23:10+08:00", 
    "Summer Solstice": "1917-06-22T08:14:16+08:00", 
    "Minor Heat": "1917-07-08T01:50:13+08:00", 
    "Major Heat": "1917-07-23T19:07:45+08:00", 
    "Start of Autumn": "1917-08-08T11:30:07+08:00", 
    "End of Heat": "1917-08-24T01:53:38+08:00", 
    "White Dew": "1917-09-08T13:59:21+08:00", 
    "Autumn Equinox": "1917-09-23T23:00:06+08:00", 
    "Cold Dew": "1917-10-09T05:02:08+08:00", 
    "Frost's Descent": "1917-10-24T07:43:37+08:00", 
    "Start of Winter": "1917-11-08T07:36:54+08:00", 
    "Minor Snow": "1917-11-23T04:44:52+08:00", 
    "Major Snow": "1917-12-08T00:00:59+08:00", 
    "Winter Solstice": "1917-12-22T17:45:37+08:00", 
    "Minor Cold": "1918-01-06T11:04:23+08:00", 
    "Major Cold": "1918-01-21T04:24:32+08:00"
  },
  
  // 1918
  1918: {
    "Start of Spring": "1918-02-04T22:53:05+08:00", 
    "Rain Water": "1918-02-19T18:52:41+08:00", 
    "Awakening of Insects": "1918-03-06T17:20:55+08:00", 
    "Spring Equinox": "1918-03-21T18:25:37+08:00", 
    "Pure Brightness": "1918-04-05T22:45:12+08:00", 
    "Grain Rain": "1918-04-21T06:05:23+08:00", 
    "Start of Summer": "1918-05-06T16:38:11+08:00", 
    "Grain Buds": "1918-05-22T05:45:27+08:00", 
    "Grain in Ear": "1918-06-06T21:10:57+08:00", 
    "Summer Solstice": "1918-06-22T13:59:34+08:00", 
    "Minor Heat": "1918-07-08T07:32:07+08:00", 
    "Major Heat": "1918-07-24T00:51:23+08:00", 
    "Start of Autumn": "1918-08-08T17:07:24+08:00", 
    "End of Heat": "1918-08-24T07:37:07+08:00", 
    "White Dew": "1918-09-08T19:35:26+08:00", 
    "Autumn Equinox": "1918-09-24T04:45:37+08:00", 
    "Cold Dew": "1918-10-09T10:40:17+08:00", 
    "Frost's Descent": "1918-10-24T13:32:47+08:00", 
    "Start of Winter": "1918-11-08T13:18:52+08:00", 
    "Minor Snow": "1918-11-23T10:38:02+08:00", 
    "Major Snow": "1918-12-08T05:46:29+08:00", 
    "Winter Solstice": "1918-12-22T23:41:27+08:00", 
    "Minor Cold": "1919-01-06T16:51:28+08:00", 
    "Major Cold": "1919-01-21T10:20:40+08:00"
  },
  
  // 1919
  1919: {
    "Start of Spring": "1919-02-05T04:39:23+08:00", 
    "Rain Water": "1919-02-20T00:47:25+08:00", 
    "Awakening of Insects": "1919-03-06T23:05:29+08:00", 
    "Spring Equinox": "1919-03-22T00:19:05+08:00", 
    "Pure Brightness": "1919-04-06T04:28:44+08:00", 
    "Grain Rain": "1919-04-21T11:58:35+08:00", 
    "Start of Summer": "1919-05-06T22:22:00+08:00", 
    "Grain Buds": "1919-05-22T11:39:04+08:00", 
    "Grain in Ear": "1919-06-07T02:56:36+08:00", 
    "Summer Solstice": "1919-06-22T19:53:30+08:00", 
    "Minor Heat": "1919-07-08T13:20:30+08:00", 
    "Major Heat": "1919-07-24T06:44:26+08:00", 
    "Start of Autumn": "1919-08-08T22:58:01+08:00", 
    "End of Heat": "1919-08-24T13:28:16+08:00", 
    "White Dew": "1919-09-09T01:27:37+08:00", 
    "Autumn Equinox": "1919-09-24T10:35:18+08:00", 
    "Cold Dew": "1919-10-09T16:33:20+08:00", 
    "Frost's Descent": "1919-10-24T19:21:14+08:00", 
    "Start of Winter": "1919-11-08T19:11:30+08:00", 
    "Minor Snow": "1919-11-23T16:25:07+08:00", 
    "Major Snow": "1919-12-08T11:37:47+08:00", 
    "Winter Solstice": "1919-12-23T05:27:01+08:00", 
    "Minor Cold": "1920-01-06T22:40:47+08:00", 
    "Major Cold": "1920-01-21T16:04:20+08:00"
  },
  
  // 1920
  1920: {
    "Start of Spring": "1920-02-05T10:26:26+08:00", 
    "Rain Water": "1920-02-20T06:28:57+08:00", 
    "Awakening of Insects": "1920-03-06T04:51:02+08:00", 
    "Spring Equinox": "1920-03-21T05:59:15+08:00", 
    "Pure Brightness": "1920-04-05T10:14:54+08:00", 
    "Grain Rain": "1920-04-20T17:39:07+08:00", 
    "Start of Summer": "1920-05-06T04:11:17+08:00", 
    "Grain Buds": "1920-05-21T17:21:43+08:00", 
    "Grain in Ear": "1920-06-06T08:50:22+08:00", 
    "Summer Solstice": "1920-06-22T01:39:45+08:00", 
    "Minor Heat": "1920-07-07T19:18:36+08:00", 
    "Major Heat": "1920-07-23T12:34:53+08:00", 
    "Start of Autumn": "1920-08-08T04:58:14+08:00", 
    "End of Heat": "1920-08-23T19:21:15+08:00", 
    "White Dew": "1920-09-08T10:19:05+08:00", 
    "Autumn Equinox": "1920-09-23T16:28:05+08:00", 
    "Cold Dew": "1920-10-08T22:29:08+08:00", 
    "Frost's Descent": "1920-10-24T01:12:39+08:00", 
    "Start of Winter": "1920-11-08T01:04:54+08:00", 
    "Minor Snow": "1920-11-22T22:15:23+08:00", 
    "Major Snow": "1920-12-07T17:30:16+08:00", 
    "Winter Solstice": "1920-12-22T11:16:56+08:00", 
    "Minor Cold": "1921-01-06T04:33:40+08:00", 
    "Major Cold": "1921-01-20T21:54:39+08:00" 
  },
  
  // 1921
  1921: {
    "Start of Spring": "1921-02-04T16:20:12+08:00",
    "Rain Water": "1921-02-19T12:19:56+08:00",
    "Awakening of Insects": "1921-03-06T10:45:09+08:00",
    "Spring Equinox": "1921-03-21T11:50:58+08:00",
    "Pure Brightness": "1921-04-05T16:08:41+08:00",
    "Grain Rain": "1921-04-20T23:32:14+08:00",
    "Start of Summer": "1921-05-06T10:04:17+08:00",
    "Grain Buds": "1921-05-21T23:16:40+08:00",
    "Grain in Ear": "1921-06-06T14:41:25+08:00",
    "Summer Solstice": "1921-06-22T07:35:35+08:00",
    "Minor Heat": "1921-07-08T01:06:34+08:00",
    "Major Heat": "1921-07-23T18:30:15+08:00",
    "Start of Autumn": "1921-08-08T10:43:25+08:00",
    "End of Heat": "1921-08-24T01:15:07+08:00",
    "White Dew": "1921-09-08T13:09:39+08:00",
    "Autumn Equinox": "1921-09-23T22:19:42+08:00",
    "Cold Dew": "1921-10-09T04:10:36+08:00",
    "Frost's Descent": "1921-10-24T07:02:15+08:00",
    "Start of Winter": "1921-11-08T06:45:30+08:00",
    "Minor Snow": "1921-11-23T04:04:27+08:00",
    "Major Snow": "1921-12-07T23:11:25+08:00",
    "Winter Solstice": "1921-12-22T17:07:23+08:00",
    "Minor Cold": "1922-01-06T10:16:55+08:00",
    "Major Cold": "1922-01-21T03:47:54+08:00"
  },
  
  // 1922
  1922: {
    "Start of Spring": "1922-02-04T22:06:24+08:00",
    "Rain Water": "1922-02-19T18:16:09+08:00",
    "Awakening of Insects": "1922-03-06T16:33:49+08:00",
    "Spring Equinox": "1922-03-21T17:48:33+08:00",
    "Pure Brightness": "1922-04-05T21:58:00+08:00",
    "Grain Rain": "1922-04-21T05:28:32+08:00",
    "Start of Summer": "1922-05-06T15:52:50+08:00",
    "Grain Buds": "1922-05-22T05:10:13+08:00",
    "Grain in Ear": "1922-06-06T20:30:15+08:00",
    "Summer Solstice": "1922-06-22T13:26:39+08:00",
    "Minor Heat": "1922-07-08T06:57:25+08:00",
    "Major Heat": "1922-07-24T00:19:38+08:00",
    "Start of Autumn": "1922-08-08T16:37:08+08:00",
    "End of Heat": "1922-08-24T07:04:09+08:00",
    "White Dew": "1922-09-08T19:06:19+08:00",
    "Autumn Equinox": "1922-09-24T04:09:32+08:00",
    "Cold Dew": "1922-10-09T10:09:25+08:00",
    "Frost's Descent": "1922-10-24T12:52:52+08:00",
    "Start of Winter": "1922-11-08T12:45:12+08:00",
    "Minor Snow": "1922-11-23T09:55:09+08:00",
    "Major Snow": "1922-12-08T05:10:38+08:00",
    "Winter Solstice": "1922-12-22T22:56:52+08:00",
    "Minor Cold": "1923-01-06T16:14:00+08:00",
    "Major Cold": "1923-01-21T09:34:45+08:00"
  },
  
  // 1923
  1923: {
    "Start of Spring": "1923-02-05T04:00:17+08:00",
    "Rain Water": "1923-02-19T23:59:40+08:00",
    "Awakening of Insects": "1923-03-06T22:24:26+08:00",
    "Spring Equinox": "1923-03-21T23:28:42+08:00",
    "Pure Brightness": "1923-04-06T03:45:47+08:00",
    "Grain Rain": "1923-04-21T11:05:33+08:00",
    "Start of Summer": "1923-05-06T21:38:14+08:00",
    "Grain Buds": "1923-05-22T10:45:13+08:00",
    "Grain in Ear": "1923-06-07T02:14:18+08:00",
    "Summer Solstice": "1923-06-22T19:02:42+08:00",
    "Minor Heat": "1923-07-08T12:42:11+08:00",
    "Major Heat": "1923-07-24T06:00:29+08:00",
    "Start of Autumn": "1923-08-08T22:24:29+08:00",
    "End of Heat": "1923-08-24T12:51:45+08:00",
    "White Dew": "1923-09-09T00:57:09+08:00",
    "Autumn Equinox": "1923-09-24T10:03:30+08:00",
    "Cold Dew": "1923-10-09T16:03:22+08:00",
    "Frost's Descent": "1923-10-24T18:50:49+08:00",
    "Start of Winter": "1923-11-08T18:40:20+08:00",
    "Minor Snow": "1923-11-23T15:53:36+08:00",
    "Major Snow": "1923-12-08T11:04:33+08:00",
    "Winter Solstice": "1923-12-23T04:53:13+08:00",
    "Minor Cold": "1924-01-06T22:05:33+08:00",
    "Major Cold": "1924-01-21T15:28:21+08:00"
  },
  
  // 1924
  1924: {
    "Start of Spring": "1924-02-05T09:49:32+08:00",
    "Rain Water": "1924-02-20T05:51:16+08:00",
    "Awakening of Insects": "1924-03-06T04:12:12+08:00",
    "Spring Equinox": "1924-03-21T05:20:05+08:00",
    "Pure Brightness": "1924-04-05T09:33:07+08:00",
    "Grain Rain": "1924-04-20T16:58:33+08:00",
    "Start of Summer": "1924-05-06T03:25:39+08:00",
    "Grain Buds": "1924-05-21T16:40:25+08:00",
    "Grain in Ear": "1924-06-06T08:01:31+08:00",
    "Summer Solstice": "1924-06-22T00:59:18+08:00",
    "Minor Heat": "1924-07-07T18:29:24+08:00",
    "Major Heat": "1924-07-23T11:57:27+08:00",
    "Start of Autumn": "1924-08-08T04:12:14+08:00",
    "End of Heat": "1924-08-23T18:47:53+08:00",
    "White Dew": "1924-09-08T06:45:30+08:00",
    "Autumn Equinox": "1924-09-23T15:58:13+08:00",
    "Cold Dew": "1924-10-08T21:52:09+08:00",
    "Frost's Descent": "1924-10-24T00:44:22+08:00",
    "Start of Winter": "1924-11-08T00:29:11+08:00",
    "Minor Snow": "1924-11-22T21:46:22+08:00",
    "Major Snow": "1924-12-07T16:52:59+08:00",
    "Winter Solstice": "1924-12-22T10:45:24+08:00",
    "Minor Cold": "1925-01-06T03:53:14+08:00",
    "Major Cold": "1925-01-20T21:20:08+08:00"
  },
  
  // 1925
  1925: {
    "Start of Spring": "1925-02-04T15:36:45+08:00",
    "Rain Water": "1925-02-19T11:42:59+08:00",
    "Awakening of Insects": "1925-03-06T09:59:50+08:00",
    "Spring Equinox": "1925-03-21T11:12:06+08:00",
    "Pure Brightness": "1925-04-05T15:22:27+08:00",
    "Grain Rain": "1925-04-20T22:51:05+08:00",
    "Start of Summer": "1925-05-06T09:17:51+08:00",
    "Grain Buds": "1925-05-21T22:32:53+08:00",
    "Grain in Ear": "1925-06-06T13:56:22+08:00",
    "Summer Solstice": "1925-06-22T06:49:54+08:00",
    "Minor Heat": "1925-07-08T00:24:54+08:00",
    "Major Heat": "1925-07-23T17:44:47+08:00",
    "Start of Autumn": "1925-08-08T10:07:05+08:00",
    "End of Heat": "1925-08-24T00:33:05+08:00",
    "White Dew": "1925-09-08T12:40:01+08:00",
    "Autumn Equinox": "1925-09-23T21:43:19+08:00",
    "Cold Dew": "1925-10-09T03:47:22+08:00",
    "Frost's Descent": "1925-10-24T06:31:02+08:00",
    "Start of Winter": "1925-11-08T06:26:13+08:00",
    "Minor Snow": "1925-11-23T03:35:24+08:00",
    "Major Snow": "1925-12-07T22:52:17+08:00",
    "Winter Solstice": "1925-12-22T16:36:35+08:00",
    "Minor Cold": "1926-01-06T09:54:17+08:00",
    "Major Cold": "1926-01-21T03:12:25+08:00"
  },
  
  // 1926
  1926: {
    "Start of Spring": "1926-02-04T21:38:16+08:00",
    "Rain Water": "1926-02-19T17:34:43+08:00",
    "Awakening of Insects": "1926-03-06T15:59:41+08:00",
    "Spring Equinox": "1926-03-21T17:01:08+08:00",
    "Pure Brightness": "1926-04-05T21:18:17+08:00",
    "Grain Rain": "1926-04-21T04:36:03+08:00",
    "Start of Summer": "1926-05-06T15:08:20+08:00",
    "Grain Buds": "1926-05-22T04:14:26+08:00",
    "Grain in Ear": "1926-06-06T19:41:37+08:00",
    "Summer Solstice": "1926-06-22T12:29:58+08:00",
    "Minor Heat": "1926-07-08T06:05:36+08:00",
    "Major Heat": "1926-07-23T23:24:44+08:00",
    "Start of Autumn": "1926-08-08T15:44:12+08:00",
    "End of Heat": "1926-08-24T06:13:54+08:00",
    "White Dew": "1926-09-08T18:15:51+08:00",
    "Autumn Equinox": "1926-09-24T03:26:32+08:00",
    "Cold Dew": "1926-10-09T09:24:51+08:00",
    "Frost's Descent": "1926-10-24T12:18:14+08:00",
    "Start of Winter": "1926-11-08T12:07:42+08:00",
    "Minor Snow": "1926-11-23T09:27:330+08:00",
    "Major Snow": "1926-12-08T04:38:39+08:00",
    "Winter Solstice": "1926-12-22T22:33:18+08:00",
    "Minor Cold": "1927-01-06T15:44:37+08:00",
    "Major Cold": "1927-01-21T09:11:48+08:00"
  },
  
  // 1927
  1927: {
    "Start of Spring": "1927-02-05T03:30:02+08:00",
    "Rain Water": "1927-02-19T23:34:13+08:00",
    "Awakening of Insects": "1927-03-06T21:50:16+08:00",
    "Spring Equinox": "1927-03-21T22:59:02+08:00",
    "Pure Brightness": "1927-04-06T03:06:06+08:00",
    "Grain Rain": "1927-04-21T10:31:38+08:00",
    "Start of Summer": "1927-05-06T20:53:04+08:00",
    "Grain Buds": "1927-05-22T10:07:47+08:00",
    "Grain in Ear": "1927-06-07T01:24:45+08:00",
    "Summer Solstice": "1927-06-22T18:22:07+08:00",
    "Minor Heat": "1927-07-08T11:49:55+08:00",
    "Major Heat": "1927-07-24T05:16:41+08:00",
    "Start of Autumn": "1927-08-08T21:31:23+08:00",
    "End of Heat": "1927-08-24T12:05:23+08:00",
    "White Dew": "1927-09-09T00:05:25+08:00",
    "Autumn Equinox": "1927-09-24T09:16:52+08:00",
    "Cold Dew": "1927-10-09T15:15:05+08:00",
    "Frost's Descent": "1927-10-24T18:06:37+08:00",
    "Start of Winter": "1927-11-08T17:56:54+08:00",
    "Minor Snow": "1927-11-23T15:13:55+08:00",
    "Major Snow": "1927-12-08T10:26:18+08:00",
    "Winter Solstice": "1927-12-23T04:18:26+08:00",
    "Minor Cold": "1928-01-06T21:31:11+08:00",
    "Major Cold": "1928-01-21T14:56:36+08:00"
  },
  
  // 1928
  1928: {
    "Start of Spring": "1928-02-05T09:16:22+08:00",
    "Rain Water": "1928-02-20T05:19:12+08:00",
    "Awakening of Insects": "1928-03-06T03:37:14+08:00",
    "Spring Equinox": "1928-03-21T04:44:11+08:00",
    "Pure Brightness": "1928-04-05T08:54:31+08:00",
    "Grain Rain": "1928-04-20T16:16:40+08:00",
    "Start of Summer": "1928-05-06T02:43:29+08:00",
    "Grain Buds": "1928-05-21T15:52:19+08:00",
    "Grain in Ear": "1928-06-06T07:17:09+08:00",
    "Summer Solstice": "1928-06-22T00:06:23+08:00",
    "Minor Heat": "1928-07-07T17:44:15+08:00",
    "Major Heat": "1928-07-23T11:02:13+08:00",
    "Start of Autumn": "1928-08-08T03:27:30+08:00",
    "End of Heat": "1928-08-23T17:53:05+08:00",
    "White Dew": "1928-09-08T06:01:45+08:00",
    "Autumn Equinox": "1928-09-23T15:05:26+08:00",
    "Cold Dew": "1928-10-08T21:09:51+08:00",
    "Frost's Descent": "1928-10-23T23:54:28+08:00",
    "Start of Winter": "1928-11-07T23:49:30+08:00",
    "Minor Snow": "1928-11-22T21:00:12+08:00",
    "Major Snow": "1928-12-07T16:17:16+08:00",
    "Winter Solstice": "1928-12-22T10:03:36+08:00",
    "Minor Cold": "1929-01-06T03:22:01+08:00",
    "Major Cold": "1929-01-20T20:42:10+08:00"
  },
  
  // 1929
  1929: {
    "Start of Spring": "1929-02-04T15:08:43+08:00",
    "Rain Water": "1929-02-19T11:06:48+08:00",
    "Awakening of Insects": "1929-03-06T09:31:57+08:00",
    "Spring Equinox": "1929-03-21T10:34:45+08:00",
    "Pure Brightness": "1929-04-05T14:51:13+08:00",
    "Grain Rain": "1929-04-20T22:10:15+08:00",
    "Start of Summer": "1929-05-06T08:40:20+08:00",
    "Grain Buds": "1929-05-21T21:47:33+08:00",
    "Grain in Ear": "1929-06-06T13:10:47+08:00",
    "Summer Solstice": "1929-06-22T06:00:33+08:00",
    "Minor Heat": "1929-07-07T23:31:38+08:00",
    "Major Heat": "1929-07-23T16:53:14+08:00",
    "Start of Autumn": "1929-08-08T09:08:41+08:00",
    "End of Heat": "1929-08-23T23:41:12+08:00",
    "White Dew": "1929-09-08T11:39:34+08:00",
    "Autumn Equinox": "1929-09-23T20:52:15+08:00",
    "Cold Dew": "1929-10-09T02:47:02+08:00",
    "Frost's Descent": "1929-10-24T05:41:24+08:00",
    "Start of Winter": "1929-11-08T05:27:27+08:00",
    "Minor Snow": "1929-11-23T02:48:03+08:00",
    "Major Snow": "1929-12-07T21:56:24+08:00",
    "Winter Solstice": "1929-12-22T15:52:41+08:00",
    "Minor Cold": "1930-01-06T09:02:32+08:00",
    "Major Cold": "1930-01-21T02:32:56+08:00"
  },
  
  // 1930
  1930: {
    "Start of Spring": "1930-02-04T20:51:07+08:00",
    "Rain Water": "1930-02-19T16:59:45+08:00",
    "Awakening of Insects": "1930-03-06T15:16:33+08:00",
    "Spring Equinox": "1930-03-21T16:29:42+08:00",
    "Pure Brightness": "1930-04-05T20:37:22+08:00",
    "Grain Rain": "1930-04-21T04:05:45+08:00",
    "Start of Summer": "1930-05-06T14:26:59+08:00",
    "Grain Buds": "1930-05-22T03:41:59+08:00",
    "Grain in Ear": "1930-06-06T18:58:02+08:00",
    "Summer Solstice": "1930-06-22T11:52:45+08:00",
    "Minor Heat": "1930-07-08T05:19:40+08:00",
    "Major Heat": "1930-07-23T22:41:53+08:00",
    "Start of Autumn": "1930-08-08T14:56:58+08:00",
    "End of Heat": "1930-08-24T05:26:17+08:00",
    "White Dew": "1930-09-08T17:28:22+08:00",
    "Autumn Equinox": "1930-09-24T02:35:52+08:00",
    "Cold Dew": "1930-10-09T08:37:28+08:00",
    "Frost's Descent": "1930-10-24T11:25:57+08:00",
    "Start of Winter": "1930-11-08T11:20:12+08:00",
    "Minor Snow": "1930-11-23T08:34:25+08:00",
    "Major Snow": "1930-12-08T03:50:37+08:00",
    "Winter Solstice": "1930-12-22T21:39:29+08:00",
    "Minor Cold": "1931-01-06T14:55:35+08:00",
    "Major Cold": "1931-01-21T08:17:27+08:00"
  },
  
  // 1931
  1931: {
    "Start of Spring": "1931-02-05T02:40:38+08:00",
    "Rain Water": "1931-02-19T22:40:14+08:00",
    "Awakening of Insects": "1931-03-06T21:02:06+08:00",
    "Spring Equinox": "1931-03-21T22:06:14+08:00",
    "Pure Brightness": "1931-04-06T02:20:26+08:00",
    "Grain Rain": "1931-04-21T09:39:45+08:00",
    "Start of Summer": "1931-05-06T20:09:35+08:00",
    "Grain Buds": "1931-05-22T09:15:21+08:00",
    "Grain in Ear": "1931-06-07T00:41:45+08:00",
    "Summer Solstice": "1931-06-22T17:28:00+08:00",
    "Minor Heat": "1931-07-08T11:05:34+08:00",
    "Major Heat": "1931-07-24T04:21:20+08:00",
    "Start of Autumn": "1931-08-08T20:44:52+08:00",
    "End of Heat": "1931-08-24T11:10:13+08:00",
    "White Dew": "1931-09-08T23:17:15+08:00",
    "Autumn Equinox": "1931-09-24T08:23:15+08:00",
    "Cold Dew": "1931-10-09T14:26:51+08:00",
    "Frost's Descent": "1931-10-24T17:15:26+08:00",
    "Start of Winter": "1931-11-08T17:09:51+08:00",
    "Minor Snow": "1931-11-23T14:24:38+08:00",
    "Major Snow": "1931-12-08T09:40:15+08:00",
    "Winter Solstice": "1931-12-23T03:29:31+08:00",
    "Minor Cold": "1932-01-06T20:45:03+08:00",
    "Major Cold": "1932-01-21T14:06:45+08:00"
  },
  
  // 1932
  1932: {
    "Start of Spring": "1932-02-05T08:29:20+08:00",
    "Rain Water": "1932-02-20T04:28:19+08:00",
    "Awakening of Insects": "1932-03-06T02:49:19+08:00",
    "Spring Equinox": "1932-03-21T03:53:32+08:00",
    "Pure Brightness": "1932-04-05T08:06:19+08:00",
    "Grain Rain": "1932-04-20T15:28:01+08:00",
    "Start of Summer": "1932-05-06T01:55:08+08:00",
    "Grain Buds": "1932-05-21T15:06:33+08:00",
    "Grain in Ear": "1932-06-06T06:27:43+08:00",
    "Summer Solstice": "1932-06-21T23:22:34+08:00",
    "Minor Heat": "1932-07-07T16:52:15+08:00",
    "Major Heat": "1932-07-23T10:17:59+08:00",
    "Start of Autumn": "1932-08-08T02:31:48+08:00",
    "End of Heat": "1932-08-23T17:06:10+08:00",
    "White Dew": "1932-09-08T05:02:52+08:00",
    "Autumn Equinox": "1932-09-23T14:15:49+08:00",
    "Cold Dew": "1932-10-08T20:09:38+08:00",
    "Frost's Descent": "1932-10-23T23:03:50+08:00",
    "Start of Winter": "1932-11-07T22:49:40+08:00",
    "Minor Snow": "1932-11-22T20:10:05+08:00",
    "Major Snow": "1932-12-07T15:18:22+08:00",
    "Winter Solstice": "1932-12-22T09:14:12+08:00",
    "Minor Cold": "1933-01-06T02:23:20+08:00",
    "Major Cold": "1933-01-20T19:52:39+08:00"
  },
  
  // 1933
  1933: {
    "Start of Spring": "1933-02-04T14:09:16+08:00",
    "Rain Water": "1933-02-19T10:16:15+08:00",
    "Awakening of Insects": "1933-03-06T08:31:24+08:00",
    "Spring Equinox": "1933-03-21T09:43:03+08:00",
    "Pure Brightness": "1933-04-05T13:50:29+08:00",
    "Grain Rain": "1933-04-20T21:18:14+08:00",
    "Start of Summer": "1933-05-06T07:41:45+08:00",
    "Grain Buds": "1933-05-21T20:56:45+08:00",
    "Grain in Ear": "1933-06-06T12:17:19+08:00",
    "Summer Solstice": "1933-06-22T05:11:45+08:00",
    "Minor Heat": "1933-07-07T22:44:17+08:00",
    "Major Heat": "1933-07-23T16:05:22+08:00",
    "Start of Autumn": "1933-08-08T08:25:30+08:00",
    "End of Heat": "1933-08-23T22:52:19+08:00",
    "White Dew": "1933-09-08T10:57:26+08:00",
    "Autumn Equinox": "1933-09-23T20:01:06+08:00",
    "Cold Dew": "1933-10-09T02:03:53+08:00",
    "Frost's Descent": "1933-10-24T04:48:03+08:00",
    "Start of Winter": "1933-11-08T04:42:58+08:00",
    "Minor Snow": "1933-11-23T01:53:24+08:00",
    "Major Snow": "1933-12-07T21:11:05+08:00",
    "Winter Solstice": "1933-12-22T14:57:26+08:00",
    "Minor Cold": "1934-01-06T08:16:27+08:00",
    "Major Cold": "1934-01-21T01:36:51+08:00"
  },
  
  // 1934
  1934: {
    "Start of Spring": "1934-02-04T20:03:37+08:00",
    "Rain Water": "1934-02-19T16:01:37+08:00",
    "Awakening of Insects": "1934-03-06T14:26:20+08:00",
    "Spring Equinox": "1934-03-21T15:27:53+08:00",
    "Pure Brightness": "1934-04-05T19:43:39+08:00",
    "Grain Rain": "1934-04-21T03:00:07+08:00",
    "Start of Summer": "1934-05-06T13:30:44+08:00",
    "Grain Buds": "1934-05-22T02:34:51+08:00",
    "Grain in Ear": "1934-06-06T18:01:21+08:00",
    "Summer Solstice": "1934-06-22T10:47:51+08:00",
    "Minor Heat": "1934-07-08T04:24:25+08:00",
    "Major Heat": "1934-07-23T21:42:07+08:00",
    "Start of Autumn": "1934-08-08T14:03:38+08:00",
    "End of Heat": "1934-08-24T04:32:00+08:00",
    "White Dew": "1934-09-08T16:36:08+08:00",
    "Autumn Equinox": "1934-09-24T01:45:08+08:00",
    "Cold Dew": "1934-10-09T07:44:59+08:00",
    "Frost's Descent": "1934-10-24T10:36:15+08:00",
    "Start of Winter": "1934-11-08T10:26:41+08:00",
    "Minor Snow": "1934-11-23T07:44:20+08:00",
    "Major Snow": "1934-12-08T02:56:31+08:00",
    "Winter Solstice": "1934-12-22T20:49:22+08:00",
    "Minor Cold": "1935-01-06T14:02:19+08:00",
    "Major Cold": "1935-01-21T07:28:17+08:00"
  },
  
  // 1935
  1935: {
    "Start of Spring": "1935-02-05T01:48:41+08:00",
    "Rain Water": "1935-02-19T21:51:56+08:00",
    "Awakening of Insects": "1935-03-06T20:10:10+08:00",
    "Spring Equinox": "1935-03-21T21:17:43+08:00",
    "Pure Brightness": "1935-04-06T01:26:21+08:00",
    "Grain Rain": "1935-04-21T08:50:04+08:00",
    "Start of Summer": "1935-05-06T19:12:02+08:00",
    "Grain Buds": "1935-05-22T08:24:47+08:00",
    "Grain in Ear": "1935-06-06T23:41:35+08:00",
    "Summer Solstice": "1935-06-22T16:37:51+08:00",
    "Minor Heat": "1935-07-08T10:05:32+08:00",
    "Major Heat": "1935-07-24T03:32:54+08:00",
    "Start of Autumn": "1935-08-08T19:47:48+08:00",
    "End of Heat": "1935-08-24T10:23:56+08:00",
    "White Dew": "1935-09-08T22:24:04+08:00",
    "Autumn Equinox": "1935-09-24T07:38:07+08:00",
    "Cold Dew": "1935-10-09T13:35:40+08:00",
    "Frost's Descent": "1935-10-24T16:29:09+08:00",
    "Start of Winter": "1935-11-08T16:17:31+08:00",
    "Minor Snow": "1935-11-23T13:35:22+08:00",
    "Major Snow": "1935-12-08T08:44:50+08:00",
    "Winter Solstice": "1935-12-23T02:37:03+08:00",
    "Minor Cold": "1936-01-06T19:46:37+08:00",
    "Major Cold": "1936-01-21T13:12:13+08:00"
  },
  
  // 1936
  1936: {
    "Start of Spring": "1936-02-05T07:29:16+08:00",
    "Rain Water": "1936-02-20T03:33:00+08:00",
    "Awakening of Insects": "1936-03-06T01:49:06+08:00",
    "Spring Equinox": "1936-03-21T02:57:48+08:00",
    "Pure Brightness": "1936-04-05T07:06:44+08:00",
    "Grain Rain": "1936-04-20T14:31:04+08:00",
    "Start of Summer": "1936-05-06T00:56:30+08:00",
    "Grain Buds": "1936-05-21T14:07:24+08:00",
    "Grain in Ear": "1936-06-06T05:30:40+08:00",
    "Summer Solstice": "1936-06-21T22:21:34+08:00",
    "Minor Heat": "1936-07-07T15:58:18+08:00",
    "Major Heat": "1936-07-23T09:17:50+08:00",
    "Start of Autumn": "1936-08-08T01:43:10+08:00",
    "End of Heat": "1936-08-23T16:10:28+08:00",
    "White Dew": "1936-09-08T04:20:35+08:00",
    "Autumn Equinox": "1936-09-23T13:25:54+08:00",
    "Cold Dew": "1936-10-08T19:32:25+08:00",
    "Frost's Descent": "1936-10-23T22:18:02+08:00",
    "Start of Winter": "1936-11-07T22:14:38+08:00",
    "Minor Snow": "1936-11-22T19:25:00+08:00",
    "Major Snow": "1936-12-07T14:42:13+08:00",
    "Winter Solstice": "1936-12-22T08:26:37+08:00",
    "Minor Cold": "1937-01-06T01:43:44+08:00",
    "Major Cold": "1937-01-20T19:00:57+08:00",
  },
  
  // 1937
  1937: {
    "Start of Spring": "1937-02-04T13:25:33+08:00",
    "Rain Water": "1937-02-19T09:20:41+08:00",
    "Awakening of Insects": "1937-03-06T07:44:24+08:00",
    "Spring Equinox": "1937-03-21T08:45:01+08:00",
    "Pure Brightness": "1937-04-05T13:01:22+08:00",
    "Grain Rain": "1937-04-20T20:19:08+08:00",
    "Start of Summer": "1937-05-06T06:50:35+08:00",
    "Grain Buds": "1937-05-21T19:57:07+08:00",
    "Grain in Ear": "1937-06-06T11:22:48+08:00",
    "Summer Solstice": "1937-06-22T04:11:56+08:00",
    "Minor Heat": "1937-07-07T21:45:55+08:00",
    "Major Heat": "1937-07-23T15:06:53+08:00",
    "Start of Autumn": "1937-08-08T07:25:20+08:00",
    "End of Heat": "1937-08-23T21:57:49+08:00",
    "White Dew": "1937-09-08T09:59:23+08:00",
    "Autumn Equinox": "1937-09-23T19:12:54+08:00",
    "Cold Dew": "1937-10-09T01:10:54+08:00",
    "Frost's Descent": "1937-10-24T04:06:30+08:00",
    "Start of Winter": "1937-11-08T03:55:15+08:00",
    "Minor Snow": "1937-11-23T01:16:27+08:00",
    "Major Snow": "1937-12-07T20:26:16+08:00",
    "Winter Solstice": "1937-12-22T14:21:36+08:00",
    "Minor Cold": "1938-01-06T07:31:08+08:00",
    "Major Cold": "1938-01-21T00:58:42+08:00"
  },
  
  // 1938
  1938: {
    "Start of Spring": "1938-02-04T19:14:58+08:00",
    "Rain Water": "1938-02-19T15:19:33+08:00",
    "Awakening of Insects": "1938-03-06T13:33:46+08:00",
    "Spring Equinox": "1938-03-21T14:43:02+08:00",
    "Pure Brightness": "1938-04-05T18:48:39+08:00",
    "Grain Rain": "1938-04-21T02:14:41+08:00",
    "Start of Summer": "1938-05-06T12:35:09+08:00",
    "Grain Buds": "1938-05-22T01:50:08+08:00",
    "Grain in Ear": "1938-06-06T17:06:37+08:00",
    "Summer Solstice": "1938-06-22T10:03:32+08:00",
    "Minor Heat": "1938-07-08T03:31:21+08:00",
    "Major Heat": "1938-07-23T20:57:02+08:00",
    "Start of Autumn": "1938-08-08T13:12:41+08:00",
    "End of Heat": "1938-08-24T03:45:46+08:00",
    "White Dew": "1938-09-08T15:48:08+08:00",
    "Autumn Equinox": "1938-09-24T00:59:27+08:00",
    "Cold Dew": "1938-10-09T07:01:24+08:00",
    "Frost's Descent": "1938-10-24T09:53:44+08:00",
    "Start of Winter": "1938-11-08T09:48:19+08:00",
    "Minor Snow": "1938-11-23T07:06:02+08:00",
    "Major Snow": "1938-12-08T02:21:58+08:00",
    "Winter Solstice": "1938-12-22T20:13:21+08:00",
    "Minor Cold": "1939-01-06T13:27:51+08:00",
    "Major Cold": "1939-01-21T06:50:40+08:00"
  },
  
  // 1939
  1939: {
    "Start of Spring": "1939-02-05T01:10:26+08:00",
    "Rain Water": "1939-02-19T21:09:15+08:00",
    "Awakening of Insects": "1939-03-06T19:26:11+08:00",
    "Spring Equinox": "1939-03-21T20:28:26+08:00",
    "Pure Brightness": "1939-04-06T00:37:24+08:00",
    "Grain Rain": "1939-04-21T07:55:05+08:00",
    "Start of Summer": "1939-05-06T18:21:02+08:00",
    "Grain Buds": "1939-05-22T07:26:38+08:00",
    "Grain in Ear": "1939-06-06T22:51:38+08:00",
    "Summer Solstice": "1939-06-22T15:39:22+08:00",
    "Minor Heat": "1939-07-08T09:18:20+08:00",
    "Major Heat": "1939-07-24T02:36:36+08:00",
    "Start of Autumn": "1939-08-08T19:03:27+08:00",
    "End of Heat": "1939-08-24T09:31:08+08:00",
    "White Dew": "1939-09-08T21:42:01+08:00",
    "Autumn Equinox": "1939-09-24T06:49:25+08:00",
    "Cold Dew": "1939-10-09T12:56:36+08:00",
    "Frost's Descent": "1939-10-24T15:45:49+08:00",
    "Start of Winter": "1939-11-08T15:43:30+08:00",
    "Minor Snow": "1939-11-23T12:58:28+08:00",
    "Major Snow": "1939-12-08T08:17:00+08:00",
    "Winter Solstice": "1939-12-23T02:05:55+08:00",
    "Minor Cold": "1940-01-06T19:23:40+08:00",
    "Major Cold": "1940-01-21T12:44:03+08:00"
  },
  
  // 1940
  1940: {
    "Start of Spring": "1940-02-05T07:07:32+08:00",
    "Rain Water": "1940-02-20T03:03:42+08:00",
    "Awakening of Insects": "1940-03-06T01:23:58+08:00",
    "Spring Equinox": "1940-03-21T02:23:41+08:00",
    "Pure Brightness": "1940-04-05T06:34:34+08:00",
    "Grain Rain": "1940-04-20T13:50:52+08:00",
    "Start of Summer": "1940-05-06T00:16:16+08:00",
    "Grain Buds": "1940-05-21T13:23:00+08:00",
    "Grain in Ear": "1940-06-06T04:44:02+08:00",
    "Summer Solstice": "1940-06-21T21:36:22+08:00",
    "Minor Heat": "1940-07-07T15:08:01+08:00",
    "Major Heat": "1940-07-23T08:34:03+08:00",
    "Start of Autumn": "1940-08-08T00:51:29+08:00",
    "End of Heat": "1940-08-23T15:28:30+08:00",
    "White Dew": "1940-09-08T03:29:14+08:00",
    "Autumn Equinox": "1940-09-23T12:45:32+08:00",
    "Cold Dew": "1940-10-08T18:42:23+08:00",
    "Frost's Descent": "1940-10-23T21:39:18+08:00",
    "Start of Winter": "1940-11-07T21:26:46+08:00",
    "Minor Snow": "1940-11-22T18:48:55+08:00",
    "Major Snow": "1940-12-07T13:57:51+08:00",
    "Winter Solstice": "1940-12-22T07:54:41+08:00",
    "Minor Cold": "1941-01-06T01:03:54+08:00",
    "Major Cold": "1941-01-20T18:33:37+08:00"
  },
  
  // 1941
  1941: {
    "Start of Spring": "1941-02-04T12:49:44+08:00",
    "Rain Water": "1941-02-19T08:56:21+08:00",
    "Awakening of Insects": "1941-03-06T07:10:04+08:00",
    "Spring Equinox": "1941-03-21T08:20:19+08:00",
    "Pure Brightness": "1941-04-05T12:24:55+08:00",
    "Grain Rain": "1941-04-20T19:50:24+08:00",
    "Start of Summer": "1941-05-06T06:09:50+08:00",
    "Grain Buds": "1941-05-21T19:22:47+08:00",
    "Grain in Ear": "1941-06-06T10:39:12+08:00",
    "Summer Solstice": "1941-06-22T03:33:15+08:00",
    "Minor Heat": "1941-07-07T21:03:04+08:00",
    "Major Heat": "1941-07-23T14:26:08+08:00",
    "Start of Autumn": "1941-08-08T06:45:52+08:00",
    "End of Heat": "1941-08-23T21:16:51+08:00",
    "White Dew": "1941-09-08T09:23:48+08:00",
    "Autumn Equinox": "1941-09-23T18:32:42+08:00",
    "Cold Dew": "1941-10-09T00:38:12+08:00",
    "Frost's Descent": "1941-10-24T03:27:09+08:00",
    "Start of Winter": "1941-11-08T03:24:03+08:00",
    "Minor Snow": "1941-11-23T00:37:47+08:00",
    "Major Snow": "1941-12-07T19:55:58+08:00",
    "Winter Solstice": "1941-12-22T13:44:06+08:00",
    "Minor Cold": "1942-01-06T07:02:18+08:00",
    "Major Cold": "1942-01-21T00:23:28+08:00"
  },
  
  // 1942
  1942: {
    "Start of Spring": "1942-02-04T18:48:34+08:00",
    "Rain Water": "1942-02-19T14:46:46+08:00",
    "Awakening of Insects": "1942-03-06T13:09:20+08:00",
    "Spring Equinox": "1942-03-21T14:10:34+08:00",
    "Pure Brightness": "1942-04-05T18:23:50+08:00",
    "Grain Rain": "1942-04-21T01:39:05+08:00",
    "Start of Summer": "1942-05-06T12:06:50+08:00",
    "Grain Buds": "1942-05-22T01:08:38+08:00",
    "Grain in Ear": "1942-06-06T16:32:31+08:00",
    "Summer Solstice": "1942-06-22T09:16:13+08:00",
    "Minor Heat": "1942-07-08T02:51:46+08:00",
    "Major Heat": "1942-07-23T20:07:23+08:00",
    "Start of Autumn": "1942-08-08T12:30:18+08:00",
    "End of Heat": "1942-08-24T02:58:10+08:00",
    "White Dew": "1942-09-08T15:06:07+08:00",
    "Autumn Equinox": "1942-09-24T00:16:24+08:00",
    "Cold Dew": "1942-10-09T06:21:42+08:00",
    "Frost's Descent": "1942-10-24T09:15:08+08:00",
    "Start of Winter": "1942-11-08T09:11:07+08:00",
    "Minor Snow": "1942-11-23T06:30:21+08:00",
    "Major Snow": "1942-12-08T01:46:47+08:00",
    "Winter Solstice": "1942-12-22T19:39:31+08:00",
    "Minor Cold": "1943-01-06T12:54:50+08:00",
    "Major Cold": "1943-01-21T06:18:52+08:00"
  },
  
  // 1943
  1943: {
    "Start of Spring": "1943-02-05T00:40:04+08:00",
    "Rain Water": "1943-02-19T20:40:13+08:00",
    "Awakening of Insects": "1943-03-06T18:58:30+08:00",
    "Spring Equinox": "1943-03-21T20:02:34+08:00",
    "Pure Brightness": "1943-04-06T00:11:10+08:00",
    "Grain Rain": "1943-04-21T07:31:29+08:00",
    "Start of Summer": "1943-05-06T17:53:21+08:00",
    "Grain Buds": "1943-05-22T07:02:49+08:00",
    "Grain in Ear": "1943-06-06T22:18:57+08:00",
    "Summer Solstice": "1943-06-22T15:12:17+08:00",
    "Minor Heat": "1943-07-08T08:38:50+08:00",
    "Major Heat": "1943-07-24T02:04:30+08:00",
    "Start of Autumn": "1943-08-08T18:18:30+08:00",
    "End of Heat": "1943-08-24T08:54:59+08:00",
    "White Dew": "1943-09-08T20:55:08+08:00",
    "Autumn Equinox": "1943-09-24T06:11:41+08:00",
    "Cold Dew": "1943-10-09T12:10:29+08:00",
    "Frost's Descent": "1943-10-24T15:08:15+08:00",
    "Start of Winter": "1943-11-08T14:58:43+08:00",
    "Minor Snow": "1943-11-23T12:21:26+08:00",
    "Major Snow": "1943-12-08T07:32:50+08:00",
    "Winter Solstice": "1943-12-23T01:29:04+08:00",
    "Minor Cold": "1944-01-06T18:39:15+08:00",
    "Major Cold": "1944-01-21T12:07:04+08:00"
  },
  
  // 1944
  1944: {
    "Start of Spring": "1944-02-05T06:22:55+08:00",
    "Rain Water": "1944-02-20T02:27:05+08:00",
    "Awakening of Insects": "1944-03-06T00:40:26+08:00",
    "Spring Equinox": "1944-03-21T01:48:32+08:00",
    "Pure Brightness": "1944-04-05T05:53:58+08:00",
    "Grain Rain": "1944-04-20T13:17:45+08:00",
    "Start of Summer": "1944-05-05T23:39:43+08:00",
    "Grain Buds": "1944-05-21T12:50:46+08:00",
    "Grain in Ear": "1944-06-06T04:10:53+08:00",
    "Summer Solstice": "1944-06-21T21:02:14+08:00",
    "Minor Heat": "1944-07-07T14:36:02+08:00",
    "Major Heat": "1944-07-23T07:55:49+08:00",
    "Start of Autumn": "1944-08-08T00:18:51+08:00",
    "End of Heat": "1944-08-23T14:46:26+08:00",
    "White Dew": "1944-09-08T02:55:32+08:00",
    "Autumn Equinox": "1944-09-23T12:01:35+08:00",
    "Cold Dew": "1944-10-08T18:08:43+08:00",
    "Frost's Descent": "1944-10-23T20:55:56+08:00",
    "Start of Winter": "1944-11-07T20:54:39+08:00",
    "Minor Snow": "1944-11-22T18:07:30+08:00",
    "Major Snow": "1944-12-07T13:27:38+08:00",
    "Winter Solstice": "1944-12-22T07:14:45+08:00",
    "Minor Cold": "1945-01-06T00:34:26+08:00",
    "Major Cold": "1945-01-20T17:53:36+08:00"
  },
  
  // 1945
  1945: {
    "Start of Spring": "1945-02-04T12:19:22+08:00",
    "Rain Water": "1945-02-19T08:14:51+08:00",
    "Awakening of Insects": "1945-03-06T06:37:59+08:00",
    "Spring Equinox": "1945-03-21T07:37:10+08:00",
    "Pure Brightness": "1945-04-05T11:51:46+08:00",
    "Grain Rain": "1945-04-20T19:06:51+08:00",
    "Start of Summer": "1945-05-06T05:36:35+08:00",
    "Grain Buds": "1945-05-21T18:40:12+08:00",
    "Grain in Ear": "1945-06-06T10:05:24+08:00",
    "Summer Solstice": "1945-06-22T02:52:00+08:00",
    "Minor Heat": "1945-07-07T20:26:46+08:00",
    "Major Heat": "1945-07-23T13:45:23+08:00",
    "Start of Autumn": "1945-08-08T06:05:03+08:00",
    "End of Heat": "1945-08-23T20:35:16+08:00",
    "White Dew": "1945-09-08T08:38:07+08:00",
    "Autumn Equinox": "1945-09-23T17:49:44+08:00",
    "Cold Dew": "1945-10-08T23:49:07+08:00",
    "Frost's Descent": "1945-10-24T02:43:34+08:00",
    "Start of Winter": "1945-11-08T02:34:11+08:00",
    "Minor Snow": "1945-11-22T23:55:11+08:00",
    "Major Snow": "1945-12-07T19:07:39+08:00",
    "Winter Solstice": "1945-12-22T13:03:32+08:00",
    "Minor Cold": "1946-01-06T06:16:19+08:00",
    "Major Cold": "1946-01-20T23:44:35+08:00"
  },
  
  // 1946
  1946: {
    "Start of Spring": "1946-02-04T18:03:53+08:00",
    "Rain Water": "1946-02-19T14:08:30+08:00",
    "Awakening of Insects": "1946-03-06T12:24:38+08:00",
    "Spring Equinox": "1946-03-21T13:32:37+08:00",
    "Pure Brightness": "1946-04-05T17:38:32+08:00",
    "Grain Rain": "1946-04-21T01:02:08+08:00",
    "Start of Summer": "1946-05-06T11:21:29+08:00",
    "Grain Buds": "1946-05-22T00:33:53+08:00",
    "Grain in Ear": "1946-06-06T15:48:42+08:00",
    "Summer Solstice": "1946-06-22T08:44:17+08:00",
    "Minor Heat": "1946-07-08T02:10:48+08:00",
    "Major Heat": "1946-07-23T19:37:00+08:00",
    "Start of Autumn": "1946-08-08T11:51:35+08:00",
    "End of Heat": "1946-08-24T02:26:19+08:00",
    "White Dew": "1946-09-08T14:27:25+08:00",
    "Autumn Equinox": "1946-09-23T23:40:34+08:00",
    "Cold Dew": "1946-10-09T05:40:47+08:00",
    "Frost's Descent": "1946-10-24T08:34:39+08:00",
    "Start of Winter": "1946-11-08T08:27:09+08:00",
    "Minor Snow": "1946-11-23T05:46:15+08:00",
    "Major Snow": "1946-12-08T01:00:11+08:00",
    "Winter Solstice": "1946-12-22T18:53:17+08:00",
    "Minor Cold": "1947-01-06T12:06:20+08:00",
    "Major Cold": "1947-01-21T05:31:30+08:00"
  },
  
  // 1947
  1947: {
    "Start of Spring": "1947-02-04T23:50:21+08:00",
    "Rain Water": "1947-02-19T19:51:53+08:00",
    "Awakening of Insects": "1947-03-06T18:07:56+08:00",
    "Spring Equinox": "1947-03-21T19:12:38+08:00",
    "Pure Brightness": "1947-04-05T23:20:08+08:00",
    "Grain Rain": "1947-04-21T06:39:22+08:00",
    "Start of Summer": "1947-05-06T17:02:57+08:00",
    "Grain Buds": "1947-05-22T06:09:00+08:00",
    "Grain in Ear": "1947-06-06T21:31:12+08:00",
    "Summer Solstice": "1947-06-22T14:18:47+08:00",
    "Minor Heat": "1947-07-08T07:55:48+08:00",
    "Major Heat": "1947-07-24T01:14:09+08:00",
    "Start of Autumn": "1947-08-08T17:40:51+08:00",
    "End of Heat": "1947-08-24T08:08:56+08:00",
    "White Dew": "1947-09-08T20:21:03+08:00",
    "Autumn Equinox": "1947-09-24T05:28:35+08:00",
    "Cold Dew": "1947-10-09T11:37:17+08:00",
    "Frost's Descent": "1947-10-24T14:25:50+08:00",
    "Start of Winter": "1947-11-08T14:24:22+08:00",
    "Minor Snow": "1947-11-23T11:37:36+08:00",
    "Major Snow": "1947-12-08T06:56:11+08:00",
    "Winter Solstice": "1947-12-23T00:42:43+08:00",
    "Minor Cold": "1948-01-06T18:00:13+08:00",
    "Major Cold": "1948-01-21T11:18:22+08:00"
  },
  
  // 1948
  1948: {
    "Start of Spring": "1948-02-05T05:42:00+08:00",
    "Rain Water": "1948-02-20T01:36:38+08:00",
    "Awakening of Insects": "1948-03-05T23:57:53+08:00",
    "Spring Equinox": "1948-03-21T00:56:43+08:00",
    "Pure Brightness": "1948-04-05T05:09:20+08:00",
    "Grain Rain": "1948-04-20T12:24:50+08:00",
    "Start of Summer": "1948-05-05T22:52:13+08:00",
    "Grain Buds": "1948-05-21T11:57:35+08:00",
    "Grain in Ear": "1948-06-06T03:20:19+08:00",
    "Summer Solstice": "1948-06-21T20:10:32+08:00",
    "Minor Heat": "1948-07-07T13:43:28+08:00",
    "Major Heat": "1948-07-23T07:07:29+08:00",
    "Start of Autumn": "1948-08-07T23:26:17+08:00",
    "End of Heat": "1948-08-23T14:02:30+08:00",
    "White Dew": "1948-09-08T02:04:59+08:00",
    "Autumn Equinox": "1948-09-23T11:21:39+08:00",
    "Cold Dew": "1948-10-08T17:20:16+08:00",
    "Frost's Descent": "1948-10-23T20:17:57+08:00",
    "Start of Winter": "1948-11-07T20:06:32+08:00",
    "Minor Snow": "1948-11-22T17:28:47+08:00",
    "Major Snow": "1948-12-07T12:37:37+08:00",
    "Winter Solstice": "1948-12-22T06:33:13+08:00",
    "Minor Cold": "1949-01-05T23:41:08+08:00",
    "Major Cold": "1949-01-20T17:08:32+08:00"
  },
  
  // 1949
  1949: {
    "Start of Spring": "1949-02-04T11:22:49+08:00",
    "Rain Water": "1949-02-19T07:27:03+08:00",
    "Awakening of Insects": "1949-03-06T05:39:16+08:00",
    "Spring Equinox": "1949-03-21T06:48:01+08:00",
    "Pure Brightness": "1949-04-05T10:51:56+08:00",
    "Grain Rain": "1949-04-20T18:17:15+08:00",
    "Start of Summer": "1949-05-06T04:36:34+08:00",
    "Grain Buds": "1949-05-21T17:50:38+08:00",
    "Grain in Ear": "1949-06-06T09:06:49+08:00",
    "Summer Solstice": "1949-06-22T02:02:43+08:00",
    "Minor Heat": "1949-07-07T19:31:35+08:00",
    "Major Heat": "1949-07-23T12:56:39+08:00",
    "Start of Autumn": "1949-08-08T05:14:56+08:00",
    "End of Heat": "1949-08-23T19:48:11+08:00",
    "White Dew": "1949-09-08T07:54:09+08:00",
    "Autumn Equinox": "1949-09-23T17:05:48+08:00",
    "Cold Dew": "1949-10-08T23:11:02+08:00",
    "Frost's Descent": "1949-10-24T02:02:57+08:00",
    "Start of Winter": "1949-11-08T01:59:46+08:00",
    "Minor Snow": "1949-11-22T23:16:02+08:00",
    "Major Snow": "1949-12-07T18:33:24+08:00",
    "Winter Solstice": "1949-12-22T12:22:51+08:00",
    "Minor Cold": "1950-01-06T05:38:43+08:00",
    "Major Cold": "1950-01-20T22:59:35+08:00"
  },
  
  // 1950
  1950: {
    "Start of Spring": "1950-02-04T17:20:46+08:00",
    "Rain Water": "1950-02-19T13:17:29+08:00",
    "Awakening of Insects": "1950-03-06T11:35:26+08:00",
    "Spring Equinox": "1950-03-21T12:35:06+08:00",
    "Pure Brightness": "1950-04-05T16:44:27+08:00",
    "Grain Rain": "1950-04-20T23:59:06+08:00",
    "Start of Summer": "1950-05-06T10:24:41+08:00",
    "Grain Buds": "1950-05-21T23:27:07+08:00",
    "Grain in Ear": "1950-06-06T14:51:00+08:00",
    "Summer Solstice": "1950-06-22T07:36:00+08:00",
    "Minor Heat": "1950-07-08T01:13:17+08:00",
    "Major Heat": "1950-07-23T18:29:53+08:00",
    "Start of Autumn": "1950-08-08T10:55:11+08:00",
    "End of Heat": "1950-08-24T01:23:09+08:00",
    "White Dew": "1950-09-08T13:33:39+08:00",
    "Autumn Equinox": "1950-09-23T22:43:32+08:00",
    "Cold Dew": "1950-10-09T04:51:39+08:00",
    "Frost's Descent": "1950-10-24T07:44:43+08:00",
    "Start of Winter": "1950-11-08T07:43:43+08:00",
    "Minor Snow": "1950-11-23T05:02:29+08:00",
    "Major Snow": "1950-12-08T00:21:40+08:00",
    "Winter Solstice": "1950-12-22T18:13:18+08:00",
    "Minor Cold": "1951-01-06T11:30:22+08:00",
    "Major Cold": "1951-01-21T04:52:02+08:00"
  },
  
  // 1951
  1951: {
    "Start of Spring": "1951-02-04T23:13:26+08:00",
    "Rain Water": "1951-02-19T19:09:38+08:00",
    "Awakening of Insects": "1951-03-06T17:26:40+08:00",
    "Spring Equinox": "1951-03-21T18:25:41+08:00",
    "Pure Brightness": "1951-04-05T22:32:38+08:00",
    "Grain Rain": "1951-04-21T05:48:03+08:00",
    "Start of Summer": "1951-05-06T16:09:15+08:00",
    "Grain Buds": "1951-05-22T05:15:22+08:00",
    "Grain in Ear": "1951-06-06T20:32:32+08:00",
    "Summer Solstice": "1951-06-22T13:24:48+08:00",
    "Minor Heat": "1951-07-08T06:53:51+08:00",
    "Major Heat": "1951-07-24T00:20:37+08:00",
    "Start of Autumn": "1951-08-08T16:37:26+08:00",
    "End of Heat": "1951-08-24T07:16:05+08:00",
    "White Dew": "1951-09-08T19:18:10+08:00",
    "Autumn Equinox": "1951-09-24T04:36:50+08:00",
    "Cold Dew": "1951-10-09T10:36:23+08:00",
    "Frost's Descent": "1951-10-24T13:36:00+08:00",
    "Start of Winter": "1951-11-08T13:26:36+08:00",
    "Minor Snow": "1951-11-23T10:51:03+08:00",
    "Major Snow": "1951-12-08T06:02:18+08:00",
    "Winter Solstice": "1951-12-23T00:00:01+08:00",
    "Minor Cold": "1952-01-06T17:09:45+08:00",
    "Major Cold": "1952-01-21T10:38:22+08:00"
  },
  
  // 1952
  1952: {
    "Start of Spring": "1952-02-05T04:52:54+08:00",
    "Rain Water": "1952-02-20T00:56:40+08:00",
    "Awakening of Insects": "1952-03-05T23:07:18+08:00",
    "Spring Equinox": "1952-03-21T00:13:42+08:00",
    "Pure Brightness": "1952-04-05T04:15:02+08:00",
    "Grain Rain": "1952-04-20T11:36:37+08:00",
    "Start of Summer": "1952-05-05T21:54:01+08:00",
    "Grain Buds": "1952-05-21T11:03:49+08:00",
    "Grain in Ear": "1952-06-06T02:20:18+08:00",
    "Summer Solstice": "1952-06-21T19:12:30+08:00",
    "Minor Heat": "1952-07-07T12:44:38+08:00",
    "Major Heat": "1952-07-23T06:07:25+08:00",
    "Start of Autumn": "1952-08-07T22:30:57+08:00",
    "End of Heat": "1952-08-23T13:02:47+08:00",
    "White Dew": "1952-09-08T01:13:42+08:00",
    "Autumn Equinox": "1952-09-23T10:23:39+08:00",
    "Cold Dew": "1952-10-08T16:32:25+08:00",
    "Frost's Descent": "1952-10-23T19:22:10+08:00",
    "Start of Winter": "1952-11-07T19:21:34+08:00",
    "Minor Snow": "1952-11-22T16:35:36+08:00",
    "Major Snow": "1952-12-07T11:55:33+08:00",
    "Winter Solstice": "1952-12-22T05:43:06+08:00",
    "Minor Cold": "1953-01-05T23:02:02+08:00",
    "Major Cold": "1953-01-20T16:21:18+08:00"
  },
  
  // 1953
  1953: {
    "Start of Spring": "1953-02-04T10:45:53+08:00",
    "Rain Water": "1953-02-19T06:41:05+08:00",
    "Awakening of Insects": "1953-03-06T05:02:26+08:00",
    "Spring Equinox": "1953-03-21T06:00:30+08:00",
    "Pure Brightness": "1953-04-05T10:12:36+08:00",
    "Grain Rain": "1953-04-20T17:25:21+08:00",
    "Start of Summer": "1953-05-06T03:52:18+08:00",
    "Grain Buds": "1953-05-21T16:52:47+08:00",
    "Grain in Ear": "1953-06-06T08:16:04+08:00",
    "Summer Solstice": "1953-06-22T00:59:53+08:00",
    "Minor Heat": "1953-07-07T18:34:54+08:00",
    "Major Heat": "1953-07-23T11:52:06+08:00",
    "Start of Autumn": "1953-08-08T04:14:35+08:00",
    "End of Heat": "1953-08-23T18:45:09+08:00",
    "White Dew": "1953-09-08T06:52:43+08:00",
    "Autumn Equinox": "1953-09-23T16:05:52+08:00",
    "Cold Dew": "1953-10-08T22:10:25+08:00",
    "Frost's Descent": "1953-10-24T01:06:14+08:00",
    "Start of Winter": "1953-11-08T01:00:57+08:00",
    "Minor Snow": "1953-11-22T22:22:03+08:00",
    "Major Snow": "1953-12-07T17:36:59+08:00",
    "Winter Solstice": "1953-12-22T11:31:25+08:00",
    "Minor Cold": "1954-01-06T04:45:17+08:00",
    "Major Cold": "1954-01-20T22:11:01+08:00"
  },
  
  // 1954
  1954: {
    "Start of Spring": "1954-02-04T16:30:41+08:00",
    "Rain Water": "1954-02-19T12:32:18+08:00",
    "Awakening of Insects": "1954-03-06T10:48:32+08:00",
    "Spring Equinox": "1954-03-21T11:53:23+08:00",
    "Pure Brightness": "1954-04-05T15:59:10+08:00",
    "Grain Rain": "1954-04-20T23:19:32+08:00",
    "Start of Summer": "1954-05-06T09:38:10+08:00",
    "Grain Buds": "1954-05-21T22:47:22+08:00",
    "Grain in Ear": "1954-06-06T14:00:49+08:00",
    "Summer Solstice": "1954-06-22T06:54:00+08:00",
    "Minor Heat": "1954-07-08T00:19:10+08:00",
    "Major Heat": "1954-07-23T17:44:54+08:00",
    "Start of Autumn": "1954-08-08T09:59:04+08:00",
    "End of Heat": "1954-08-24T00:35:52+08:00",
    "White Dew": "1954-09-08T12:37:51+08:00",
    "Autumn Equinox": "1954-09-23T21:55:13+08:00",
    "Cold Dew": "1954-10-09T03:57:18+08:00",
    "Frost's Descent": "1954-10-24T06:56:19+08:00",
    "Start of Winter": "1954-11-08T06:50:34+08:00",
    "Minor Snow": "1954-11-23T04:14:10+08:00",
    "Major Snow": "1954-12-07T23:28:29+08:00",
    "Winter Solstice": "1954-12-22T17:24:19+08:00",
    "Minor Cold": "1955-01-06T10:35:52+08:00",
    "Major Cold": "1955-01-21T04:01:50+08:00"
  },
  
  // 1955
  1955: {
    "Start of Spring": "1955-02-04T22:17:36+08:00",
    "Rain Water": "1955-02-19T18:18:45+08:00",
    "Awakening of Insects": "1955-03-06T16:30:57+08:00",
    "Spring Equinox": "1955-03-21T17:35:04+08:00",
    "Pure Brightness": "1955-04-05T21:38:44+08:00",
    "Grain Rain": "1955-04-21T04:57:50+08:00",
    "Start of Summer": "1955-05-06T15:17:58+08:00",
    "Grain Buds": "1955-05-22T04:24:19+08:00",
    "Grain in Ear": "1955-06-06T19:43:25+08:00",
    "Summer Solstice": "1955-06-22T12:31:19+08:00",
    "Minor Heat": "1955-07-08T06:05:52+08:00",
    "Major Heat": "1955-07-23T23:24:30+08:00",
    "Start of Autumn": "1955-08-08T15:50:02+08:00",
    "End of Heat": "1955-08-24T06:18:53+08:00",
    "White Dew": "1955-09-08T18:31:46+08:00",
    "Autumn Equinox": "1955-09-24T03:40:50+08:00",
    "Cold Dew": "1955-10-09T09:52:08+08:00",
    "Frost's Descent": "1955-10-24T12:43:01+08:00",
    "Start of Winter": "1955-11-08T12:45:09+08:00",
    "Minor Snow": "1955-11-23T10:00:51+08:00",
    "Major Snow": "1955-12-08T05:22:46+08:00",
    "Winter Solstice": "1955-12-22T23:10:52+08:00",
    "Minor Cold": "1956-01-06T16:30:17+08:00",
    "Major Cold": "1956-01-21T09:48:16+08:00"
  },
  
  // 1956
  1956: {
    "Start of Spring": "1956-02-05T04:11:55+08:00",
    "Rain Water": "1956-02-20T00:04:37+08:00",
    "Awakening of Insects": "1956-03-05T22:24:27+08:00",
    "Spring Equinox": "1956-03-20T23:20:15+08:00",
    "Pure Brightness": "1956-04-05T03:31:09+08:00",
    "Grain Rain": "1956-04-20T10:43:25+08:00",
    "Start of Summer": "1956-05-05T21:09:58+08:00",
    "Grain Buds": "1956-05-21T10:12:32+08:00",
    "Grain in Ear": "1956-06-06T01:35:47+08:00",
    "Summer Solstice": "1956-06-21T18:23:41+08:00",
    "Minor Heat": "1956-07-07T11:57:59+08:00",
    "Major Heat": "1956-07-23T05:19:52+08:00",
    "Start of Autumn": "1956-08-07T21:40:12+08:00",
    "End of Heat": "1956-08-23T12:14:46+08:00",
    "White Dew": "1956-09-08T00:18:56+08:00",
    "Autumn Equinox": "1956-09-23T09:35:02+08:00",
    "Cold Dew": "1956-10-08T15:35:53+08:00",
    "Frost's Descent": "1956-10-23T18:34:19+08:00",
    "Start of Winter": "1956-11-07T18:25:54+08:00",
    "Minor Snow": "1956-11-22T15:49:50+08:00",
    "Major Snow": "1956-12-07T11:02:06+08:00",
    "Winter Solstice": "1956-12-22T04:59:27+08:00",
    "Minor Cold": "1957-01-05T22:10:25+08:00",
    "Major Cold": "1957-01-20T15:38:35+08:00"
  },
  
  // 1957
  1957: {
    "Start of Spring": "1957-02-04T09:54:37+08:00",
    "Rain Water": "1957-02-19T05:57:58+08:00",
    "Awakening of Insects": "1957-03-06T04:10:07+08:00",
    "Spring Equinox": "1957-03-21T05:16:27+08:00",
    "Pure Brightness": "1957-04-05T09:18:49+08:00",
    "Grain Rain": "1957-04-20T16:41:12+08:00",
    "Start of Summer": "1957-05-06T02:58:22+08:00",
    "Grain Buds": "1957-05-21T16:10:23+08:00",
    "Grain in Ear": "1957-06-06T07:24:43+08:00",
    "Summer Solstice": "1957-06-22T00:20:28+08:00",
    "Minor Heat": "1957-07-07T17:48:09+08:00",
    "Major Heat": "1957-07-23T11:14:48+08:00",
    "Start of Autumn": "1957-08-08T03:32:03+08:00",
    "End of Heat": "1957-08-23T18:07:31+08:00",
    "White Dew": "1957-09-08T06:12:11+08:00",
    "Autumn Equinox": "1957-09-23T15:26:02+08:00",
    "Cold Dew": "1957-10-08T21:29:58+08:00",
    "Frost's Descent": "1957-10-24T00:24:10+08:00",
    "Start of Winter": "1957-11-08T00:20:01+08:00",
    "Minor Snow": "1957-11-22T21:39:00+08:00",
    "Major Snow": "1957-12-07T16:55:56+08:00",
    "Winter Solstice": "1957-12-22T10:48:34+08:00",
    "Minor Cold": "1958-01-06T04:04:20+08:00",
    "Major Cold": "1958-01-20T21:28:27+08:00"
  },
  
  // 1958
  1958: {
    "Start of Spring": "1958-02-04T15:49:11+08:00",
    "Rain Water": "1958-02-19T11:48:26+08:00",
    "Awakening of Insects": "1958-03-06T10:04:52+08:00",
    "Spring Equinox": "1958-03-21T11:05:47+08:00",
    "Pure Brightness": "1958-04-05T15:12:21+08:00",
    "Grain Rain": "1958-04-20T22:26:58+08:00",
    "Start of Summer": "1958-05-06T08:49:10+08:00",
    "Grain Buds": "1958-05-21T21:51:00+08:00",
    "Grain in Ear": "1958-06-06T13:12:11+08:00",
    "Summer Solstice": "1958-06-22T05:56:51+08:00",
    "Minor Heat": "1958-07-07T23:33:25+08:00",
    "Major Heat": "1958-07-23T16:50:26+08:00",
    "Start of Autumn": "1958-08-08T09:17:10+08:00",
    "End of Heat": "1958-08-23T23:45:53+08:00",
    "White Dew": "1958-09-08T11:58:49+08:00",
    "Autumn Equinox": "1958-09-23T21:08:49+08:00",
    "Cold Dew": "1958-10-09T03:19:08+08:00",
    "Frost's Descent": "1958-10-24T06:11:18+08:00",
    "Start of Winter": "1958-11-08T06:11:53+08:00",
    "Minor Snow": "1958-11-23T03:29:06+08:00",
    "Major Snow": "1958-12-07T22:49:35+08:00",
    "Winter Solstice": "1958-12-22T16:39:40+08:00",
    "Minor Cold": "1959-01-06T09:58:18+08:00",
    "Major Cold": "1959-01-21T03:18:50+08:00"
  },
  
  // 1959
  1959: {
    "Start of Spring": "1959-02-04T21:42:10+08:00",
    "Rain Water": "1959-02-19T17:37:33+08:00",
    "Awakening of Insects": "1959-03-06T15:56:35+08:00",
    "Spring Equinox": "1959-03-21T16:54:29+08:00",
    "Pure Brightness": "1959-04-05T21:03:02+08:00",
    "Grain Rain": "1959-04-21T04:16:27+08:00",
    "Start of Summer": "1959-05-06T14:38:42+08:00",
    "Grain Buds": "1959-05-22T03:42:05+08:00",
    "Grain in Ear": "1959-06-06T19:00:03+08:00",
    "Summer Solstice": "1959-06-22T11:49:44+08:00",
    "Minor Heat": "1959-07-08T05:19:52+08:00",
    "Major Heat": "1959-07-23T22:45:25+08:00",
    "Start of Autumn": "1959-08-08T15:04:04+08:00",
    "End of Heat": "1959-08-24T05:43:29+08:00",
    "White Dew": "1959-09-08T17:47:54+08:00",
    "Autumn Equinox": "1959-09-24T03:08:24+08:00",
    "Cold Dew": "1959-10-09T09:09:48+08:00",
    "Frost's Descent": "1959-10-24T12:10:58+08:00",
    "Start of Winter": "1959-11-08T12:02:03+08:00",
    "Minor Snow": "1959-11-23T09:26:53+08:00",
    "Major Snow": "1959-12-08T04:37:16+08:00",
    "Winter Solstice": "1959-12-22T22:34:18+08:00",
    "Minor Cold": "1960-01-06T15:42:27+08:00",
    "Major Cold": "1960-01-21T09:10:02+08:00"
  },
  
  // 1960
  1960: {
    "Start of Spring": "1960-02-05T03:23:09+08:00",
    "Rain Water": "1960-02-19T23:26:17+08:00",
    "Awakening of Insects": "1960-03-05T21:36:06+08:00",
    "Spring Equinox": "1960-03-20T22:42:38+08:00",
    "Pure Brightness": "1960-04-05T02:43:33+08:00",
    "Grain Rain": "1960-04-20T10:05:51+08:00",
    "Start of Summer": "1960-05-05T20:22:33+08:00",
    "Grain Buds": "1960-05-21T09:33:28+08:00",
    "Grain in Ear": "1960-06-06T00:48:34+08:00",
    "Summer Solstice": "1960-06-21T17:42:15+08:00",
    "Minor Heat": "1960-07-07T11:12:39+08:00",
    "Major Heat": "1960-07-23T04:37:25+08:00",
    "Start of Autumn": "1960-08-07T20:59:44+08:00",
    "End of Heat": "1960-08-23T11:34:22+08:00",
    "White Dew": "1960-09-07T23:45:22+08:00",
    "Autumn Equinox": "1960-09-23T08:58:50+08:00",
    "Cold Dew": "1960-10-08T15:08:39+08:00",
    "Frost's Descent": "1960-10-23T18:01:49+08:00",
    "Start of Winter": "1960-11-07T18:02:01+08:00",
    "Minor Snow": "1960-11-22T15:18:20+08:00",
    "Major Snow": "1960-12-07T10:37:44+08:00",
    "Winter Solstice": "1960-12-22T04:25:53+08:00",
    "Minor Cold": "1961-01-05T21:42:36+08:00",
    "Major Cold": "1961-01-20T15:01:06+08:00"
  },
  
  // 1961
  1961: {
    "Start of Spring": "1961-02-04T09:22:26+08:00",
    "Rain Water": "1961-02-19T05:16:27+08:00",
    "Awakening of Insects": "1961-03-06T03:34:39+08:00",
    "Spring Equinox": "1961-03-21T04:32:04+08:00",
    "Pure Brightness": "1961-04-05T08:42:07+08:00",
    "Grain Rain": "1961-04-20T15:55:02+08:00",
    "Start of Summer": "1961-05-06T02:21:16+08:00",
    "Grain Buds": "1961-05-21T15:22:14+08:00",
    "Grain in Ear": "1961-06-06T06:46:00+08:00",
    "Summer Solstice": "1961-06-21T23:30:04+08:00",
    "Minor Heat": "1961-07-07T17:06:35+08:00",
    "Major Heat": "1961-07-23T10:23:34+08:00",
    "Start of Autumn": "1961-08-08T02:48:19+08:00",
    "End of Heat": "1961-08-23T17:18:30+08:00",
    "White Dew": "1961-09-08T05:29:12+08:00",
    "Autumn Equinox": "1961-09-23T14:42:25+08:00",
    "Cold Dew": "1961-10-08T20:50:56+08:00",
    "Frost's Descent": "1961-10-23T23:47:21+08:00",
    "Start of Winter": "1961-11-07T23:46:11+08:00",
    "Minor Snow": "1961-11-22T21:07:40+08:00",
    "Major Snow": "1961-12-07T16:25:54+08:00",
    "Winter Solstice": "1961-12-22T10:19:26+08:00",
    "Minor Cold": "1962-01-06T03:34:56+08:00",
    "Major Cold": "1962-01-20T20:57:53+08:00"
  },
  
  // 1962
  1962: {
    "Start of Spring": "1962-02-04T15:17:20+08:00",
    "Rain Water": "1962-02-19T11:14:34+08:00",
    "Awakening of Insects": "1962-03-06T09:29:29+08:00",
    "Spring Equinox": "1962-03-21T10:29:31+08:00",
    "Pure Brightness": "1962-04-05T14:34:14+08:00",
    "Grain Rain": "1962-04-20T21:50:40+08:00",
    "Start of Summer": "1962-05-06T08:09:28+08:00",
    "Grain Buds": "1962-05-21T21:16:30+08:00",
    "Grain in Ear": "1962-06-06T12:31:15+08:00",
    "Summer Solstice": "1962-06-22T05:24:05+08:00",
    "Minor Heat": "1962-07-07T22:51:05+08:00",
    "Major Heat": "1962-07-23T16:17:56+08:00",
    "Start of Autumn": "1962-08-08T08:33:40+08:00",
    "End of Heat": "1962-08-23T23:12:27+08:00",
    "White Dew": "1962-09-08T11:15:20+08:00",
    "Autumn Equinox": "1962-09-23T20:35:11+08:00",
    "Cold Dew": "1962-10-09T02:37:53+08:00",
    "Frost's Descent": "1962-10-24T05:39:59+08:00",
    "Start of Winter": "1962-11-08T05:34:54+08:00",
    "Minor Snow": "1962-11-23T03:01:50+08:00",
    "Major Snow": "1962-12-07T22:16:39+08:00",
    "Winter Solstice": "1962-12-22T16:15:14+08:00",
    "Minor Cold": "1963-01-06T09:26:26+08:00",
    "Major Cold": "1963-01-21T02:53:51+08:00"
  },
  
  // 1963
  1963: {
    "Start of Spring": "1963-02-04T21:07:44+08:00",
    "Rain Water": "1963-02-19T17:08:34+08:00",
    "Awakening of Insects": "1963-03-06T15:17:09+08:00",
    "Spring Equinox": "1963-03-21T16:19:39+08:00",
    "Pure Brightness": "1963-04-05T20:18:39+08:00",
    "Grain Rain": "1963-04-21T03:36:07+08:00",
    "Start of Summer": "1963-05-06T13:51:57+08:00",
    "Grain Buds": "1963-05-22T02:58:07+08:00",
    "Grain in Ear": "1963-06-06T18:14:26+08:00",
    "Summer Solstice": "1963-06-22T11:04:00+08:00",
    "Minor Heat": "1963-07-08T04:37:37+08:00",
    "Major Heat": "1963-07-23T21:59:11+08:00",
    "Start of Autumn": "1963-08-08T14:25:24+08:00",
    "End of Heat": "1963-08-24T04:57:29+08:00",
    "White Dew": "1963-09-08T17:11:50+08:00",
    "Autumn Equinox": "1963-09-24T02:23:27+08:00",
    "Cold Dew": "1963-10-09T08:36:14+08:00",
    "Frost's Descent": "1963-10-24T11:28:48+08:00",
    "Start of Winter": "1963-11-08T11:32:19+08:00",
    "Minor Snow": "1963-11-23T08:49:20+08:00",
    "Major Snow": "1963-12-08T04:12:36+08:00",
    "Winter Solstice": "1963-12-22T22:01:52+08:00",
    "Minor Cold": "1964-01-06T15:22:20+08:00",
    "Major Cold": "1964-01-21T08:41:03+08:00"
  },
  
  // 1964
  1964: {
    "Start of Spring": "1964-02-05T03:04:55+08:00",
    "Rain Water": "1964-02-19T22:57:17+08:00",
    "Awakening of Insects": "1964-03-05T21:15:59+08:00",
    "Spring Equinox": "1964-03-20T22:09:50+08:00",
    "Pure Brightness": "1964-04-05T02:18:20+08:00",
    "Grain Rain": "1964-04-20T09:27:08+08:00",
    "Start of Summer": "1964-05-05T19:51:01+08:00",
    "Grain Buds": "1964-05-21T08:49:45+08:00",
    "Grain in Ear": "1964-06-06T00:11:43+08:00",
    "Summer Solstice": "1964-06-21T16:56:47+08:00",
    "Minor Heat": "1964-07-07T10:32:07+08:00",
    "Major Heat": "1964-07-23T03:52:43+08:00",
    "Start of Autumn": "1964-08-07T20:16:09+08:00",
    "End of Heat": "1964-08-23T10:51:01+08:00",
    "White Dew": "1964-09-07T22:59:26+08:00",
    "Autumn Equinox": "1964-09-23T08:16:38+08:00",
    "Cold Dew": "1964-10-08T14:21:30+08:00",
    "Frost's Descent": "1964-10-23T17:20:40+08:00",
    "Start of Winter": "1964-11-07T17:15:06+08:00",
    "Minor Snow": "1964-11-22T14:38:53+08:00",
    "Major Snow": "1964-12-07T09:53:03+08:00",
    "Winter Solstice": "1964-12-22T03:49:31+08:00",
    "Minor Cold": "1965-01-05T21:01:57+08:00",
    "Major Cold": "1965-01-20T14:28:51+08:00"
  },
  
  // 1965
  1965: {
    "Start of Spring": "1965-02-04T08:46:06+08:00",
    "Rain Water": "1965-02-19T04:47:48+08:00",
    "Awakening of Insects": "1965-03-06T03:00:38+08:00",
    "Spring Equinox": "1965-03-21T04:04:44+08:00",
    "Pure Brightness": "1965-04-05T08:06:43+08:00",
    "Grain Rain": "1965-04-20T15:26:03+08:00",
    "Start of Summer": "1965-05-06T01:41:32+08:00",
    "Grain Buds": "1965-05-21T14:50:13+08:00",
    "Grain in Ear": "1965-06-06T06:02:06+08:00",
    "Summer Solstice": "1965-06-21T22:55:40+08:00",
    "Minor Heat": "1965-07-07T16:21:22+08:00",
    "Major Heat": "1965-07-23T09:48:09+08:00",
    "Start of Autumn": "1965-08-08T02:04:36+08:00",
    "End of Heat": "1965-08-23T16:42:40+08:00",
    "White Dew": "1965-09-08T04:47:50+08:00",
    "Autumn Equinox": "1965-09-23T14:05:57+08:00",
    "Cold Dew": "1965-10-08T20:11:07+08:00",
    "Frost's Descent": "1965-10-23T23:09:55+08:00",
    "Start of Winter": "1965-11-07T23:06:32+08:00",
    "Minor Snow": "1965-11-22T20:29:08+08:00",
    "Major Snow": "1965-12-07T15:45:32+08:00",
    "Winter Solstice": "1965-12-22T09:40:23+08:00",
    "Minor Cold": "1966-01-06T02:54:20+08:00",
    "Major Cold": "1966-01-20T20:19:39+08:00"
  },
  
  // 1966
  1966: {
    "Start of Spring": "1966-02-04T14:37:48+08:00",
    "Rain Water": "1966-02-19T10:37:47+08:00",
    "Awakening of Insects": "1966-03-06T08:51:21+08:00",
    "Spring Equinox": "1966-03-21T09:52:54+08:00",
    "Pure Brightness": "1966-04-05T13:56:29+08:00",
    "Grain Rain": "1966-04-20T21:11:30+08:00",
    "Start of Summer": "1966-05-06T07:30:26+08:00",
    "Grain Buds": "1966-05-21T20:32:01+08:00",
    "Grain in Ear": "1966-06-06T11:49:37+08:00",
    "Summer Solstice": "1966-06-22T04:33:21+08:00",
    "Minor Heat": "1966-07-07T22:06:59+08:00",
    "Major Heat": "1966-07-23T15:23:10+08:00",
    "Start of Autumn": "1966-08-08T07:48:56+08:00",
    "End of Heat": "1966-08-23T22:17:42+08:00",
    "White Dew": "1966-09-08T10:32:01+08:00",
    "Autumn Equinox": "1966-09-23T19:43:08+08:00",
    "Cold Dew": "1966-10-09T01:56:43+08:00",
    "Frost's Descent": "1966-10-24T04:50:45+08:00",
    "Start of Winter": "1966-11-08T04:55:15+08:00",
    "Minor Snow": "1966-11-23T02:14:05+08:00",
    "Major Snow": "1966-12-07T21:37:45+08:00",
    "Winter Solstice": "1966-12-22T15:28:08+08:00",
    "Minor Cold": "1967-01-06T08:48:19+08:00",
    "Major Cold": "1967-01-21T02:07:30+08:00"
  },
  
  // 1967
  1967: {
    "Start of Spring": "1967-02-04T20:30:49+08:00",
    "Rain Water": "1967-02-19T16:23:38+08:00",
    "Awakening of Insects": "1967-03-06T14:41:53+08:00",
    "Spring Equinox": "1967-03-21T15:36:46+08:00",
    "Pure Brightness": "1967-04-05T19:44:41+08:00",
    "Grain Rain": "1967-04-21T02:55:07+08:00",
    "Start of Summer": "1967-05-06T13:17:26+08:00",
    "Grain Buds": "1967-05-22T02:17:52+08:00",
    "Grain in Ear": "1967-06-06T17:36:18+08:00",
    "Summer Solstice": "1967-06-22T10:22:49+08:00",
    "Minor Heat": "1967-07-08T03:53:19+08:00",
    "Major Heat": "1967-07-23T21:15:49+08:00",
    "Start of Autumn": "1967-08-08T13:34:51+08:00",
    "End of Heat": "1967-08-24T04:12:24+08:00",
    "White Dew": "1967-09-08T16:17:42+08:00",
    "Autumn Equinox": "1967-09-24T01:38:01+08:00",
    "Cold Dew": "1967-10-09T07:41:11+08:00",
    "Frost's Descent": "1967-10-24T10:43:44+08:00",
    "Start of Winter": "1967-11-08T10:37:23+08:00",
    "Minor Snow": "1967-11-23T08:04:26+08:00",
    "Major Snow": "1967-12-08T03:17:28+08:00",
    "Winter Solstice": "1967-12-22T21:16:17+08:00",
    "Minor Cold": "1968-01-06T14:26:10+08:00",
    "Major Cold": "1968-01-21T07:54:06+08:00"
  },
  
  // 1968
  1968: {
    "Start of Spring": "1968-02-05T02:07:23+08:00",
    "Rain Water": "1968-02-19T22:09:13+08:00",
    "Awakening of Insects": "1968-03-05T20:17:45+08:00",
    "Spring Equinox": "1968-03-20T21:22:01+08:00",
    "Pure Brightness": "1968-04-05T01:20:53+08:00",
    "Grain Rain": "1968-04-20T08:41:07+08:00",
    "Start of Summer": "1968-05-05T18:55:47+08:00",
    "Grain Buds": "1968-05-21T08:05:50+08:00",
    "Grain in Ear": "1968-06-05T23:19:05+08:00",
    "Summer Solstice": "1968-06-21T16:13:16+08:00",
    "Minor Heat": "1968-07-07T09:41:37+08:00",
    "Major Heat": "1968-07-23T03:07:23+08:00",
    "Start of Autumn": "1968-08-07T19:27:11+08:00",
    "End of Heat": "1968-08-23T10:02:51+08:00",
    "White Dew": "1968-09-07T22:11:24+08:00",
    "Autumn Equinox": "1968-09-23T07:26:10+08:00",
    "Cold Dew": "1968-10-08T13:34:23+08:00",
    "Frost's Descent": "1968-10-23T16:29:34+08:00",
    "Start of Winter": "1968-11-07T16:29:17+08:00",
    "Minor Snow": "1968-11-22T13:48:31+08:00",
    "Major Snow": "1968-12-07T09:08:15+08:00",
    "Winter Solstice": "1968-12-22T02:59:45+08:00",
    "Minor Cold": "1969-01-05T20:16:48+08:00",
    "Major Cold": "1969-01-20T13:38:10+08:00"
  },
  
  // 1969
  1969: {
    "Start of Spring": "1969-02-04T07:58:52+08:00",
    "Rain Water": "1969-02-19T03:54:28+08:00",
    "Awakening of Insects": "1969-03-06T02:10:34+08:00",
    "Spring Equinox": "1969-03-21T03:08:04+08:00",
    "Pure Brightness": "1969-04-05T07:14:51+08:00",
    "Grain Rain": "1969-04-20T14:26:51+08:00",
    "Start of Summer": "1969-05-06T00:49:47+08:00",
    "Grain Buds": "1969-05-21T13:49:42+08:00",
    "Grain in Ear": "1969-06-06T05:11:29+08:00",
    "Summer Solstice": "1969-06-21T21:55:01+08:00",
    "Minor Heat": "1969-07-07T15:31:31+08:00",
    "Major Heat": "1969-07-23T08:48:08+08:00",
    "Start of Autumn": "1969-08-08T01:14:06+08:00",
    "End of Heat": "1969-08-23T15:43:20+08:00",
    "White Dew": "1969-09-08T03:55:25+08:00",
    "Autumn Equinox": "1969-09-23T13:06:53+08:00",
    "Cold Dew": "1969-10-08T19:16:40+08:00",
    "Frost's Descent": "1969-10-23T22:11:02+08:00",
    "Start of Winter": "1969-11-07T22:11:20+08:00",
    "Minor Snow": "1969-11-22T19:31:04+08:00",
    "Major Snow": "1969-12-07T14:51:18+08:00",
    "Winter Solstice": "1969-12-22T08:43:41+08:00",
    "Minor Cold": "1970-01-06T02:01:39+08:00",
    "Major Cold": "1970-01-20T19:23:47+08:00"
  },
  
  // 1970
  1970: {
    "Start of Spring": "1970-02-04T13:45:42+08:00",
    "Rain Water": "1970-02-19T09:41:46+08:00",
    "Awakening of Insects": "1970-03-06T07:58:27+08:00",
    "Spring Equinox": "1970-03-21T08:56:19+08:00",
    "Pure Brightness": "1970-04-05T13:01:44+08:00",
    "Grain Rain": "1970-04-20T20:14:56+08:00",
    "Start of Summer": "1970-05-06T06:33:47+08:00",
    "Grain Buds": "1970-05-21T19:37:19+08:00",
    "Grain in Ear": "1970-06-06T10:52:13+08:00",
    "Summer Solstice": "1970-06-22T03:42:38+08:00",
    "Minor Heat": "1970-07-07T21:10:31+08:00",
    "Major Heat": "1970-07-23T14:36:52+08:00",
    "Start of Autumn": "1970-08-08T06:54:06+08:00",
    "End of Heat": "1970-08-23T21:33:53+08:00",
    "White Dew": "1970-09-08T09:37:53+08:00",
    "Autumn Equinox": "1970-09-23T18:58:59+08:00",
    "Cold Dew": "1970-10-09T01:01:32+08:00",
    "Frost's Descent": "1970-10-24T04:04:14+08:00",
    "Start of Winter": "1970-11-08T03:57:43+08:00",
    "Minor Snow": "1970-11-23T01:24:32+08:00",
    "Major Snow": "1970-12-07T20:37:19+08:00",
    "Winter Solstice": "1970-12-22T14:35:40+08:00",
    "Minor Cold": "1971-01-06T07:45:06+08:00",
    "Major Cold": "1971-01-21T01:12:39+08:00"
  },
  
  // 1971
  1971: {
    "Start of Spring": "1971-02-04T19:25:25+08:00",
    "Rain Water": "1971-02-19T15:26:55+08:00",
    "Awakening of Insects": "1971-03-06T13:34:44+08:00",
    "Spring Equinox": "1971-03-21T14:38:06+08:00",
    "Pure Brightness": "1971-04-05T18:36:00+08:00",
    "Grain Rain": "1971-04-21T01:54:13+08:00",
    "Start of Summer": "1971-05-06T12:08:08+08:00",
    "Grain Buds": "1971-05-22T01:14:59+08:00",
    "Grain in Ear": "1971-06-06T16:28:51+08:00",
    "Summer Solstice": "1971-06-22T09:19:34+08:00",
    "Minor Heat": "1971-07-08T02:51:07+08:00",
    "Major Heat": "1971-07-23T20:14:43+08:00",
    "Start of Autumn": "1971-08-08T12:40:12+08:00",
    "End of Heat": "1971-08-24T03:15:14+08:00",
    "White Dew": "1971-09-08T15:30:12+08:00",
    "Autumn Equinox": "1971-09-24T00:44:52+08:00",
    "Cold Dew": "1971-10-09T06:58:34+08:00",
    "Frost's Descent": "1971-10-24T09:53:08+08:00",
    "Start of Winter": "1971-11-08T09:56:37+08:00",
    "Minor Snow": "1971-11-23T07:13:56+08:00",
    "Major Snow": "1971-12-08T02:35:42+08:00",
    "Winter Solstice": "1971-12-22T20:23:53+08:00",
    "Minor Cold": "1972-01-06T13:41:50+08:00",
    "Major Cold": "1972-01-21T06:58:59+08:00"
  },
  
  // 1972
  1972: {
    "Start of Spring": "1972-02-05T01:20:13+08:00",
    "Rain Water": "1972-02-19T21:11:23+08:00",
    "Awakening of Insects": "1972-03-05T19:28:04+08:00",
    "Spring Equinox": "1972-03-20T20:21:25+08:00",
    "Pure Brightness": "1972-04-05T00:28:50+08:00",
    "Grain Rain": "1972-04-20T07:37:29+08:00",
    "Start of Summer": "1972-05-05T18:01:10+08:00",
    "Grain Buds": "1972-05-21T06:59:29+08:00",
    "Grain in Ear": "1972-06-05T22:21:59+08:00",
    "Summer Solstice": "1972-06-21T15:06:10+08:00",
    "Minor Heat": "1972-07-07T08:42:53+08:00",
    "Major Heat": "1972-07-23T02:02:30+08:00",
    "Start of Autumn": "1972-08-07T18:28:29+08:00",
    "End of Heat": "1972-08-23T09:03:01+08:00",
    "White Dew": "1972-09-07T21:15:06+08:00",
    "Autumn Equinox": "1972-09-23T06:32:45+08:00",
    "Cold Dew": "1972-10-08T12:41:45+08:00",
    "Frost's Descent": "1972-10-23T15:41:27+08:00",
    "Start of Winter": "1972-11-07T15:39:23+08:00",
    "Minor Snow": "1972-11-22T13:02:41+08:00",
    "Major Snow": "1972-12-07T08:18:42+08:00",
    "Winter Solstice": "1972-12-22T02:12:53+08:00",
    "Minor Cold": "1973-01-05T19:25:19+08:00",
    "Major Cold": "1973-01-20T12:48:12+08:00"
  },
  
  // 1973
  1973: {
    "Start of Spring": "1973-02-04T07:04:12+08:00",
    "Rain Water": "1973-02-19T03:01:09+08:00",
    "Awakening of Insects": "1973-03-06T01:12:36+08:00",
    "Spring Equinox": "1973-03-21T02:12:26+08:00",
    "Pure Brightness": "1973-04-05T06:13:53+08:00",
    "Grain Rain": "1973-04-20T13:30:21+08:00",
    "Start of Summer": "1973-05-05T23:46:23+08:00",
    "Grain Buds": "1973-05-21T12:53:49+08:00",
    "Grain in Ear": "1973-06-06T04:06:50+08:00",
    "Summer Solstice": "1973-06-21T21:00:34+08:00",
    "Minor Heat": "1973-07-07T14:27:21+08:00",
    "Major Heat": "1973-07-23T07:55:32+08:00",
    "Start of Autumn": "1973-08-08T00:12:48+08:00",
    "End of Heat": "1973-08-23T14:53:27+08:00",
    "White Dew": "1973-09-08T02:59:24+08:00",
    "Autumn Equinox": "1973-09-23T12:21:06+08:00",
    "Cold Dew": "1973-10-08T18:27:15+08:00",
    "Frost's Descent": "1973-10-23T21:30:09+08:00",
    "Start of Winter": "1973-11-07T21:27:38+08:00",
    "Minor Snow": "1973-11-22T18:54:00+08:00",
    "Major Snow": "1973-12-07T14:10:23+08:00",
    "Winter Solstice": "1973-12-22T08:07:41+08:00",
    "Minor Cold": "1974-01-06T01:19:55+08:00",
    "Major Cold": "1974-01-20T18:45:40+08:00"
  },
  
  // 1974
  1974: {
    "Start of Spring": "1974-02-04T13:00:05+08:00",
    "Rain Water": "1974-02-19T08:58:41+08:00",
    "Awakening of Insects": "1974-03-06T07:07:06+08:00",
    "Spring Equinox": "1974-03-21T08:06:38+08:00",
    "Pure Brightness": "1974-04-05T12:05:00+08:00",
    "Grain Rain": "1974-04-20T19:18:51+08:00",
    "Start of Summer": "1974-05-06T05:33:52+08:00",
    "Grain Buds": "1974-05-21T18:36:02+08:00",
    "Grain in Ear": "1974-06-06T09:51:39+08:00",
    "Summer Solstice": "1974-06-22T02:37:36+08:00",
    "Minor Heat": "1974-07-07T20:11:06+08:00",
    "Major Heat": "1974-07-23T13:30:10+08:00",
    "Start of Autumn": "1974-08-08T05:57:10+08:00",
    "End of Heat": "1974-08-23T20:28:40+08:00",
    "White Dew": "1974-09-08T08:45:04+08:00",
    "Autumn Equinox": "1974-09-23T17:58:26+08:00",
    "Cold Dew": "1974-10-09T00:14:39+08:00",
    "Frost's Descent": "1974-10-24T03:10:36+08:00",
    "Start of Winter": "1974-11-08T03:17:58+08:00",
    "Minor Snow": "1974-11-23T00:38:27+08:00",
    "Major Snow": "1974-12-07T20:04:37+08:00",
    "Winter Solstice": "1974-12-22T13:55:56+08:00",
    "Minor Cold": "1975-01-06T07:17:30+08:00",
    "Major Cold": "1975-01-21T00:36:14+08:00"
  },
  
  // 1975
  1975: {
    "Start of Spring": "1975-02-04T18:59:12+08:00",
    "Rain Water": "1975-02-19T14:49:41+08:00",
    "Awakening of Insects": "1975-03-06T13:05:47+08:00",
    "Spring Equinox": "1975-03-21T13:56:39+08:00",
    "Pure Brightness": "1975-04-05T18:01:30+08:00",
    "Grain Rain": "1975-04-21T01:07:12+08:00",
    "Start of Summer": "1975-05-06T11:27:11+08:00",
    "Grain Buds": "1975-05-22T00:23:40+08:00",
    "Grain in Ear": "1975-06-06T15:42:01+08:00",
    "Summer Solstice": "1975-06-22T08:26:25+08:00",
    "Minor Heat": "1975-07-08T01:59:24+08:00",
    "Major Heat": "1975-07-23T19:21:44+08:00",
    "Start of Autumn": "1975-08-08T11:44:53+08:00",
    "End of Heat": "1975-08-24T02:23:37+08:00",
    "White Dew": "1975-09-08T14:33:17+08:00",
    "Autumn Equinox": "1975-09-23T23:55:12+08:00",
    "Cold Dew": "1975-10-09T06:02:04+08:00",
    "Frost's Descent": "1975-10-24T09:06:01+08:00",
    "Start of Winter": "1975-11-08T09:02:36+08:00",
    "Minor Snow": "1975-11-23T06:30:42+08:00",
    "Major Snow": "1975-12-08T01:46:09+08:00",
    "Winter Solstice": "1975-12-22T19:45:33+08:00",
    "Minor Cold": "1976-01-06T12:57:22+08:00",
    "Major Cold": "1976-01-21T06:25:06+08:00"
  },
  
  // 1976
  1976: {
    "Start of Spring": "1976-02-05T00:39:28+08:00",
    "Rain Water": "1976-02-19T20:39:55+08:00",
    "Awakening of Insects": "1976-03-05T18:48:06+08:00",
    "Spring Equinox": "1976-03-20T19:49:36+08:00",
    "Pure Brightness": "1976-04-04T23:46:27+08:00",
    "Grain Rain": "1976-04-20T07:02:56+08:00",
    "Start of Summer": "1976-05-05T17:14:24+08:00",
    "Grain Buds": "1976-05-21T06:21:04+08:00",
    "Grain in Ear": "1976-06-05T21:31:13+08:00",
    "Summer Solstice": "1976-06-21T14:24:11+08:00",
    "Minor Heat": "1976-07-07T07:50:50+08:00",
    "Major Heat": "1976-07-23T01:18:26+08:00",
    "Start of Autumn": "1976-08-07T17:38:21+08:00",
    "End of Heat": "1976-08-23T08:18:15+08:00",
    "White Dew": "1976-09-07T20:28:12+08:00",
    "Autumn Equinox": "1976-09-23T05:48:11+08:00",
    "Cold Dew": "1976-10-08T11:58:03+08:00",
    "Frost's Descent": "1976-10-23T14:58:01+08:00",
    "Start of Winter": "1976-11-07T14:58:34+08:00",
    "Minor Snow": "1976-11-22T12:21:28+08:00",
    "Major Snow": "1976-12-07T07:40:56+08:00",
    "Winter Solstice": "1976-12-22T01:35:06+08:00",
    "Minor Cold": "1977-01-05T18:51:03+08:00",
    "Major Cold": "1977-01-20T12:14:25+08:00"
  },
  
  // 1977
  1977: {
    "Start of Spring": "1977-02-04T06:33:25+08:00",
    "Rain Water": "1977-02-19T02:30:25+08:00",
    "Awakening of Insects": "1977-03-06T00:44:09+08:00",
    "Spring Equinox": "1977-03-21T01:42:15+08:00",
    "Pure Brightness": "1977-04-05T05:45:44+08:00",
    "Grain Rain": "1977-04-20T12:57:12+08:00",
    "Start of Summer": "1977-05-05T23:16:00+08:00",
    "Grain Buds": "1977-05-21T12:14:20+08:00",
    "Grain in Ear": "1977-06-06T03:32:01+08:00",
    "Summer Solstice": "1977-06-21T20:13:44+08:00",
    "Minor Heat": "1977-07-07T13:47:52+08:00",
    "Major Heat": "1977-07-23T07:03:38+08:00",
    "Start of Autumn": "1977-08-07T23:30:14+08:00",
    "End of Heat": "1977-08-23T14:00:14+08:00",
    "White Dew": "1977-09-08T02:15:41+08:00",
    "Autumn Equinox": "1977-09-23T11:29:13+08:00",
    "Cold Dew": "1977-10-08T17:43:56+08:00",
    "Frost's Descent": "1977-10-23T20:40:39+08:00",
    "Start of Winter": "1977-11-07T20:45:49+08:00",
    "Minor Snow": "1977-11-22T18:06:59+08:00",
    "Major Snow": "1977-12-07T13:30:49+08:00",
    "Winter Solstice": "1977-12-22T07:23:08+08:00",
    "Minor Cold": "1978-01-06T00:43:12+08:00",
    "Major Cold": "1978-01-20T18:03:59+08:00"
  },
  
  // 1978
  1978: {
    "Start of Spring": "1978-02-04T12:26:57+08:00",
    "Rain Water": "1978-02-19T08:20:57+08:00",
    "Awakening of Insects": "1978-03-06T06:38:11+08:00",
    "Spring Equinox": "1978-03-21T07:33:34+08:00",
    "Pure Brightness": "1978-04-05T11:39:20+08:00",
    "Grain Rain": "1978-04-20T18:49:32+08:00",
    "Start of Summer": "1978-05-06T05:08:32+08:00",
    "Grain Buds": "1978-05-21T18:08:26+08:00",
    "Grain in Ear": "1978-06-06T09:23:05+08:00",
    "Summer Solstice": "1978-06-22T02:09:33+08:00",
    "Minor Heat": "1978-07-07T19:36:57+08:00",
    "Major Heat": "1978-07-23T13:00:14+08:00",
    "Start of Autumn": "1978-08-08T05:17:40+08:00",
    "End of Heat": "1978-08-23T19:56:46+08:00",
    "White Dew": "1978-09-08T08:02:24+08:00",
    "Autumn Equinox": "1978-09-23T17:25:24+08:00",
    "Cold Dew": "1978-10-08T23:30:54+08:00",
    "Frost's Descent": "1978-10-24T02:37:09+08:00",
    "Start of Winter": "1978-11-08T02:34:01+08:00",
    "Minor Snow": "1978-11-23T00:04:36+08:00",
    "Major Snow": "1978-12-07T19:20:01+08:00",
    "Winter Solstice": "1978-12-22T13:20:57+08:00",
    "Minor Cold": "1979-01-06T06:31:33+08:00",
    "Major Cold": "1979-01-20T23:59:56+08:00"
  },
  
  // 1979
  1979: {
    "Start of Spring": "1979-02-04T18:12:18+08:00",
    "Rain Water": "1979-02-19T14:13:13+08:00",
    "Awakening of Insects": "1979-03-06T12:19:38+08:00",
    "Spring Equinox": "1979-03-21T13:21:55+08:00",
    "Pure Brightness": "1979-04-05T17:17:57+08:00",
    "Grain Rain": "1979-04-21T00:35:21+08:00",
    "Start of Summer": "1979-05-06T10:47:10+08:00",
    "Grain Buds": "1979-05-21T23:53:50+08:00",
    "Grain in Ear": "1979-06-06T15:05:11+08:00",
    "Summer Solstice": "1979-06-22T07:56:09+08:00",
    "Minor Heat": "1979-07-08T01:24:37+08:00",
    "Major Heat": "1979-07-23T18:48:32+08:00",
    "Start of Autumn": "1979-08-08T11:10:53+08:00",
    "End of Heat": "1979-08-24T01:46:43+08:00",
    "White Dew": "1979-09-08T13:59:45+08:00",
    "Autumn Equinox": "1979-09-23T23:16:22+08:00",
    "Cold Dew": "1979-10-09T05:30:02+08:00",
    "Frost's Descent": "1979-10-24T08:27:50+08:00",
    "Start of Winter": "1979-11-08T08:32:47+08:00",
    "Minor Snow": "1979-11-23T05:54:06+08:00",
    "Major Snow": "1979-12-08T01:17:48+08:00",
    "Winter Solstice": "1979-12-22T19:09:45+08:00",
    "Minor Cold": "1980-01-06T12:28:53+08:00",
    "Major Cold": "1980-01-21T05:48:37+08:00"
  },
  
  // 1980
  1980: {
    "Start of Spring": "1980-02-05T00:09:28+08:00",
    "Rain Water": "1980-02-19T20:01:38+08:00",
    "Awakening of Insects": "1980-03-05T18:16:29+08:00",
    "Spring Equinox": "1980-03-20T19:09:40+08:00",
    "Pure Brightness": "1980-04-04T23:14:42+08:00",
    "Grain Rain": "1980-04-20T06:22:41+08:00",
    "Start of Summer": "1980-05-05T16:44:28+08:00",
    "Grain Buds": "1980-05-21T05:42:02+08:00",
    "Grain in Ear": "1980-06-05T21:03:44+08:00",
    "Summer Solstice": "1980-06-21T13:47:00+08:00",
    "Minor Heat": "1980-07-07T07:23:56+08:00",
    "Major Heat": "1980-07-23T00:41:59+08:00",
    "Start of Autumn": "1980-08-07T17:08:30+08:00",
    "End of Heat": "1980-08-23T07:40:38+08:00",
    "White Dew": "1980-09-07T19:53:27+08:00",
    "Autumn Equinox": "1980-09-23T05:08:40+08:00",
    "Cold Dew": "1980-10-08T11:19:14+08:00",
    "Frost's Descent": "1980-10-23T14:17:30+08:00",
    "Start of Winter": "1980-11-07T14:18:13+08:00",
    "Minor Snow": "1980-11-22T11:41:23+08:00",
    "Major Snow": "1980-12-07T07:01:15+08:00",
    "Winter Solstice": "1980-12-22T00:56:04+08:00",
    "Minor Cold": "1981-01-05T18:12:38+08:00",
    "Major Cold": "1981-01-20T11:35:58+08:00"
  },
  
  // 1981
  1981: {
    "Start of Spring": "1981-02-04T05:55:23+08:00",
    "Rain Water": "1981-02-19T01:51:38+08:00",
    "Awakening of Insects": "1981-03-06T00:05:07+08:00",
    "Spring Equinox": "1981-03-21T01:02:49+08:00",
    "Pure Brightness": "1981-04-05T05:05:02+08:00",
    "Grain Rain": "1981-04-20T12:18:31+08:00",
    "Start of Summer": "1981-05-05T22:34:47+08:00",
    "Grain Buds": "1981-05-21T11:39:25+08:00",
    "Grain in Ear": "1981-06-06T02:52:39+08:00",
    "Summer Solstice": "1981-06-21T19:44:40+08:00",
    "Minor Heat": "1981-07-07T13:11:52+08:00",
    "Major Heat": "1981-07-23T06:39:43+08:00",
    "Start of Autumn": "1981-08-07T22:57:09+08:00",
    "End of Heat": "1981-08-23T13:38:10+08:00",
    "White Dew": "1981-09-08T01:43:13+08:00",
    "Autumn Equinox": "1981-09-23T11:05:11+08:00",
    "Cold Dew": "1981-10-08T17:09:32+08:00",
    "Frost's Descent": "1981-10-23T20:12:49+08:00",
    "Start of Winter": "1981-11-07T20:08:29+08:00",
    "Minor Snow": "1981-11-22T17:35:56+08:00",
    "Major Snow": "1981-12-07T12:51:15+08:00",
    "Winter Solstice": "1981-12-22T06:50:31+08:00",
    "Minor Cold": "1982-01-06T00:02:35+08:00",
    "Major Cold": "1982-01-20T17:30:53+08:00"
  },
  
  // 1982
  1982: {
    "Start of Spring": "1982-02-04T11:45:28+08:00",
    "Rain Water": "1982-02-19T07:46:31+08:00",
    "Awakening of Insects": "1982-03-06T05:54:34+08:00",
    "Spring Equinox": "1982-03-21T06:55:50+08:00",
    "Pure Brightness": "1982-04-05T10:52:41+08:00",
    "Grain Rain": "1982-04-20T18:07:27+08:00",
    "Start of Summer": "1982-05-06T04:19:59+08:00",
    "Grain Buds": "1982-05-21T17:22:53+08:00",
    "Grain in Ear": "1982-06-06T08:35:53+08:00",
    "Summer Solstice": "1982-06-22T01:22:59+08:00",
    "Minor Heat": "1982-07-07T18:54:35+08:00",
    "Major Heat": "1982-07-23T12:15:23+08:00",
    "Start of Autumn": "1982-08-08T04:41:45+08:00",
    "End of Heat": "1982-08-23T19:15:13+08:00",
    "White Dew": "1982-09-08T07:31:43+08:00",
    "Autumn Equinox": "1982-09-23T16:46:11+08:00",
    "Cold Dew": "1982-10-08T23:02:09+08:00",
    "Frost's Descent": "1982-10-24T01:57:47+08:00",
    "Start of Winter": "1982-11-08T02:04:06+08:00",
    "Minor Snow": "1982-11-22T23:23:18+08:00",
    "Major Snow": "1982-12-07T18:48:05+08:00",
    "Winter Solstice": "1982-12-22T12:38:09+08:00",
    "Minor Cold": "1983-01-06T05:58:42+08:00",
    "Major Cold": "1983-01-20T23:16:56+08:00"
  },
  
  // 1983
  1983: {
    "Start of Spring": "1983-02-04T17:39:42+08:00",
    "Rain Water": "1983-02-19T13:30:34+08:00",
    "Awakening of Insects": "1983-03-06T11:47:12+08:00",
    "Spring Equinox": "1983-03-21T12:38:44+08:00",
    "Pure Brightness": "1983-04-05T16:44:23+08:00",
    "Grain Rain": "1983-04-20T23:50:09+08:00",
    "Start of Summer": "1983-05-06T10:10:51+08:00",
    "Grain Buds": "1983-05-21T23:06:26+08:00",
    "Grain in Ear": "1983-06-06T14:25:42+08:00",
    "Summer Solstice": "1983-06-22T07:08:41+08:00",
    "Minor Heat": "1983-07-08T00:43:13+08:00",
    "Major Heat": "1983-07-23T18:04:07+08:00",
    "Start of Autumn": "1983-08-08T10:29:37+08:00",
    "End of Heat": "1983-08-24T01:07:29+08:00",
    "White Dew": "1983-09-08T13:20:03+08:00",
    "Autumn Equinox": "1983-09-23T22:41:37+08:00",
    "Cold Dew": "1983-10-09T04:51:04+08:00",
    "Frost's Descent": "1983-10-24T07:54:17+08:00",
    "Start of Winter": "1983-11-08T07:52:12+08:00",
    "Minor Snow": "1983-11-23T05:18:20+08:00",
    "Major Snow": "1983-12-08T00:33:40+08:00",
    "Winter Solstice": "1983-12-22T18:29:55+08:00",
    "Minor Cold": "1984-01-06T11:40:51+08:00",
    "Major Cold": "1984-01-21T05:05:02+08:00"
  },
  
  // 1984
  1984: {
    "Start of Spring": "1984-02-04T23:18:44+08:00",
    "Rain Water": "1984-02-19T19:16:13+08:00",
    "Awakening of Insects": "1984-03-05T17:24:39+08:00",
    "Spring Equinox": "1984-03-20T18:24:19+08:00",
    "Pure Brightness": "1984-04-04T22:22:20+08:00",
    "Grain Rain": "1984-04-20T05:38:06+08:00",
    "Start of Summer": "1984-05-05T15:50:57+08:00",
    "Grain Buds": "1984-05-21T04:57:36+08:00",
    "Grain in Ear": "1984-06-05T20:08:37+08:00",
    "Summer Solstice": "1984-06-21T13:02:14+08:00",
    "Minor Heat": "1984-07-07T06:29:06+08:00",
    "Major Heat": "1984-07-22T23:58:12+08:00",
    "Start of Autumn": "1984-08-07T16:17:53+08:00",
    "End of Heat": "1984-08-23T07:00:10+08:00",
    "White Dew": "1984-09-07T19:09:50+08:00",
    "Autumn Equinox": "1984-09-23T04:32:53+08:00",
    "Cold Dew": "1984-10-08T10:42:35+08:00",
    "Frost's Descent": "1984-10-23T13:45:39+08:00",
    "Start of Winter": "1984-11-07T13:45:32+08:00",
    "Minor Snow": "1984-11-22T11:10:38+08:00",
    "Major Snow": "1984-12-07T06:28:03+08:00",
    "Winter Solstice": "1984-12-22T00:22:48+08:00",
    "Minor Cold": "1985-01-05T17:35:05+08:00",
    "Major Cold": "1985-01-20T10:57:33+08:00"
  },
  
  // 1985
  1985: {
    "Start of Spring": "1985-02-04T05:11:47+08:00",
    "Rain Water": "1985-02-19T01:07:21+08:00",
    "Awakening of Insects": "1985-03-05T23:16:21+08:00",
    "Spring Equinox": "1985-03-21T00:13:43+08:00",
    "Pure Brightness": "1985-04-05T04:13:35+08:00",
    "Grain Rain": "1985-04-20T11:25:46+08:00",
    "Start of Summer": "1985-05-05T21:42:32+08:00",
    "Grain Buds": "1985-05-21T10:42:55+08:00",
    "Grain in Ear": "1985-06-06T01:59:56+08:00",
    "Summer Solstice": "1985-06-21T18:44:07+08:00",
    "Minor Heat": "1985-07-07T12:18:35+08:00",
    "Major Heat": "1985-07-23T05:36:26+08:00",
    "Start of Autumn": "1985-08-07T22:04:16+08:00",
    "End of Heat": "1985-08-23T12:35:41+08:00",
    "White Dew": "1985-09-08T00:53:01+08:00",
    "Autumn Equinox": "1985-09-23T10:07:27+08:00",
    "Cold Dew": "1985-10-08T16:24:33+08:00",
    "Frost's Descent": "1985-10-23T19:21:52+08:00",
    "Start of Winter": "1985-11-07T19:29:29+08:00",
    "Minor Snow": "1985-11-22T16:50:46+08:00",
    "Major Snow": "1985-12-07T12:16:21+08:00",
    "Winter Solstice": "1985-12-22T06:07:40+08:00",
    "Minor Cold": "1986-01-05T23:28:02+08:00",
    "Major Cold": "1986-01-20T16:46:12+08:00"
  },
  
  // 1986
  1986: {
    "Start of Spring": "1986-02-04T11:07:42+08:00",
    "Rain Water": "1986-02-19T06:57:31+08:00",
    "Awakening of Insects": "1986-03-06T05:12:08+08:00",
    "Spring Equinox": "1986-03-21T06:02:41+08:00",
    "Pure Brightness": "1986-04-05T10:06:07+08:00",
    "Grain Rain": "1986-04-20T17:12:08+08:00",
    "Start of Summer": "1986-05-06T03:30:36+08:00",
    "Grain Buds": "1986-05-21T16:27:55+08:00",
    "Grain in Ear": "1986-06-06T07:44:23+08:00",
    "Summer Solstice": "1986-06-22T00:29:57+08:00",
    "Minor Heat": "1986-07-07T18:00:45+08:00",
    "Major Heat": "1986-07-23T11:24:23+08:00",
    "Start of Autumn": "1986-08-08T03:45:36+08:00",
    "End of Heat": "1986-08-23T18:25:47+08:00",
    "White Dew": "1986-09-08T06:34:37+08:00",
    "Autumn Equinox": "1986-09-23T15:58:52+08:00",
    "Cold Dew": "1986-10-08T22:06:45+08:00",
    "Frost's Descent": "1986-10-24T01:14:11+08:00",
    "Start of Winter": "1986-11-08T01:12:49+08:00",
    "Minor Snow": "1986-11-22T22:44:20+08:00",
    "Major Snow": "1986-12-07T18:00:56+08:00",
    "Winter Solstice": "1986-12-22T12:02:07+08:00",
    "Minor Cold": "1987-01-06T05:13:00+08:00",
    "Major Cold": "1987-01-20T22:40:23+08:00"
  },
  
  // 1987
  1987: {
    "Start of Spring": "1987-02-04T16:51:40+08:00",
    "Rain Water": "1987-02-19T12:49:57+08:00",
    "Awakening of Insects": "1987-03-06T10:53:37+08:00",
    "Spring Equinox": "1987-03-21T11:51:58+08:00",
    "Pure Brightness": "1987-04-05T15:44:08+08:00",
    "Grain Rain": "1987-04-20T22:57:32+08:00",
    "Start of Summer": "1987-05-06T09:05:35+08:00",
    "Grain Buds": "1987-05-21T22:10:01+08:00",
    "Grain in Ear": "1987-06-06T13:18:58+08:00",
    "Summer Solstice": "1987-06-22T06:10:45+08:00",
    "Minor Heat": "1987-07-07T23:38:39+08:00",
    "Major Heat": "1987-07-23T17:06:02+08:00",
    "Start of Autumn": "1987-08-08T09:29:13+08:00",
    "End of Heat": "1987-08-24T00:09:50+08:00",
    "White Dew": "1987-09-08T12:24:07+08:00",
    "Autumn Equinox": "1987-09-23T21:45:16+08:00",
    "Cold Dew": "1987-10-09T03:59:40+08:00",
    "Frost's Descent": "1987-10-24T07:00:52+08:00",
    "Start of Winter": "1987-11-08T07:05:40+08:00",
    "Minor Snow": "1987-11-23T04:29:23+08:00",
    "Major Snow": "1987-12-07T23:52:12+08:00",
    "Winter Solstice": "1987-12-22T17:45:52+08:00",
    "Minor Cold": "1988-01-06T11:03:30+08:00",
    "Major Cold": "1988-01-21T04:24:17+08:00"
  },
  
  // 1988
  1988: {
    "Start of Spring": "1988-02-04T22:42:49+08:00",
    "Rain Water": "1988-02-19T18:35:07+08:00",
    "Awakening of Insects": "1988-03-05T16:46:32+08:00",
    "Spring Equinox": "1988-03-20T17:38:35+08:00",
    "Pure Brightness": "1988-04-04T21:39:04+08:00",
    "Grain Rain": "1988-04-20T04:44:47+08:00",
    "Start of Summer": "1988-05-05T15:01:43+08:00",
    "Grain Buds": "1988-05-21T03:56:40+08:00",
    "Grain in Ear": "1988-06-05T19:14:53+08:00",
    "Summer Solstice": "1988-06-21T11:56:31+08:00",
    "Minor Heat": "1988-07-07T05:32:54+08:00",
    "Major Heat": "1988-07-22T22:51:05+08:00",
    "Start of Autumn": "1988-08-07T15:20:15+08:00",
    "End of Heat": "1988-08-23T05:54:00+08:00",
    "White Dew": "1988-09-07T18:11:31+08:00",
    "Autumn Equinox": "1988-09-23T03:28:50+08:00",
    "Cold Dew": "1988-10-08T09:44:30+08:00",
    "Frost's Descent": "1988-10-23T12:44:06+08:00",
    "Start of Winter": "1988-11-07T12:48:55+08:00",
    "Minor Snow": "1988-11-22T10:11:59+08:00",
    "Major Snow": "1988-12-07T05:34:28+08:00",
    "Winter Solstice": "1988-12-21T23:27:53+08:00",
    "Minor Cold": "1989-01-05T16:45:55+08:00",
    "Major Cold": "1989-01-20T10:06:59+08:00"
  },
  
  // 1989
  1989: {
    "Start of Spring": "1989-02-04T04:27:09+08:00",
    "Rain Water": "1989-02-19T00:20:30+08:00",
    "Awakening of Insects": "1989-03-05T22:34:08+08:00",
    "Spring Equinox": "1989-03-20T23:28:15+08:00",
    "Pure Brightness": "1989-04-05T03:29:54+08:00",
    "Grain Rain": "1989-04-20T10:38:56+08:00",
    "Start of Summer": "1989-05-05T20:53:55+08:00",
    "Grain Buds": "1989-05-21T09:53:32+08:00",
    "Grain in Ear": "1989-06-06T01:05:13+08:00",
    "Summer Solstice": "1989-06-21T17:53:00+08:00",
    "Minor Heat": "1989-07-07T11:19:25+08:00",
    "Major Heat": "1989-07-23T04:45:28+08:00",
    "Start of Autumn": "1989-08-07T21:03:52+08:00",
    "End of Heat": "1989-08-23T11:46:13+08:00",
    "White Dew": "1989-09-07T23:53:53+08:00",
    "Autumn Equinox": "1989-09-23T09:19:37+08:00",
    "Cold Dew": "1989-10-08T15:27:19+08:00",
    "Frost's Descent": "1989-10-23T18:35:08+08:00",
    "Start of Winter": "1989-11-07T18:33:32+08:00",
    "Minor Snow": "1989-11-22T16:04:37+08:00",
    "Major Snow": "1989-12-07T11:20:57+08:00",
    "Winter Solstice": "1989-12-22T05:22:00+08:00",
    "Minor Cold": "1990-01-05T22:33:14+08:00",
    "Major Cold": "1990-01-20T16:01:33+08:00"
  },
  
  // 1990
  1990: {
    "Start of Spring": "1990-02-04T10:14:00+08:00",
    "Rain Water": "1990-02-19T06:14:01+08:00",
    "Awakening of Insects": "1990-03-06T04:19:18+08:00",
    "Spring Equinox": "1990-03-21T05:19:15+08:00",
    "Pure Brightness": "1990-04-05T09:12:56+08:00",
    "Grain Rain": "1990-04-20T16:26:32+08:00",
    "Start of Summer": "1990-05-06T02:35:26+08:00",
    "Grain Buds": "1990-05-21T15:37:23+08:00",
    "Grain in Ear": "1990-06-06T06:46:18+08:00",
    "Summer Solstice": "1990-06-21T23:32:46+08:00",
    "Minor Heat": "1990-07-07T17:00:28+08:00",
    "Major Heat": "1990-07-23T10:21:30+08:00",
    "Start of Autumn": "1990-08-08T02:45:32+08:00",
    "End of Heat": "1990-08-23T17:20:49+08:00",
    "White Dew": "1990-09-08T05:37:28+08:00",
    "Autumn Equinox": "1990-09-23T14:55:29+08:00",
    "Cold Dew": "1990-10-08T21:13:49+08:00",
    "Frost's Descent": "1990-10-24T00:13:56+08:00",
    "Start of Winter": "1990-11-08T00:23:30+08:00",
    "Minor Snow": "1990-11-22T21:46:55+08:00",
    "Major Snow": "1990-12-07T17:14:10+08:00",
    "Winter Solstice": "1990-12-22T11:06:59+08:00",
    "Minor Cold": "1991-01-06T04:28:07+08:00",
    "Major Cold": "1991-01-20T21:47:05+08:00"
  },
  
  // 1991
  1991: {
    "Start of Spring": "1991-02-04T16:08:24+08:00",
    "Rain Water": "1991-02-19T11:58:20+08:00",
    "Awakening of Insects": "1991-03-06T10:12:15+08:00",
    "Spring Equinox": "1991-03-21T11:01:56+08:00",
    "Pure Brightness": "1991-04-05T15:04:42+08:00",
    "Grain Rain": "1991-04-20T22:08:23+08:00",
    "Start of Summer": "1991-05-06T08:26:53+08:00",
    "Grain Buds": "1991-05-21T21:20:14+08:00",
    "Grain in Ear": "1991-06-06T12:38:17+08:00",
    "Summer Solstice": "1991-06-22T05:18:47+08:00",
    "Minor Heat": "1991-07-07T22:52:59+08:00",
    "Major Heat": "1991-07-23T16:11:08+08:00",
    "Start of Autumn": "1991-08-08T08:37:15+08:00",
    "End of Heat": "1991-08-23T23:12:51+08:00",
    "White Dew": "1991-09-08T11:27:21+08:00",
    "Autumn Equinox": "1991-09-23T20:48:06+08:00",
    "Cold Dew": "1991-10-09T03:01:07+08:00",
    "Frost's Descent": "1991-10-24T06:05:10+08:00",
    "Start of Winter": "1991-11-08T06:07:50+08:00",
    "Minor Snow": "1991-11-23T03:35:45+08:00",
    "Major Snow": "1991-12-07T22:56:00+08:00",
    "Winter Solstice": "1991-12-22T16:53:38+08:00",
    "Minor Cold": "1992-01-06T10:08:31+08:00",
    "Major Cold": "1992-01-21T03:32:29+08:00"
  },
  
  // 1992
  1992: {
    "Start of Spring": "1992-02-04T21:48:17+08:00",
    "Rain Water": "1992-02-19T17:43:30+08:00",
    "Awakening of Insects": "1992-03-05T15:52:08+08:00",
    "Spring Equinox": "1992-03-20T16:48:04+08:00",
    "Pure Brightness": "1992-04-04T20:45:08+08:00",
    "Grain Rain": "1992-04-20T03:56:53+08:00",
    "Start of Summer": "1992-05-05T14:08:40+08:00",
    "Grain Buds": "1992-05-21T03:12:08+08:00",
    "Grain in Ear": "1992-06-05T18:22:19+08:00",
    "Summer Solstice": "1992-06-21T11:14:08+08:00",
    "Minor Heat": "1992-07-07T04:40:15+08:00",
    "Major Heat": "1992-07-22T22:08:49+08:00",
    "Start of Autumn": "1992-08-07T14:27:24+08:00",
    "End of Heat": "1992-08-23T05:10:06+08:00",
    "White Dew": "1992-09-07T17:18:20+08:00",
    "Autumn Equinox": "1992-09-23T02:42:46+08:00",
    "Cold Dew": "1992-10-08T08:51:29+08:00",
    "Frost's Descent": "1992-10-23T11:57:07+08:00",
    "Start of Winter": "1992-11-07T11:57:02+08:00",
    "Minor Snow": "1992-11-22T09:25:51+08:00",
    "Major Snow": "1992-12-07T04:44:12+08:00",
    "Winter Solstice": "1992-12-21T22:43:13+08:00",
    "Minor Cold": "1993-01-05T15:56:31+08:00",
    "Major Cold": "1993-01-20T09:22:49+08:00"
  },
  
  // 1993
  1993: {
    "Start of Spring": "1993-02-04T03:37:09+08:00",
    "Rain Water": "1993-02-18T23:35:10+08:00",
    "Awakening of Insects": "1993-03-05T21:42:32+08:00",
    "Spring Equinox": "1993-03-20T22:40:39+08:00",
    "Pure Brightness": "1993-04-05T02:37:11+08:00",
    "Grain Rain": "1993-04-20T09:49:01+08:00",
    "Start of Summer": "1993-05-05T20:01:43+08:00",
    "Grain Buds": "1993-05-21T09:01:43+08:00",
    "Grain in Ear": "1993-06-06T00:15:13+08:00",
    "Summer Solstice": "1993-06-21T16:59:44+08:00",
    "Minor Heat": "1993-07-07T10:32:02+08:00",
    "Major Heat": "1993-07-23T03:50:49+08:00",
    "Start of Autumn": "1993-08-07T20:17:58+08:00",
    "End of Heat": "1993-08-23T10:50:18+08:00",
    "White Dew": "1993-09-07T23:07:47+08:00",
    "Autumn Equinox": "1993-09-23T08:22:30+08:00",
    "Cold Dew": "1993-10-08T14:40:02+08:00",
    "Frost's Descent": "1993-10-23T17:37:08+08:00",
    "Start of Winter": "1993-11-07T17:45:33+08:00",
    "Minor Snow": "1993-11-22T15:06:51+08:00",
    "Major Snow": "1993-12-07T10:33:49+08:00",
    "Winter Solstice": "1993-12-22T04:25:48+08:00",
    "Minor Cold": "1994-01-05T21:48:07+08:00",
    "Major Cold": "1994-01-20T15:07:24+08:00"
  },
  
  // 1994
  1994: {
    "Start of Spring": "1994-02-04T09:30:56+08:00",
    "Rain Water": "1994-02-19T05:21:38+08:00",
    "Awakening of Insects": "1994-03-06T03:37:42+08:00",
    "Spring Equinox": "1994-03-21T04:28:01+08:00",
    "Pure Brightness": "1994-04-05T08:31:48+08:00",
    "Grain Rain": "1994-04-20T15:36:00+08:00",
    "Start of Summer": "1994-05-06T01:54:05+08:00",
    "Grain Buds": "1994-05-21T14:48:28+08:00",
    "Grain in Ear": "1994-06-06T06:04:52+08:00",
    "Summer Solstice": "1994-06-21T22:47:32+08:00",
    "Minor Heat": "1994-07-07T16:19:22+08:00",
    "Major Heat": "1994-07-23T09:41:00+08:00",
    "Start of Autumn": "1994-08-08T02:04:22+08:00",
    "End of Heat": "1994-08-23T16:43:45+08:00",
    "White Dew": "1994-09-08T04:55:07+08:00",
    "Autumn Equinox": "1994-09-23T14:19:13+08:00",
    "Cold Dew": "1994-10-08T20:29:05+08:00",
    "Frost's Descent": "1994-10-23T23:36:01+08:00",
    "Start of Winter": "1994-11-07T23:35:36+08:00",
    "Minor Snow": "1994-11-22T21:05:58+08:00",
    "Major Snow": "1994-12-07T16:22:53+08:00",
    "Winter Solstice": "1994-12-22T10:22:43+08:00",
    "Minor Cold": "1995-01-06T03:34:05+08:00",
    "Major Cold": "1995-01-20T21:00:27+08:00"
  },
  
  // 1995
  1995: {
    "Start of Spring": "1995-02-04T15:12:51+08:00",
    "Rain Water": "1995-02-19T11:10:44+08:00",
    "Awakening of Insects": "1995-03-06T09:16:04+08:00",
    "Spring Equinox": "1995-03-21T10:14:27+08:00",
    "Pure Brightness": "1995-04-05T14:08:06+08:00",
    "Grain Rain": "1995-04-20T21:21:29+08:00",
    "Start of Summer": "1995-05-06T07:30:03+08:00",
    "Grain Buds": "1995-05-21T20:34:11+08:00",
    "Grain in Ear": "1995-06-06T11:42:28+08:00",
    "Summer Solstice": "1995-06-22T04:34:22+08:00",
    "Minor Heat": "1995-07-07T22:01:00+08:00",
    "Major Heat": "1995-07-23T15:29:40+08:00",
    "Start of Autumn": "1995-08-08T07:51:44+08:00",
    "End of Heat": "1995-08-23T22:34:50+08:00",
    "White Dew": "1995-09-08T10:48:34+08:00",
    "Autumn Equinox": "1995-09-23T20:13:00+08:00",
    "Cold Dew": "1995-10-09T02:27:12+08:00",
    "Frost's Descent": "1995-10-24T05:31:31+08:00",
    "Start of Winter": "1995-11-08T05:35:35+08:00",
    "Minor Snow": "1995-11-23T03:01:23+08:00",
    "Major Snow": "1995-12-07T22:22:15+08:00",
    "Winter Solstice": "1995-12-22T16:16:47+08:00",
    "Minor Cold": "1996-01-06T09:31:27+08:00",
    "Major Cold": "1996-01-21T02:52:30+08:00"
  },
  
  // 1996
  1996: {
    "Start of Spring": "1996-02-04T21:07:54+08:00",
    "Rain Water": "1996-02-19T17:00:43+08:00",
    "Awakening of Insects": "1996-03-05T15:09:39+08:00",
    "Spring Equinox": "1996-03-20T16:03:04+08:00",
    "Pure Brightness": "1996-04-04T20:02:01+08:00",
    "Grain Rain": "1996-04-20T03:09:53+08:00",
    "Start of Summer": "1996-05-05T13:26:02+08:00",
    "Grain Buds": "1996-05-21T02:23:06+08:00",
    "Grain in Ear": "1996-06-05T17:40:47+08:00",
    "Summer Solstice": "1996-06-21T10:23:44+08:00",
    "Minor Heat": "1996-07-07T04:00:00+08:00",
    "Major Heat": "1996-07-22T21:18:42+08:00",
    "Start of Autumn": "1996-08-07T13:48:49+08:00",
    "End of Heat": "1996-08-23T04:22:50+08:00",
    "White Dew": "1996-09-07T16:42:25+08:00",
    "Autumn Equinox": "1996-09-23T02:00:06+08:00",
    "Cold Dew": "1996-10-08T08:18:42+08:00",
    "Frost's Descent": "1996-10-23T11:18:42+08:00",
    "Start of Winter": "1996-11-07T11:26:33+08:00",
    "Minor Snow": "1996-11-22T08:49:24+08:00",
    "Major Snow": "1996-12-07T04:14:00+08:00",
    "Winter Solstice": "1996-12-21T22:05:53+08:00",
    "Minor Cold": "1997-01-05T15:24:28+08:00",
    "Major Cold": "1997-01-20T08:42:31+08:00"
  },
  
  // 1997
  1997: {
    "Start of Spring": "1997-02-04T03:01:57+08:00",
    "Rain Water": "1997-02-18T22:51:29+08:00",
    "Awakening of Insects": "1997-03-05T21:04:07+08:00",
    "Spring Equinox": "1997-03-20T21:54:40+08:00",
    "Pure Brightness": "1997-04-05T01:56:16+08:00",
    "Grain Rain": "1997-04-20T09:02:49+08:00",
    "Start of Summer": "1997-05-05T19:19:26+08:00",
    "Grain Buds": "1997-05-21T08:17:53+08:00",
    "Grain in Ear": "1997-06-05T23:32:31+08:00",
    "Summer Solstice": "1997-06-21T16:19:56+08:00",
    "Minor Heat": "1997-07-07T09:49:23+08:00",
    "Major Heat": "1997-07-23T03:15:26+08:00",
    "Start of Autumn": "1997-08-07T19:36:18+08:00",
    "End of Heat": "1997-08-23T10:19:11+08:00",
    "White Dew": "1997-09-07T22:28:49+08:00",
    "Autumn Equinox": "1997-09-23T07:55:47+08:00",
    "Cold Dew": "1997-10-08T14:05:10+08:00",
    "Frost's Descent": "1997-10-23T17:14:45+08:00",
    "Start of Winter": "1997-11-07T17:14:38+08:00",
    "Minor Snow": "1997-11-22T14:47:33+08:00",
    "Major Snow": "1997-12-07T10:04:52+08:00",
    "Winter Solstice": "1997-12-22T04:07:02+08:00",
    "Minor Cold": "1998-01-05T21:18:09+08:00",
    "Major Cold": "1998-01-20T14:46:04+08:00"
  },
  
  // 1998
  1998: {
    "Start of Spring": "1998-02-04T08:56:52+08:00",
    "Rain Water": "1998-02-19T04:54:53+08:00",
    "Awakening of Insects": "1998-03-06T02:57:15+08:00",
    "Spring Equinox": "1998-03-21T03:54:32+08:00",
    "Pure Brightness": "1998-04-05T07:44:57+08:00",
    "Grain Rain": "1998-04-20T14:56:43+08:00",
    "Start of Summer": "1998-05-06T01:03:10+08:00",
    "Grain Buds": "1998-05-21T14:05:26+08:00",
    "Grain in Ear": "1998-06-06T05:13:22+08:00",
    "Summer Solstice": "1998-06-21T22:02:34+08:00",
    "Minor Heat": "1998-07-07T15:30:25+08:00",
    "Major Heat": "1998-07-23T08:55:22+08:00",
    "Start of Autumn": "1998-08-08T01:19:50+08:00",
    "End of Heat": "1998-08-23T15:58:56+08:00",
    "White Dew": "1998-09-08T04:15:55+08:00",
    "Autumn Equinox": "1998-09-23T13:37:11+08:00",
    "Cold Dew": "1998-10-08T19:55:45+08:00",
    "Frost's Descent": "1998-10-23T22:58:35+08:00",
    "Start of Winter": "1998-11-07T23:08:23+08:00",
    "Minor Snow": "1998-11-22T20:34:12+08:00",
    "Major Snow": "1998-12-07T16:01:35+08:00",
    "Winter Solstice": "1998-12-22T09:56:27+08:00",
    "Minor Cold": "1999-01-06T03:17:09+08:00",
    "Major Cold": "1999-01-20T20:37:21+08:00"
  },
  
  // 1999
  1999: {
    "Start of Spring": "1999-02-04T14:57:03+08:00",
    "Rain Water": "1999-02-19T10:46:50+08:00",
    "Awakening of Insects": "1999-03-06T08:57:42+08:00",
    "Spring Equinox": "1999-03-21T09:45:50+08:00",
    "Pure Brightness": "1999-04-05T13:44:37+08:00",
    "Grain Rain": "1999-04-20T20:46:00+08:00",
    "Start of Summer": "1999-05-06T07:01:00+08:00",
    "Grain Buds": "1999-05-21T19:52:25+08:00",
    "Grain in Ear": "1999-06-06T11:09:07+08:00",
    "Summer Solstice": "1999-06-22T03:49:07+08:00",
    "Minor Heat": "1999-07-07T21:24:59+08:00",
    "Major Heat": "1999-07-23T14:44:06+08:00",
    "Start of Autumn": "1999-08-08T07:14:06+08:00",
    "End of Heat": "1999-08-23T21:51:05+08:00",
    "White Dew": "1999-09-08T10:09:59+08:00",
    "Autumn Equinox": "1999-09-23T19:31:31+08:00",
    "Cold Dew": "1999-10-09T01:48:21+08:00",
    "Frost's Descent": "1999-10-24T04:52:14+08:00",
    "Start of Winter": "1999-11-08T04:57:51+08:00",
    "Minor Snow": "1999-11-23T02:24:50+08:00",
    "Major Snow": "1999-12-07T21:47:27+08:00",
    "Winter Solstice": "1999-12-22T15:43:48+08:00",
    "Minor Cold": "2000-01-06T09:00:42+08:00",
    "Major Cold": "2000-01-21T02:23:03+08:00"
  },
  
  // 2000
  2000: {
    "Start of Spring": "2000-02-04T20:40:24+08:00",
    "Rain Water": "2000-02-19T16:33:18+08:00",
    "Awakening of Insects": "2000-03-05T14:42:40+08:00",
    "Spring Equinox": "2000-03-20T15:35:15+08:00",
    "Pure Brightness": "2000-04-04T19:31:58+08:00",
    "Grain Rain": "2000-04-20T02:39:30+08:00",
    "Start of Summer": "2000-05-05T12:50:10+08:00",
    "Grain Buds": "2000-05-21T01:49:24+08:00",
    "Grain in Ear": "2000-06-05T16:58:34+08:00",
    "Summer Solstice": "2000-06-21T09:47:43+08:00",
    "Minor Heat": "2000-07-07T03:13:56+08:00",
    "Major Heat": "2000-07-22T20:42:41+08:00",
    "Start of Autumn": "2000-08-07T13:02:59+08:00",
    "End of Heat": "2000-08-23T03:48:31+08:00",
    "White Dew": "2000-09-07T15:59:10+08:00",
    "Autumn Equinox": "2000-09-23T01:27:35+08:00",
    "Cold Dew": "2000-10-08T07:38:13+08:00",
    "Frost's Descent": "2000-10-23T10:47:28+08:00",
    "Start of Winter": "2000-11-07T10:48:04+08:00",
    "Minor Snow": "2000-11-22T08:19:20+08:00",
    "Major Snow": "2000-12-07T03:37:02+08:00",
    "Winter Solstice": "2000-12-21T21:37:26+08:00",
    "Minor Cold": "2001-01-05T14:49:16+08:00",
    "Major Cold": "2001-01-20T08:16:18+08:00"
  },
  
  // 2001
  2001: {
    "Start of Spring": "2001-02-04T02:28:49+08:00",
    "Rain Water": "2001-02-18T22:27:16+08:00",
    "Awakening of Insects": "2001-03-05T20:32:28+08:00",
    "Spring Equinox": "2001-03-20T21:30:44+08:00",
    "Pure Brightness": "2001-04-05T01:24:22+08:00",
    "Grain Rain": "2001-04-20T08:35:53+08:00",
    "Start of Summer": "2001-05-05T18:44:50+08:00",
    "Grain Buds": "2001-05-21T07:44:12+08:00",
    "Grain in Ear": "2001-06-05T22:53:35+08:00",
    "Summer Solstice": "2001-06-21T15:37:43+08:00",
    "Minor Heat": "2001-07-07T09:06:42+08:00",
    "Major Heat": "2001-07-23T02:26:14+08:00",
    "Start of Autumn": "2001-08-07T18:52:21+08:00",
    "End of Heat": "2001-08-23T09:27:08+08:00",
    "White Dew": "2001-09-07T21:46:11+08:00",
    "Autumn Equinox": "2001-09-23T07:04:28+08:00",
    "Cold Dew": "2001-10-08T13:25:01+08:00",
    "Frost's Descent": "2001-10-23T16:25:36+08:00",
    "Start of Winter": "2001-11-07T16:36:52+08:00",
    "Minor Snow": "2001-11-22T14:00:28+08:00",
    "Major Snow": "2001-12-07T09:28:53+08:00",
    "Winter Solstice": "2001-12-22T03:21:30+08:00",
    "Minor Cold": "2002-01-05T20:43:30+08:00",
    "Major Cold": "2002-01-20T14:02:01+08:00"
  },
  
  // 2002
  2002: {
    "Start of Spring": "2002-02-04T08:24:05+08:00",
    "Rain Water": "2002-02-19T04:13:18+08:00",
    "Awakening of Insects": "2002-03-06T02:27:33+08:00",
    "Spring Equinox": "2002-03-21T03:16:07+08:00",
    "Pure Brightness": "2002-04-05T07:18:17+08:00",
    "Grain Rain": "2002-04-20T14:20:28+08:00",
    "Start of Summer": "2002-05-06T00:37:18+08:00",
    "Grain Buds": "2002-05-21T13:29:06+08:00",
    "Grain in Ear": "2002-06-06T04:44:46+08:00",
    "Summer Solstice": "2002-06-21T21:24:24+08:00",
    "Minor Heat": "2002-07-07T14:56:11+08:00",
    "Major Heat": "2002-07-23T08:14:51+08:00",
    "Start of Autumn": "2002-08-08T00:39:18+08:00",
    "End of Heat": "2002-08-23T15:16:58+08:00",
    "White Dew": "2002-09-08T03:31:02+08:00",
    "Autumn Equinox": "2002-09-23T12:55:23+08:00",
    "Cold Dew": "2002-10-08T19:09:18+08:00",
    "Frost's Descent": "2002-10-23T22:17:49+08:00",
    "Start of Winter": "2002-11-07T22:21:49+08:00",
    "Minor Snow": "2002-11-22T19:53:44+08:00",
    "Major Snow": "2002-12-07T15:14:14+08:00",
    "Winter Solstice": "2002-12-22T09:14:22+08:00",
    "Minor Cold": "2003-01-06T02:27:43+08:00",
    "Major Cold": "2003-01-20T19:52:35+08:00"
  },
  
  // 2003
  2003: {
    "Start of Spring": "2003-02-04T14:05:20+08:00",
    "Rain Water": "2003-02-19T10:00:13+08:00",
    "Awakening of Insects": "2003-03-06T08:04:52+08:00",
    "Spring Equinox": "2003-03-21T08:59:46+08:00",
    "Pure Brightness": "2003-04-05T12:52:29+08:00",
    "Grain Rain": "2003-04-20T20:02:48+08:00",
    "Start of Summer": "2003-05-06T06:10:29+08:00",
    "Grain Buds": "2003-05-21T19:12:25+08:00",
    "Grain in Ear": "2003-06-06T10:19:43+08:00",
    "Summer Solstice": "2003-06-22T03:10:28+08:00",
    "Minor Heat": "2003-07-07T20:35:39+08:00",
    "Major Heat": "2003-07-23T14:04:08+08:00",
    "Start of Autumn": "2003-08-08T06:24:18+08:00",
    "End of Heat": "2003-08-23T21:08:10+08:00",
    "White Dew": "2003-09-08T09:20:14+08:00",
    "Autumn Equinox": "2003-09-23T18:46:49+08:00",
    "Cold Dew": "2003-10-09T01:00:33+08:00",
    "Frost's Descent": "2003-10-24T04:08:27+08:00",
    "Start of Winter": "2003-11-08T04:13:11+08:00",
    "Minor Snow": "2003-11-23T01:43:21+08:00",
    "Major Snow": "2003-12-07T21:05:09+08:00",
    "Winter Solstice": "2003-12-22T15:03:48+08:00",
    "Minor Cold": "2004-01-06T08:18:33+08:00",
    "Major Cold": "2004-01-21T01:42:22+08:00"
  },
  
  // 2004
  2004: {
    "Start of Spring": "2004-02-04T19:56:13+08:00",
    "Rain Water": "2004-02-19T15:49:59+08:00",
    "Awakening of Insects": "2004-03-05T13:55:38+08:00",
    "Spring Equinox": "2004-03-20T14:48:38+08:00",
    "Pure Brightness": "2004-04-04T18:43:19+08:00",
    "Grain Rain": "2004-04-20T01:50:25+08:00",
    "Start of Summer": "2004-05-05T12:02:28+08:00",
    "Grain Buds": "2004-05-21T00:59:12+08:00",
    "Grain in Ear": "2004-06-05T16:13:46+08:00",
    "Summer Solstice": "2004-06-21T08:56:51+08:00",
    "Minor Heat": "2004-07-07T02:31:16+08:00",
    "Major Heat": "2004-07-22T19:50:09+08:00",
    "Start of Autumn": "2004-08-07T12:19:36+08:00",
    "End of Heat": "2004-08-23T02:53:15+08:00",
    "White Dew": "2004-09-07T15:12:55+08:00",
    "Autumn Equinox": "2004-09-23T00:29:50+08:00",
    "Cold Dew": "2004-10-08T06:49:18+08:00",
    "Frost's Descent": "2004-10-23T09:48:49+08:00",
    "Start of Winter": "2004-11-07T09:58:33+08:00",
    "Minor Snow": "2004-11-22T07:21:40+08:00",
    "Major Snow": "2004-12-07T02:48:57+08:00",
    "Winter Solstice": "2004-12-21T20:41:36+08:00",
    "Minor Cold": "2005-01-05T14:02:59+08:00",
    "Major Cold": "2005-01-20T07:21:34+08:00"
  },
  
  // 2005
  2005: {
    "Start of Spring": "2005-02-04T01:43:02+08:00",
    "Rain Water": "2005-02-18T21:31:57+08:00",
    "Awakening of Insects": "2005-03-05T19:45:10+08:00",
    "Spring Equinox": "2005-03-20T20:33:26+08:00",
    "Pure Brightness": "2005-04-05T00:34:17+08:00",
    "Grain Rain": "2005-04-20T07:37:15+08:00",
    "Start of Summer": "2005-05-05T17:52:50+08:00",
    "Grain Buds": "2005-05-21T06:47:24+08:00",
    "Grain in Ear": "2005-06-05T22:01:52+08:00",
    "Summer Solstice": "2005-06-21T14:46:07+08:00",
    "Minor Heat": "2005-07-07T08:16:34+08:00",
    "Major Heat": "2005-07-23T01:40:42+08:00",
    "Start of Autumn": "2005-08-07T18:03:21+08:00",
    "End of Heat": "2005-08-23T08:45:27+08:00",
    "White Dew": "2005-09-07T20:56:40+08:00",
    "Autumn Equinox": "2005-09-23T06:23:11+08:00",
    "Cold Dew": "2005-10-08T12:33:18+08:00",
    "Frost's Descent": "2005-10-23T15:42:20+08:00",
    "Start of Winter": "2005-11-07T15:42:26+08:00",
    "Minor Snow": "2005-11-22T13:14:58+08:00",
    "Major Snow": "2005-12-07T08:32:41+08:00",
    "Winter Solstice": "2005-12-22T02:34:56+08:00",
    "Minor Cold": "2006-01-05T19:46:57+08:00",
    "Major Cold": "2006-01-20T13:15:18+08:00"
  },
  
  // 2006
  2006: {
    "Start of Spring": "2006-02-04T07:27:16+08:00",
    "Rain Water": "2006-02-19T03:25:34+08:00",
    "Awakening of Insects": "2006-03-06T01:28:40+08:00",
    "Spring Equinox": "2006-03-21T02:25:34+08:00",
    "Pure Brightness": "2006-04-05T06:15:31+08:00",
    "Grain Rain": "2006-04-20T13:26:03+08:00",
    "Start of Summer": "2006-05-05T23:30:39+08:00",
    "Grain Buds": "2006-05-21T12:31:33+08:00",
    "Grain in Ear": "2006-06-06T03:36:59+08:00",
    "Summer Solstice": "2006-06-21T20:25:51+08:00",
    "Minor Heat": "2006-07-07T13:51:27+08:00",
    "Major Heat": "2006-07-23T07:17:42+08:00",
    "Start of Autumn": "2006-08-07T23:40:47+08:00",
    "End of Heat": "2006-08-23T14:22:34+08:00",
    "White Dew": "2006-09-08T02:39:01+08:00",
    "Autumn Equinox": "2006-09-23T12:03:22+08:00",
    "Cold Dew": "2006-10-08T18:21:23+08:00",
    "Frost's Descent": "2006-10-23T21:26:28+08:00",
    "Start of Winter": "2006-11-07T21:34:51+08:00",
    "Minor Snow": "2006-11-22T19:01:45+08:00",
    "Major Snow": "2006-12-07T14:26:49+08:00",
    "Winter Solstice": "2006-12-22T08:22:05+08:00",
    "Minor Cold": "2007-01-06T01:40:10+08:00",
    "Major Cold": "2007-01-20T19:00:49+08:00"
  },
  
  // 2007
  2007: {
    "Start of Spring": "2007-02-04T13:18:12+08:00",
    "Rain Water": "2007-02-19T09:08:56+08:00",
    "Awakening of Insects": "2007-03-06T07:17:59+08:00",
    "Spring Equinox": "2007-03-21T08:07:25+08:00",
    "Pure Brightness": "2007-04-05T12:04:39+08:00",
    "Grain Rain": "2007-04-20T19:07:05+08:00",
    "Start of Summer": "2007-05-06T05:20:23+08:00",
    "Grain Buds": "2007-05-21T18:11:56+08:00",
    "Grain in Ear": "2007-06-06T09:27:04+08:00",
    "Summer Solstice": "2007-06-22T02:06:26+08:00",
    "Minor Heat": "2007-07-07T19:41:44+08:00",
    "Major Heat": "2007-07-23T13:00:10+08:00",
    "Start of Autumn": "2007-08-08T05:31:14+08:00",
    "End of Heat": "2007-08-23T20:07:57+08:00",
    "White Dew": "2007-09-08T08:29:28+08:00",
    "Autumn Equinox": "2007-09-23T17:51:13+08:00",
    "Cold Dew": "2007-10-09T00:11:29+08:00",
    "Frost's Descent": "2007-10-24T03:15:23+08:00",
    "Start of Winter": "2007-11-08T03:24:01+08:00",
    "Minor Snow": "2007-11-23T00:49:53+08:00",
    "Major Snow": "2007-12-07T20:14:04+08:00",
    "Winter Solstice": "2007-12-22T14:07:48+08:00",
    "Minor Cold": "2008-01-06T07:24:50+08:00",
    "Major Cold": "2008-01-21T00:43:31+08:00"
  },
  
  // 2008
  2008: {
    "Start of Spring": "2008-02-04T19:00:24+08:00",
    "Rain Water": "2008-02-19T14:49:33+08:00",
    "Awakening of Insects": "2008-03-05T12:58:48+08:00",
    "Spring Equinox": "2008-03-20T13:48:17+08:00",
    "Pure Brightness": "2008-04-04T17:45:51+08:00",
    "Grain Rain": "2008-04-20T00:51:08+08:00",
    "Start of Summer": "2008-05-05T11:03:25+08:00",
    "Grain Buds": "2008-05-21T00:00:53+08:00",
    "Grain in Ear": "2008-06-05T15:11:43+08:00",
    "Summer Solstice": "2008-06-21T07:59:21+08:00",
    "Minor Heat": "2008-07-07T01:26:49+08:00",
    "Major Heat": "2008-07-22T18:54:47+08:00",
    "Start of Autumn": "2008-08-07T11:16:10+08:00",
    "End of Heat": "2008-08-23T02:02:14+08:00",
    "White Dew": "2008-09-07T14:14:08+08:00",
    "Autumn Equinox": "2008-09-22T23:44:29+08:00",
    "Cold Dew": "2008-10-08T05:56:37+08:00",
    "Frost's Descent": "2008-10-23T09:08:38+08:00",
    "Start of Winter": "2008-11-07T09:10:33+08:00",
    "Minor Snow": "2008-11-22T06:44:19+08:00",
    "Major Snow": "2008-12-07T02:02:17+08:00",
    "Winter Solstice": "2008-12-21T20:03:45+08:00",
    "Minor Cold": "2009-01-05T13:14:07+08:00",
    "Major Cold": "2009-01-20T06:40:20+08:00"
  },
  
  // 2009
  2009: {
    "Start of Spring": "2009-02-04T00:49:47+08:00",
    "Rain Water": "2009-02-18T20:46:06+08:00",
    "Awakening of Insects": "2009-03-05T18:47:31+08:00",
    "Spring Equinox": "2009-03-20T19:43:38+08:00",
    "Pure Brightness": "2009-04-04T23:33:46+08:00",
    "Grain Rain": "2009-04-20T06:44:25+08:00",
    "Start of Summer": "2009-05-05T16:50:49+08:00",
    "Grain Buds": "2009-05-21T05:51:10+08:00",
    "Grain in Ear": "2009-06-05T20:59:03+08:00",
    "Summer Solstice": "2009-06-21T13:45:30+08:00",
    "Minor Heat": "2009-07-07T07:13:29+08:00",
    "Major Heat": "2009-07-23T00:35:42+08:00",
    "Start of Autumn": "2009-08-07T17:01:09+08:00",
    "End of Heat": "2009-08-23T07:38:33+08:00",
    "White Dew": "2009-09-07T19:57:36+08:00",
    "Autumn Equinox": "2009-09-23T05:18:35+08:00",
    "Cold Dew": "2009-10-08T11:40:03+08:00",
    "Frost's Descent": "2009-10-23T14:43:28+08:00",
    "Start of Winter": "2009-11-07T14:56:15+08:00",
    "Minor Snow": "2009-11-22T12:22:33+08:00",
    "Major Snow": "2009-12-07T07:52:14+08:00",
    "Winter Solstice": "2009-12-22T01:46:47+08:00",
    "Minor Cold": "2010-01-05T19:08:46+08:00",
    "Major Cold": "2010-01-20T12:27:41+08:00"
  },
  
  // 2010
  2010: {
    "Start of Spring": "2010-02-04T06:47:51+08:00",
    "Rain Water": "2010-02-19T02:35:37+08:00",
    "Awakening of Insects": "2010-03-06T00:46:21+08:00",
    "Spring Equinox": "2010-03-21T01:32:12+08:00",
    "Pure Brightness": "2010-04-05T05:30:29+08:00",
    "Grain Rain": "2010-04-20T12:29:48+08:00",
    "Start of Summer": "2010-05-05T22:44:01+08:00",
    "Grain Buds": "2010-05-21T11:33:53+08:00",
    "Grain in Ear": "2010-06-06T02:49:23+08:00",
    "Summer Solstice": "2010-06-21T19:28:24+08:00",
    "Minor Heat": "2010-07-07T13:02:23+08:00",
    "Major Heat": "2010-07-23T06:21:12+08:00",
    "Start of Autumn": "2010-08-07T22:49:07+08:00",
    "End of Heat": "2010-08-23T13:26:57+08:00",
    "White Dew": "2010-09-08T01:44:40+08:00",
    "Autumn Equinox": "2010-09-23T11:09:02+08:00",
    "Cold Dew": "2010-10-08T17:26:29+08:00",
    "Frost's Descent": "2010-10-23T20:35:04+08:00",
    "Start of Winter": "2010-11-07T20:42:29+08:00",
    "Minor Snow": "2010-11-22T18:14:33+08:00",
    "Major Snow": "2010-12-07T13:38:22+08:00",
    "Winter Solstice": "2010-12-22T07:38:27+08:00",
    "Minor Cold": "2011-01-06T00:54:37+08:00",
    "Major Cold": "2011-01-20T18:18:32+08:00"
  },
  
  // 2011
  2011: {
    "Start of Spring": "2011-02-04T12:32:56+08:00",
    "Rain Water": "2011-02-19T08:25:19+08:00",
    "Awakening of Insects": "2011-03-06T06:29:58+08:00",
    "Spring Equinox": "2011-03-21T07:20:44+08:00",
    "Pure Brightness": "2011-04-05T11:11:58+08:00",
    "Grain Rain": "2011-04-20T18:17:26+08:00",
    "Start of Summer": "2011-05-06T04:23:12+08:00",
    "Grain Buds": "2011-05-21T17:21:10+08:00",
    "Grain in Ear": "2011-06-06T08:27:20+08:00",
    "Summer Solstice": "2011-06-22T01:16:29+08:00",
    "Minor Heat": "2011-07-07T18:42:00+08:00",
    "Major Heat": "2011-07-23T12:11:48+08:00",
    "Start of Autumn": "2011-08-08T04:33:26+08:00",
    "End of Heat": "2011-08-23T19:20:38+08:00",
    "White Dew": "2011-09-08T07:34:13+08:00",
    "Autumn Equinox": "2011-09-23T17:04:37+08:00",
    "Cold Dew": "2011-10-08T23:19:05+08:00",
    "Frost's Descent": "2011-10-24T02:30:18+08:00",
    "Start of Winter": "2011-11-08T02:34:55+08:00",
    "Minor Snow": "2011-11-23T00:07:48+08:00",
    "Major Snow": "2011-12-07T19:28:59+08:00",
    "Winter Solstice": "2011-12-22T13:30:01+08:00",
    "Minor Cold": "2012-01-06T06:43:54+08:00",
    "Major Cold": "2012-01-21T00:09:49+08:00"
  },
  
  // 2012
  2012: {
    "Start of Spring": "2012-02-04T18:22:23+08:00",
    "Rain Water": "2012-02-19T14:17:35+08:00",
    "Awakening of Insects": "2012-03-05T12:21:02+08:00",
    "Spring Equinox": "2012-03-20T13:14:25+08:00",
    "Pure Brightness": "2012-04-04T17:05:36+08:00",
    "Grain Rain": "2012-04-20T00:12:04+08:00",
    "Start of Summer": "2012-05-05T10:19:40+08:00",
    "Grain Buds": "2012-05-20T23:15:31+08:00",
    "Grain in Ear": "2012-06-05T14:25:53+08:00",
    "Summer Solstice": "2012-06-21T07:08:48+08:00",
    "Minor Heat": "2012-07-07T00:40:43+08:00",
    "Major Heat": "2012-07-22T18:00:51+08:00",
    "Start of Autumn": "2012-08-07T10:30:32+08:00",
    "End of Heat": "2012-08-23T01:06:50+08:00",
    "White Dew": "2012-09-07T13:29:00+08:00",
    "Autumn Equinox": "2012-09-22T22:48:59+08:00",
    "Cold Dew": "2012-10-08T05:11:42+08:00",
    "Frost's Descent": "2012-10-23T08:13:33+08:00",
    "Start of Winter": "2012-11-07T08:25:56+08:00",
    "Minor Snow": "2012-11-22T05:50:07+08:00",
    "Major Snow": "2012-12-07T01:18:55+08:00",
    "Winter Solstice": "2012-12-21T19:11:35+08:00",
    "Minor Cold": "2013-01-05T12:33:37+08:00",
    "Major Cold": "2013-01-20T05:51:42+08:00"
  },
  
  // 2013
  2013: {
    "Start of Spring": "2013-02-04T00:13:25+08:00",
    "Rain Water": "2013-02-18T20:01:35+08:00",
    "Awakening of Insects": "2013-03-05T18:14:51+08:00",
    "Spring Equinox": "2013-03-20T19:01:55+08:00",
    "Pure Brightness": "2013-04-04T23:02:27+08:00",
    "Grain Rain": "2013-04-20T06:03:18+08:00",
    "Start of Summer": "2013-05-05T16:18:09+08:00",
    "Grain Buds": "2013-05-21T05:09:30+08:00",
    "Grain in Ear": "2013-06-05T20:23:19+08:00",
    "Summer Solstice": "2013-06-21T13:03:56+08:00",
    "Minor Heat": "2013-07-07T06:34:36+08:00",
    "Major Heat": "2013-07-22T23:55:58+08:00",
    "Start of Autumn": "2013-08-07T16:20:21+08:00",
    "End of Heat": "2013-08-23T07:01:41+08:00",
    "White Dew": "2013-09-07T19:16:16+08:00",
    "Autumn Equinox": "2013-09-23T04:44:08+08:00",
    "Cold Dew": "2013-10-08T10:58:29+08:00",
    "Frost's Descent": "2013-10-23T14:09:48+08:00",
    "Start of Winter": "2013-11-07T14:13:52+08:00",
    "Minor Snow": "2013-11-22T11:48:06+08:00",
    "Major Snow": "2013-12-07T07:08:31+08:00",
    "Winter Solstice": "2013-12-22T01:10:59+08:00",
    "Minor Cold": "2014-01-05T18:24:10+08:00",
    "Major Cold": "2014-01-20T11:51:14+08:00"
  },
  
  // 2014
  2014: {
    "Start of Spring": "2014-02-04T06:03:15+08:00",
    "Rain Water": "2014-02-19T01:59:29+08:00",
    "Awakening of Insects": "2014-03-06T00:02:15+08:00",
    "Spring Equinox": "2014-03-21T00:57:06+08:00",
    "Pure Brightness": "2014-04-05T04:46:39+08:00",
    "Grain Rain": "2014-04-20T11:55:32+08:00",
    "Start of Summer": "2014-05-05T21:59:25+08:00",
    "Grain Buds": "2014-05-21T10:59:02+08:00",
    "Grain in Ear": "2014-06-06T02:03:02+08:00",
    "Summer Solstice": "2014-06-21T18:51:13+08:00",
    "Minor Heat": "2014-07-07T12:14:45+08:00",
    "Major Heat": "2014-07-23T05:41:21+08:00",
    "Start of Autumn": "2014-08-07T22:02:28+08:00",
    "End of Heat": "2014-08-23T12:45:58+08:00",
    "White Dew": "2014-09-08T01:01:25+08:00",
    "Autumn Equinox": "2014-09-23T10:29:04+08:00",
    "Cold Dew": "2014-10-08T16:47:29+08:00",
    "Frost's Descent": "2014-10-23T19:57:03+08:00",
    "Start of Winter": "2014-11-07T20:06:40+08:00",
    "Minor Snow": "2014-11-22T17:38:11+08:00",
    "Major Snow": "2014-12-07T13:04:05+08:00",
    "Winter Solstice": "2014-12-22T07:03:01+08:00",
    "Minor Cold": "2015-01-06T00:20:32+08:00",
    "Major Cold": "2015-01-20T17:43:14+08:00"
  },
  
  // 2015
  2015: {
    "Start of Spring": "2015-02-04T11:58:27+08:00",
    "Rain Water": "2015-02-19T07:49:47+08:00",
    "Awakening of Insects": "2015-03-06T05:55:39+08:00",
    "Spring Equinox": "2015-03-21T06:45:07+08:00",
    "Pure Brightness": "2015-04-05T10:39:07+08:00",
    "Grain Rain": "2015-04-20T17:41:50+08:00",
    "Start of Summer": "2015-05-06T03:52:35+08:00",
    "Grain Buds": "2015-05-21T16:44:45+08:00",
    "Grain in Ear": "2015-06-06T07:58:09+08:00",
    "Summer Solstice": "2015-06-22T00:37:53+08:00",
    "Minor Heat": "2015-07-07T18:12:14+08:00",
    "Major Heat": "2015-07-23T11:30:25+08:00",
    "Start of Autumn": "2015-08-08T04:01:23+08:00",
    "End of Heat": "2015-08-23T18:37:15+08:00",
    "White Dew": "2015-09-08T06:59:33+08:00",
    "Autumn Equinox": "2015-09-23T16:20:31+08:00",
    "Cold Dew": "2015-10-08T22:42:47+08:00",
    "Frost's Descent": "2015-10-24T01:46:41+08:00",
    "Start of Winter": "2015-11-08T01:58:36+08:00",
    "Minor Snow": "2015-11-22T23:25:15+08:00",
    "Major Snow": "2015-12-07T18:53:19+08:00",
    "Winter Solstice": "2015-12-22T12:47:55+08:00",
    "Minor Cold": "2016-01-06T06:08:21+08:00",
    "Major Cold": "2016-01-20T23:27:04+08:00"
  },
  
  // 2016
  2016: {
    "Start of Spring": "2016-02-04T17:46:00+08:00",
    "Rain Water": "2016-02-19T13:33:41+08:00",
    "Awakening of Insects": "2016-03-05T11:43:30+08:00",
    "Spring Equinox": "2016-03-20T12:30:08+08:00",
    "Pure Brightness": "2016-04-04T16:27:29+08:00",
    "Grain Rain": "2016-04-19T23:29:23+08:00",
    "Start of Summer": "2016-05-05T09:41:50+08:00",
    "Grain Buds": "2016-05-20T22:36:26+08:00",
    "Grain in Ear": "2016-06-05T13:48:28+08:00",
    "Summer Solstice": "2016-06-21T06:34:09+08:00",
    "Minor Heat": "2016-07-07T00:03:18+08:00",
    "Major Heat": "2016-07-22T17:30:10+08:00",
    "Start of Autumn": "2016-08-07T09:52:58+08:00",
    "End of Heat": "2016-08-23T00:38:26+08:00",
    "White Dew": "2016-09-07T12:51:02+08:00",
    "Autumn Equinox": "2016-09-22T22:21:05+08:00",
    "Cold Dew": "2016-10-08T04:33:20+08:00",
    "Frost's Descent": "2016-10-23T07:45:30+08:00",
    "Start of Winter": "2016-11-07T07:47:38+08:00",
    "Minor Snow": "2016-11-22T05:22:20+08:00",
    "Major Snow": "2016-12-07T00:41:05+08:00",
    "Winter Solstice": "2016-12-21T18:44:07+08:00",
    "Minor Cold": "2017-01-05T11:55:42+08:00",
    "Major Cold": "2017-01-20T05:23:33+08:00"
  },
  
  // 2017
  2017: {
    "Start of Spring": "2017-02-03T23:34:01+08:00",
    "Rain Water": "2017-02-18T19:31:16+08:00",
    "Awakening of Insects": "2017-03-05T17:32:40+08:00",
    "Spring Equinox": "2017-03-20T18:28:35+08:00",
    "Pure Brightness": "2017-04-04T22:17:16+08:00",
    "Grain Rain": "2017-04-20T05:26:58+08:00",
    "Start of Summer": "2017-05-05T15:30:59+08:00",
    "Grain Buds": "2017-05-21T04:30:53+08:00",
    "Grain in Ear": "2017-06-05T19:36:33+08:00",
    "Summer Solstice": "2017-06-21T12:24:06+08:00",
    "Minor Heat": "2017-07-07T05:50:38+08:00",
    "Major Heat": "2017-07-22T23:15:18+08:00",
    "Start of Autumn": "2017-08-07T15:39:58+08:00",
    "End of Heat": "2017-08-23T06:20:09+08:00",
    "White Dew": "2017-09-07T18:38:34+08:00",
    "Autumn Equinox": "2017-09-23T04:01:44+08:00",
    "Cold Dew": "2017-10-08T10:22:05+08:00",
    "Frost's Descent": "2017-10-23T13:26:36+08:00",
    "Start of Winter": "2017-11-07T13:37:45+08:00",
    "Minor Snow": "2017-11-22T11:04:34+08:00",
    "Major Snow": "2017-12-07T06:32:35+08:00",
    "Winter Solstice": "2017-12-22T00:27:53+08:00",
    "Minor Cold": "2018-01-05T17:48:41+08:00",
    "Major Cold": "2018-01-20T11:08:58+08:00"
  },
  
  // 2018
  2018: {
    "Start of Spring": "2018-02-04T05:28:25+08:00",
    "Rain Water": "2018-02-19T01:17:57+08:00",
    "Awakening of Insects": "2018-03-05T23:28:06+08:00",
    "Spring Equinox": "2018-03-21T00:15:24+08:00",
    "Pure Brightness": "2018-04-05T04:12:43+08:00",
    "Grain Rain": "2018-04-20T11:12:29+08:00",
    "Start of Summer": "2018-05-05T21:25:18+08:00",
    "Grain Buds": "2018-05-21T10:14:33+08:00",
    "Grain in Ear": "2018-06-06T01:29:04+08:00",
    "Summer Solstice": "2018-06-21T18:07:12+08:00",
    "Minor Heat": "2018-07-07T11:41:47+08:00",
    "Major Heat": "2018-07-23T05:00:16+08:00",
    "Start of Autumn": "2018-08-07T21:30:34+08:00",
    "End of Heat": "2018-08-23T12:08:30+08:00",
    "White Dew": "2018-09-08T00:29:37+08:00",
    "Autumn Equinox": "2018-09-23T09:54:01+08:00",
    "Cold Dew": "2018-10-08T16:14:37+08:00",
    "Frost's Descent": "2018-10-23T19:22:18+08:00",
    "Start of Winter": "2018-11-07T19:31:39+08:00",
    "Minor Snow": "2018-11-22T17:01:24+08:00",
    "Major Snow": "2018-12-07T12:25:48+08:00",
    "Winter Solstice": "2018-12-22T06:22:38+08:00",
    "Minor Cold": "2019-01-05T23:38:52+08:00",
    "Major Cold": "2019-01-20T16:59:27+08:00"
  },
  
  // 2019
  2019: {
    "Start of Spring": "2019-02-04T11:14:14+08:00",
    "Rain Water": "2019-02-19T07:03:51+08:00",
    "Awakening of Insects": "2019-03-06T05:09:39+08:00",
    "Spring Equinox": "2019-03-21T05:58:20+08:00",
    "Pure Brightness": "2019-04-05T09:51:21+08:00",
    "Grain Rain": "2019-04-20T16:55:10+08:00",
    "Start of Summer": "2019-05-06T03:02:40+08:00",
    "Grain Buds": "2019-05-21T15:59:01+08:00",
    "Grain in Ear": "2019-06-06T07:06:18+08:00",
    "Summer Solstice": "2019-06-21T23:54:09+08:00",
    "Minor Heat": "2019-07-07T17:20:25+08:00",
    "Major Heat": "2019-07-23T10:50:16+08:00",
    "Start of Autumn": "2019-08-08T03:12:57+08:00",
    "End of Heat": "2019-08-23T18:01:53+08:00",
    "White Dew": "2019-09-08T06:16:46+08:00",
    "Autumn Equinox": "2019-09-23T15:50:02+08:00",
    "Cold Dew": "2019-10-08T22:05:32+08:00",
    "Frost's Descent": "2019-10-24T01:19:37+08:00",
    "Start of Winter": "2019-11-08T01:24:15+08:00",
    "Minor Snow": "2019-11-22T22:58:48+08:00",
    "Major Snow": "2019-12-07T18:18:21+08:00",
    "Winter Solstice": "2019-12-22T12:19:18+08:00",
    "Minor Cold": "2020-01-06T05:29:59+08:00",
    "Major Cold": "2020-01-20T22:54:33+08:00"
  },
  
  // 2020
  2020: {
    "Start of Spring": "2020-02-04T17:03:12+08:00",
    "Rain Water": "2020-02-19T12:56:53+08:00",
    "Awakening of Insects": "2020-03-05T10:56:44+08:00",
    "Spring Equinox": "2020-03-20T11:49:29+08:00",
    "Pure Brightness": "2020-04-04T15:38:02+08:00",
    "Grain Rain": "2020-04-19T22:45:21+08:00",
    "Start of Summer": "2020-05-05T08:51:16+08:00",
    "Grain Buds": "2020-05-20T21:49:09+08:00",
    "Grain in Ear": "2020-06-05T12:58:18+08:00",
    "Summer Solstice": "2020-06-21T05:43:33+08:00",
    "Minor Heat": "2020-07-06T23:14:20+08:00",
    "Major Heat": "2020-07-22T16:36:44+08:00",
    "Start of Autumn": "2020-08-07T09:06:03+08:00",
    "End of Heat": "2020-08-22T23:44:48+08:00",
    "White Dew": "2020-09-07T12:07:54+08:00",
    "Autumn Equinox": "2020-09-22T21:30:32+08:00",
    "Cold Dew": "2020-10-08T03:55:07+08:00",
    "Frost's Descent": "2020-10-23T06:59:25+08:00",
    "Start of Winter": "2020-11-07T07:13:46+08:00",
    "Minor Snow": "2020-11-22T04:39:38+08:00",
    "Major Snow": "2020-12-07T00:09:21+08:00",
    "Winter Solstice": "2020-12-21T18:02:12+08:00",
    "Minor Cold": "2021-01-05T11:23:17+08:00",
    "Major Cold": "2021-01-20T04:39:42+08:00"
  },

  // 2021
  2021: {
    "Start of Spring": "2021-02-03T22:58:39+08:00",
    "Rain Water": "2021-02-18T18:43:49+08:00",
    "Awakening of Insects": "2021-03-05T16:53:32+08:00",
    "Spring Equinox": "2021-03-20T17:37:19+08:00",
    "Pure Brightness": "2021-04-04T21:34:58+08:00",
    "Grain Rain": "2021-04-20T04:33:14+08:00",
    "Start of Summer": "2021-05-05T14:47:01+08:00",
    "Grain Buds": "2021-05-21T03:36:58+08:00",
    "Grain in Ear": "2021-06-05T18:51:57+08:00",
    "Summer Solstice": "2021-06-21T11:32:00+08:00",
    "Minor Heat": "2021-07-07T05:05:19+08:00",
    "Major Heat": "2021-07-22T22:26:16+08:00",
    "Start of Autumn": "2021-08-07T14:53:48+08:00",
    "End of Heat": "2021-08-23T05:34:48+08:00",
    "White Dew": "2021-09-07T17:52:46+08:00",
    "Autumn Equinox": "2021-09-23T03:20:55+08:00",
    "Cold Dew": "2021-10-08T09:38:53+08:00",
    "Frost's Descent": "2021-10-23T12:51:00+08:00",
    "Start of Winter": "2021-11-07T12:58:37+08:00",
    "Minor Snow": "2021-11-22T10:33:34+08:00",
    "Major Snow": "2021-12-07T05:56:55+08:00",
    "Winter Solstice": "2021-12-21T23:59:09+08:00",
    "Minor Cold": "2022-01-05T17:13:54+08:00",
    "Major Cold": "2022-01-20T10:38:56+08:00"
  },

  // 2022
  2022: {
    "Start of Spring": "2022-02-04T04:50:36+08:00",
    "Rain Water": "2022-02-19T00:42:50+08:00",
    "Awakening of Insects": "2022-03-05T22:43:34+08:00",
    "Spring Equinox": "2022-03-20T23:33:15+08:00",
    "Pure Brightness": "2022-04-05T03:20:03+08:00",
    "Grain Rain": "2022-04-20T10:24:07+08:00",
    "Start of Summer": "2022-05-05T20:25:46+08:00",
    "Grain Buds": "2022-05-21T09:22:25+08:00",
    "Grain in Ear": "2022-06-06T00:25:37+08:00",
    "Summer Solstice": "2022-06-21T17:13:40+08:00",
    "Minor Heat": "2022-07-07T10:37:49+08:00",
    "Major Heat": "2022-07-23T04:06:49+08:00",
    "Start of Autumn": "2022-08-07T20:28:57+08:00",
    "End of Heat": "2022-08-23T11:15:59+08:00",
    "White Dew": "2022-09-07T23:32:07+08:00",
    "Autumn Equinox": "2022-09-23T09:03:31+08:00",
    "Cold Dew": "2022-10-08T15:22:16+08:00",
    "Frost's Descent": "2022-10-23T18:35:31+08:00",
    "Start of Winter": "2022-11-07T18:45:18+08:00",
    "Minor Snow": "2022-11-22T16:20:18+08:00",
    "Major Snow": "2022-12-07T11:46:04+08:00",
    "Winter Solstice": "2022-12-22T05:48:01+08:00",
    "Minor Cold": "2023-01-05T23:04:39+08:00",
    "Major Cold": "2023-01-20T16:29:20+08:00"
  },

  // 2023
  2023: {
    "Start of Spring": "2023-02-04T10:42:21+08:00",
    "Rain Water": "2023-02-19T06:34:05+08:00",
    "Awakening of Insects": "2023-03-06T04:36:02+08:00",
    "Spring Equinox": "2023-03-21T05:24:14+08:00",
    "Pure Brightness": "2023-04-05T09:12:52+08:00",
    "Grain Rain": "2023-04-20T16:13:26+08:00",
    "Start of Summer": "2023-05-06T02:18:34+08:00",
    "Grain Buds": "2023-05-21T15:08:59+08:00",
    "Grain in Ear": "2023-06-06T06:18:10+08:00",
    "Summer Solstice": "2023-06-21T22:57:37+08:00",
    "Minor Heat": "2023-07-07T16:30:29+08:00",
    "Major Heat": "2023-07-23T09:50:15+08:00",
    "Start of Autumn": "2023-08-08T02:22:41+08:00",
    "End of Heat": "2023-08-23T17:01:06+08:00",
    "White Dew": "2023-09-08T05:26:31+08:00",
    "Autumn Equinox": "2023-09-23T14:49:46+08:00",
    "Cold Dew": "2023-10-08T21:15:23+08:00",
    "Frost's Descent": "2023-10-24T00:20:39+08:00",
    "Start of Winter": "2023-11-08T00:35:23+08:00",
    "Minor Snow": "2023-11-22T22:02:29+08:00",
    "Major Snow": "2023-12-07T17:32:44+08:00",
    "Winter Solstice": "2023-12-22T11:27:09+08:00",
    "Minor Cold": "2024-01-06T04:49:09+08:00",
    "Major Cold": "2024-01-20T22:07:08+08:00"
  },

  // 2024
  2024: {
    "Start of Spring": "2024-02-04T16:26:53+08:00",
    "Rain Water": "2024-02-19T12:12:58+08:00",
    "Awakening of Insects": "2024-03-05T10:22:31+08:00",
    "Spring Equinox": "2024-03-20T11:06:12+08:00",
    "Pure Brightness": "2024-04-04T15:02:03+08:00",
    "Grain Rain": "2024-04-19T21:59:33+08:00",
    "Start of Summer": "2024-05-05T08:09:51+08:00",
    "Grain Buds": "2024-05-20T20:59:17+08:00",
    "Grain in Ear": "2024-06-05T12:09:40+08:00",
    "Summer Solstice": "2024-06-21T04:50:46+08:00",
    "Minor Heat": "2024-07-06T22:19:49+08:00",
    "Major Heat": "2024-07-22T15:44:11+08:00",
    "Start of Autumn": "2024-08-07T08:09:01+08:00",
    "End of Heat": "2024-08-22T22:54:48+08:00",
    "White Dew": "2024-09-07T11:11:06+08:00",
    "Autumn Equinox": "2024-09-22T20:43:27+08:00",
    "Cold Dew": "2024-10-08T02:59:43+08:00",
    "Frost's Descent": "2024-10-23T06:14:32+08:00",
    "Start of Winter": "2024-11-07T06:19:49+08:00",
    "Minor Snow": "2024-11-22T03:56:16+08:00",
    "Major Snow": "2024-12-06T23:16:47+08:00",
    "Winter Solstice": "2024-12-21T17:20:20+08:00",
    "Minor Cold": "2025-01-05T10:32:31+08:00",
    "Major Cold": "2025-01-20T03:59:52+08:00"
  },

  // 2025
  2025: {
    "Start of Spring": "2025-02-03T22:10:13+08:00",
    "Rain Water": "2025-02-18T18:06:18+08:00",
    "Awakening of Insects": "2025-03-05T16:07:02+08:00",
    "Spring Equinox": "2025-03-20T17:01:14+08:00",
    "Pure Brightness": "2025-04-04T20:48:21+08:00",
    "Grain Rain": "2025-04-20T03:55:45+08:00",
    "Start of Summer": "2025-05-05T13:56:57+08:00",
    "Grain Buds": "2025-05-21T02:54:23+08:00",
    "Grain in Ear": "2025-06-05T17:56:16+08:00",
    "Summer Solstice": "2025-06-21T10:42:00+08:00",
    "Minor Heat": "2025-07-07T04:04:43+08:00",
    "Major Heat": "2025-07-22T21:29:11+08:00",
    "Start of Autumn": "2025-08-07T13:51:19+08:00",
    "End of Heat": "2025-08-23T04:33:35+08:00",
    "White Dew": "2025-09-07T16:51:41+08:00",
    "Autumn Equinox": "2025-09-23T02:19:04+08:00",
    "Cold Dew": "2025-10-08T08:40:57+08:00",
    "Frost's Descent": "2025-10-23T11:50:39+08:00",
    "Start of Winter": "2025-11-07T12:03:48+08:00",
    "Minor Snow": "2025-11-22T09:35:18+08:00",
    "Major Snow": "2025-12-07T05:04:20+08:00",
    "Winter Solstice": "2025-12-21T23:02:48+08:00",
    "Minor Cold": "2026-01-05T16:22:53+08:00",
    "Major Cold": "2026-01-20T09:44:39+08:00"
  },

  // 2026
  2026: {
    "Start of Spring": "2026-02-04T04:01:51+08:00",
    "Rain Water": "2026-02-18T23:51:39+08:00",
    "Awakening of Insects": "2026-03-05T21:58:43+08:00",
    "Spring Equinox": "2026-03-20T22:45:42+08:00",
    "Pure Brightness": "2026-04-05T02:39:43+08:00",
    "Grain Rain": "2026-04-20T09:38:51+08:00",
    "Start of Summer": "2026-05-05T19:48:27+08:00",
    "Grain Buds": "2026-05-21T08:36:28+08:00",
    "Grain in Ear": "2026-06-05T23:48:04+08:00",
    "Summer Solstice": "2026-06-21T16:24:12+08:00",
    "Minor Heat": "2026-07-07T09:56:40+08:00",
    "Major Heat": "2026-07-23T03:12:48+08:00",
    "Start of Autumn": "2026-08-07T19:42:26+08:00",
    "End of Heat": "2026-08-23T10:18:31+08:00",
    "White Dew": "2026-09-07T22:40:59+08:00",
    "Autumn Equinox": "2026-09-23T08:04:56+08:00",
    "Cold Dew": "2026-10-08T14:28:59+08:00",
    "Frost's Descent": "2026-10-23T17:37:39+08:00",
    "Start of Winter": "2026-11-07T17:51:46+08:00",
    "Minor Snow": "2026-11-22T15:23:03+08:00",
    "Major Snow": "2026-12-07T10:52:14+08:00",
    "Winter Solstice": "2026-12-22T04:49:55+08:00",
    "Minor Cold": "2027-01-05T22:09:39+08:00",
    "Major Cold": "2027-01-20T15:29:32+08:00"
  },

  // 2027
  2027: {
    "Start of Spring": "2027-02-04T09:46:00+08:00",
    "Rain Water": "2027-02-19T05:33:10+08:00",
    "Awakening of Insects": "2027-03-06T03:39:14+08:00",
    "Spring Equinox": "2027-03-21T04:24:24+08:00",
    "Pure Brightness": "2027-04-05T08:17:12+08:00",
    "Grain Rain": "2027-04-20T15:17:20+08:00",
    "Start of Summer": "2027-05-06T01:24:53+08:00",
    "Grain Buds": "2027-05-21T14:17:55+08:00",
    "Grain in Ear": "2027-06-06T05:25:29+08:00",
    "Summer Solstice": "2027-06-21T22:10:30+08:00",
    "Minor Heat": "2027-07-07T15:36:44+08:00",
    "Major Heat": "2027-07-23T09:04:20+08:00",
    "Start of Autumn": "2027-08-08T01:26:27+08:00",
    "End of Heat": "2027-08-23T16:13:59+08:00",
    "White Dew": "2027-09-08T04:28:08+08:00",
    "Autumn Equinox": "2027-09-23T14:01:23+08:00",
    "Cold Dew": "2027-10-08T20:16:46+08:00",
    "Frost's Descent": "2027-10-23T23:32:33+08:00",
    "Start of Winter": "2027-11-07T23:38:15+08:00",
    "Minor Snow": "2027-11-22T21:15:54+08:00",
    "Major Snow": "2027-12-07T16:37:21+08:00",
    "Winter Solstice": "2027-12-22T10:41:50+08:00",
    "Minor Cold": "2028-01-06T03:54:19+08:00",
    "Major Cold": "2028-01-20T21:21:37+08:00"
  },

  // 2028
  2028: {
    "Start of Spring": "2028-02-04T15:30:53+08:00",
    "Rain Water": "2028-02-19T11:25:42+08:00",
    "Awakening of Insects": "2028-03-05T09:24:27+08:00",
    "Spring Equinox": "2028-03-20T10:16:49+08:00",
    "Pure Brightness": "2028-04-04T14:02:45+08:00",
    "Grain Rain": "2028-04-19T21:09:10+08:00",
    "Start of Summer": "2028-05-05T07:11:51+08:00",
    "Grain Buds": "2028-05-20T20:09:28+08:00",
    "Grain in Ear": "2028-06-05T11:15:39+08:00",
    "Summer Solstice": "2028-06-21T04:01:39+08:00",
    "Minor Heat": "2028-07-06T21:29:57+08:00",
    "Major Heat": "2028-07-22T14:53:38+08:00",
    "Start of Autumn": "2028-08-07T07:20:50+08:00",
    "End of Heat": "2028-08-22T22:00:35+08:00",
    "White Dew": "2028-09-07T10:21:49+08:00",
    "Autumn Equinox": "2028-09-22T19:44:59+08:00",
    "Cold Dew": "2028-10-08T02:08:10+08:00",
    "Frost's Descent": "2028-10-23T05:13:03+08:00",
    "Start of Winter": "2028-11-07T05:26:54+08:00",
    "Minor Snow": "2028-11-22T02:54:02+08:00",
    "Major Snow": "2028-12-06T22:24:19+08:00",
    "Winter Solstice": "2028-12-21T16:19:19+08:00",
    "Minor Cold": "2029-01-05T09:41:34+08:00",
    "Major Cold": "2029-01-20T03:00:32+08:00"
  },

  // 2029
  2029: {
    "Start of Spring": "2029-02-03T21:20:25+08:00",
    "Rain Water": "2029-02-18T17:07:34+08:00",
    "Awakening of Insects": "2029-03-05T15:17:15+08:00",
    "Spring Equinox": "2029-03-20T16:01:37+08:00",
    "Pure Brightness": "2029-04-04T19:58:02+08:00",
    "Grain Rain": "2029-04-20T02:55:20+08:00",
    "Start of Summer": "2029-05-05T13:07:24+08:00",
    "Grain Buds": "2029-05-21T01:55:30+08:00",
    "Grain in Ear": "2029-06-05T17:09:36+08:00",
    "Summer Solstice": "2029-06-21T09:47:55+08:00",
    "Minor Heat": "2029-07-07T03:22:01+08:00",
    "Major Heat": "2029-07-22T20:41:43+08:00",
    "Start of Autumn": "2029-08-07T13:11:22+08:00",
    "End of Heat": "2029-08-23T03:51:14+08:00",
    "White Dew": "2029-09-07T16:11:32+08:00",
    "Autumn Equinox": "2029-09-23T01:38:09+08:00",
    "Cold Dew": "2029-10-08T07:57:45+08:00",
    "Frost's Descent": "2029-10-23T11:07:45+08:00",
    "Start of Winter": "2029-11-07T11:16:23+08:00",
    "Minor Snow": "2029-11-22T08:49:01+08:00",
    "Major Snow": "2029-12-07T04:13:25+08:00",
    "Winter Solstice": "2029-12-21T22:13:45+08:00",
    "Minor Cold": "2030-01-05T15:30:11+08:00",
    "Major Cold": "2030-01-20T08:54:01+08:00"
  },
  
  // 2030
  2030: {
    "Start of Spring": "2030-02-04T03:08:04+08:00",
    "Rain Water": "2030-02-18T22:59:34+08:00",
    "Awakening of Insects": "2030-03-05T21:02:55+08:00",
    "Spring Equinox": "2030-03-20T21:51:43+08:00",
    "Pure Brightness": "2030-04-05T01:40:37+08:00",
    "Grain Rain": "2030-04-20T08:43:13+08:00",
    "Start of Summer": "2030-05-05T18:45:54+08:00",
    "Grain Buds": "2030-05-21T07:40:42+08:00",
    "Grain in Ear": "2030-06-05T22:44:06+08:00",
    "Summer Solstice": "2030-06-21T15:30:54+08:00",
    "Minor Heat": "2030-07-07T08:55:05+08:00",
    "Major Heat": "2030-07-23T02:24:29+08:00",
    "Start of Autumn": "2030-08-07T18:46:56+08:00",
    "End of Heat": "2030-08-23T09:36:00+08:00",
    "White Dew": "2030-09-07T21:52:26+08:00",
    "Autumn Equinox": "2030-09-23T07:26:30+08:00",
    "Cold Dew": "2030-10-08T13:44:52+08:00",
    "Frost's Descent": "2030-10-23T17:00:10+08:00",
    "Start of Winter": "2030-11-07T17:08:20+08:00",
    "Minor Snow": "2030-11-22T14:44:12+08:00",
    "Major Snow": "2030-12-07T10:07:13+08:00",
    "Winter Solstice": "2030-12-22T04:09:13+08:00",
    "Minor Cold": "2031-01-05T21:22:44+08:00",
    "Major Cold": "2031-01-20T14:47:33+08:00"
  },
  
  // 2031
  2031: {
    "Start of Spring": "2031-02-04T08:57:55+08:00",
    "Rain Water": "2031-02-19T04:50:30+08:00",
    "Awakening of Insects": "2031-03-06T02:50:38+08:00",
    "Spring Equinox": "2031-03-21T03:40:34+08:00",
    "Pure Brightness": "2031-04-05T07:27:59+08:00",
    "Grain Rain": "2031-04-20T14:30:49+08:00",
    "Start of Summer": "2031-05-06T00:34:47+08:00",
    "Grain Buds": "2031-05-21T13:27:29+08:00",
    "Grain in Ear": "2031-06-06T04:35:17+08:00",
    "Summer Solstice": "2031-06-21T21:16:43+08:00",
    "Minor Heat": "2031-07-07T14:48:26+08:00",
    "Major Heat": "2031-07-23T08:10:03+08:00",
    "Start of Autumn": "2031-08-08T00:42:31+08:00",
    "End of Heat": "2031-08-23T15:22:54+08:00",
    "White Dew": "2031-09-08T03:49:45+08:00",
    "Autumn Equinox": "2031-09-23T13:14:54+08:00",
    "Cold Dew": "2031-10-08T19:42:33+08:00",
    "Frost's Descent": "2031-10-23T22:49:01+08:00",
    "Start of Winter": "2031-11-07T23:05:15+08:00",
    "Minor Snow": "2031-11-22T20:32:11+08:00",
    "Major Snow": "2031-12-07T16:02:27+08:00",
    "Winter Solstice": "2031-12-22T09:55:07+08:00",
    "Minor Cold": "2032-01-06T03:15:40+08:00",
    "Major Cold": "2032-01-20T20:30:53+08:00"
  },
  
  // 2032
  2032: {
    "Start of Spring": "2032-02-04T14:48:32+08:00",
    "Rain Water": "2032-02-19T10:31:49+08:00",
    "Awakening of Insects": "2032-03-05T08:39:48+08:00",
    "Spring Equinox": "2032-03-20T09:21:29+08:00",
    "Pure Brightness": "2032-04-04T13:17:10+08:00",
    "Grain Rain": "2032-04-19T20:13:43+08:00",
    "Start of Summer": "2032-05-05T06:25:25+08:00",
    "Grain Buds": "2032-05-20T19:14:33+08:00",
    "Grain in Ear": "2032-06-05T10:27:32+08:00",
    "Summer Solstice": "2032-06-21T03:08:19+08:00",
    "Minor Heat": "2032-07-06T20:40:27+08:00",
    "Major Heat": "2032-07-22T14:04:18+08:00",
    "Start of Autumn": "2032-08-07T06:32:16+08:00",
    "End of Heat": "2032-08-22T21:17:53+08:00",
    "White Dew": "2032-09-07T09:37:27+08:00",
    "Autumn Equinox": "2032-09-22T19:10:27+08:00",
    "Cold Dew": "2032-10-08T01:29:58+08:00",
    "Frost's Descent": "2032-10-23T04:45:47+08:00",
    "Start of Winter": "2032-11-07T04:53:49+08:00",
    "Minor Snow": "2032-11-22T02:30:44+08:00",
    "Major Snow": "2032-12-06T21:52:52+08:00",
    "Winter Solstice": "2032-12-21T15:55:29+08:00",
    "Minor Cold": "2033-01-05T09:07:39+08:00",
    "Major Cold": "2033-01-20T02:32:20+08:00"
  },
  
  // 2033
  2033: {
    "Start of Spring": "2033-02-03T20:41:08+08:00",
    "Rain Water": "2033-02-18T16:33:22+08:00",
    "Awakening of Insects": "2033-03-05T14:31:54+08:00",
    "Spring Equinox": "2033-03-20T15:22:17+08:00",
    "Pure Brightness": "2033-04-04T19:07:41+08:00",
    "Grain Rain": "2033-04-20T02:12:40+08:00",
    "Start of Summer": "2033-05-05T12:13:18+08:00",
    "Grain Buds": "2033-05-21T01:10:30+08:00",
    "Grain in Ear": "2033-06-05T16:12:58+08:00",
    "Summer Solstice": "2033-06-21T09:00:40+08:00",
    "Minor Heat": "2033-07-07T02:24:29+08:00",
    "Major Heat": "2033-07-22T19:52:21+08:00",
    "Start of Autumn": "2033-08-07T12:15:17+08:00",
    "End of Heat": "2033-08-23T03:01:22+08:00",
    "White Dew": "2033-09-07T15:19:53+08:00",
    "Autumn Equinox": "2033-09-23T00:51:12+08:00",
    "Cold Dew": "2033-10-08T07:13:28+08:00",
    "Frost's Descent": "2033-10-23T10:27:08+08:00",
    "Start of Winter": "2033-11-07T10:40:36+08:00",
    "Minor Snow": "2033-11-22T08:15:42+08:00",
    "Major Snow": "2033-12-07T03:44:27+08:00",
    "Winter Solstice": "2033-12-21T21:45:32+08:00",
    "Minor Cold": "2034-01-05T15:04:02+08:00",
    "Major Cold": "2034-01-20T08:26:49+08:00"
  },
  
  // 2034
  2034: {
    "Start of Spring": "2034-02-04T02:40:41+08:00",
    "Rain Water": "2034-02-18T22:29:43+08:00",
    "Awakening of Insects": "2034-03-05T20:31:54+08:00",
    "Spring Equinox": "2034-03-20T21:17:01+08:00",
    "Pure Brightness": "2034-04-05T01:05:45+08:00",
    "Grain Rain": "2034-04-20T08:03:14+08:00",
    "Start of Summer": "2034-05-05T18:08:40+08:00",
    "Grain Buds": "2034-05-21T06:56:24+08:00",
    "Grain in Ear": "2034-06-05T22:06:12+08:00",
    "Summer Solstice": "2034-06-21T14:43:42+08:00",
    "Minor Heat": "2034-07-07T08:17:09+08:00",
    "Major Heat": "2034-07-23T01:35:51+08:00",
    "Start of Autumn": "2034-08-07T18:08:37+08:00",
    "End of Heat": "2034-08-23T08:47:16+08:00",
    "White Dew": "2034-09-07T21:13:29+08:00",
    "Autumn Equinox": "2034-09-23T06:39:04+08:00",
    "Cold Dew": "2034-10-08T13:06:36+08:00",
    "Frost's Descent": "2034-10-23T16:15:57+08:00",
    "Start of Winter": "2034-11-07T16:33:09+08:00",
    "Minor Snow": "2034-11-22T14:04:28+08:00",
    "Major Snow": "2034-12-07T09:36:19+08:00",
    "Winter Solstice": "2034-12-22T03:33:30+08:00",
    "Minor Cold": "2035-01-05T20:55:13+08:00",
    "Major Cold": "2035-01-20T14:13:46+08:00"
  },
  
  // 2035
  2035: {
    "Start of Spring": "2035-02-04T08:31:04+08:00",
    "Rain Water": "2035-02-19T04:15:39+08:00",
    "Awakening of Insects": "2035-03-06T02:21:08+08:00",
    "Spring Equinox": "2035-03-21T03:02:12+08:00",
    "Pure Brightness": "2035-04-05T06:53:21+08:00",
    "Grain Rain": "2035-04-20T13:48:28+08:00",
    "Start of Summer": "2035-05-05T23:54:25+08:00",
    "Grain Buds": "2035-05-21T12:42:56+08:00",
    "Grain in Ear": "2035-06-06T03:50:19+08:00",
    "Summer Solstice": "2035-06-21T20:32:38+08:00",
    "Minor Heat": "2035-07-07T14:00:39+08:00",
    "Major Heat": "2035-07-23T07:28:11+08:00",
    "Start of Autumn": "2035-08-07T23:53:49+08:00",
    "End of Heat": "2035-08-23T14:43:39+08:00",
    "White Dew": "2035-09-08T03:01:58+08:00",
    "Autumn Equinox": "2035-09-23T12:38:26+08:00",
    "Cold Dew": "2035-10-08T18:57:10+08:00",
    "Frost's Descent": "2035-10-23T22:15:39+08:00",
    "Start of Winter": "2035-11-07T22:23:20+08:00",
    "Minor Snow": "2035-11-22T20:02:41+08:00",
    "Major Snow": "2035-12-07T15:25:00+08:00",
    "Winter Solstice": "2035-12-22T09:30:21+08:00",
    "Minor Cold": "2036-01-06T02:42:59+08:00",
    "Major Cold": "2036-01-20T20:10:31+08:00"
  },
  
  // 2036
  2036: {
    "Start of Spring": "2036-02-04T14:19:25+08:00",
    "Rain Water": "2036-02-19T10:13:46+08:00",
    "Awakening of Insects": "2036-03-05T08:11:18+08:00",
    "Spring Equinox": "2036-03-20T09:02:19+08:00",
    "Pure Brightness": "2036-04-04T12:45:44+08:00",
    "Grain Rain": "2036-04-19T19:49:58+08:00",
    "Start of Summer": "2036-05-05T05:48:51+08:00",
    "Grain Buds": "2036-05-20T18:44:21+08:00",
    "Grain in Ear": "2036-06-05T09:46:28+08:00",
    "Summer Solstice": "2036-06-21T02:31:42+08:00",
    "Minor Heat": "2036-07-06T19:57:00+08:00",
    "Major Heat": "2036-07-22T13:22:08+08:00",
    "Start of Autumn": "2036-08-07T05:48:24+08:00",
    "End of Heat": "2036-08-22T20:31:52+08:00",
    "White Dew": "2036-09-07T08:54:27+08:00",
    "Autumn Equinox": "2036-09-22T18:22:46+08:00",
    "Cold Dew": "2036-10-08T00:48:26+08:00",
    "Frost's Descent": "2036-10-23T03:58:17+08:00",
    "Start of Winter": "2036-11-07T04:14:07+08:00",
    "Minor Snow": "2036-11-22T01:44:45+08:00",
    "Major Snow": "2036-12-06T21:15:29+08:00",
    "Winter Solstice": "2036-12-21T15:12:20+08:00",
    "Minor Cold": "2037-01-05T08:33:31+08:00",
    "Major Cold": "2037-01-20T01:53:11+08:00"
  },
  
  // 2037
  2037: {
    "Start of Spring": "2037-02-03T20:11:04+08:00",
    "Rain Water": "2037-02-18T15:58:22+08:00",
    "Awakening of Insects": "2037-03-05T14:05:38+08:00",
    "Spring Equinox": "2037-03-20T14:49:43+08:00",
    "Pure Brightness": "2037-04-04T18:43:29+08:00",
    "Grain Rain": "2037-04-20T01:39:46+08:00",
    "Start of Summer": "2037-05-05T11:48:55+08:00",
    "Grain Buds": "2037-05-21T00:34:54+08:00",
    "Grain in Ear": "2037-06-05T15:46:17+08:00",
    "Summer Solstice": "2037-06-21T08:21:52+08:00",
    "Minor Heat": "2037-07-07T01:54:35+08:00",
    "Major Heat": "2037-07-22T19:12:02+08:00",
    "Start of Autumn": "2037-08-07T11:42:28+08:00",
    "End of Heat": "2037-08-23T02:21:28+08:00",
    "White Dew": "2037-09-07T14:45:00+08:00",
    "Autumn Equinox": "2037-09-23T00:12:31+08:00",
    "Cold Dew": "2037-10-08T06:37:16+08:00",
    "Frost's Descent": "2037-10-23T09:49:18+08:00",
    "Start of Winter": "2037-11-07T10:03:30+08:00",
    "Minor Snow": "2037-11-22T07:37:50+08:00",
    "Major Snow": "2037-12-07T03:06:43+08:00",
    "Winter Solstice": "2037-12-21T21:07:11+08:00",
    "Minor Cold": "2038-01-05T14:26:13+08:00",
    "Major Cold": "2038-01-20T07:48:17+08:00"
  },
  
  // 2038
  2038: {
    "Start of Spring": "2038-02-04T02:03:12+08:00",
    "Rain Water": "2038-02-18T21:51:33+08:00",
    "Awakening of Insects": "2038-03-05T19:54:55+08:00",
    "Spring Equinox": "2038-03-20T20:40:04+08:00",
    "Pure Brightness": "2038-04-05T00:28:53+08:00",
    "Grain Rain": "2038-04-20T07:27:58+08:00",
    "Start of Summer": "2038-05-05T17:30:37+08:00",
    "Grain Buds": "2038-05-21T06:22:08+08:00",
    "Grain in Ear": "2038-06-05T21:25:03+08:00",
    "Summer Solstice": "2038-06-21T14:08:49+08:00",
    "Minor Heat": "2038-07-07T07:31:56+08:00",
    "Major Heat": "2038-07-23T00:59:19+08:00",
    "Start of Autumn": "2038-08-07T17:20:44+08:00",
    "End of Heat": "2038-08-23T08:09:33+08:00",
    "White Dew": "2038-09-07T20:25:42+08:00",
    "Autumn Equinox": "2038-09-23T06:01:40+08:00",
    "Cold Dew": "2038-10-08T12:20:59+08:00",
    "Frost's Descent": "2038-10-23T15:40:05+08:00",
    "Start of Winter": "2038-11-07T15:50:16+08:00",
    "Minor Snow": "2038-11-22T13:30:44+08:00",
    "Major Snow": "2038-12-07T08:55:48+08:00",
    "Winter Solstice": "2038-12-22T03:01:44+08:00",
    "Minor Cold": "2039-01-05T20:16:04+08:00",
    "Major Cold": "2039-01-20T13:43:04+08:00"
  },
  
  // 2039
  2039: {
    "Start of Spring": "2039-02-04T07:52:19+08:00",
    "Rain Water": "2039-02-19T03:45:09+08:00",
    "Awakening of Insects": "2039-03-06T01:42:27+08:00",
    "Spring Equinox": "2039-03-21T02:31:26+08:00",
    "Pure Brightness": "2039-04-05T06:15:11+08:00",
    "Grain Rain": "2039-04-20T13:17:11+08:00",
    "Start of Summer": "2039-05-05T23:17:33+08:00",
    "Grain Buds": "2039-05-21T12:10:17+08:00",
    "Grain in Ear": "2039-06-06T03:14:53+08:00",
    "Summer Solstice": "2039-06-21T19:56:50+08:00",
    "Minor Heat": "2039-07-07T13:25:33+08:00",
    "Major Heat": "2039-07-23T06:47:33+08:00",
    "Start of Autumn": "2039-08-07T23:17:29+08:00",
    "End of Heat": "2039-08-23T13:58:04+08:00",
    "White Dew": "2039-09-08T02:23:26+08:00",
    "Autumn Equinox": "2039-09-23T11:49:00+08:00",
    "Cold Dew": "2039-10-08T18:16:40+08:00",
    "Frost's Descent": "2039-10-23T21:24:27+08:00",
    "Start of Winter": "2039-11-07T21:42:17+08:00",
    "Minor Snow": "2039-11-22T19:11:35+08:00",
    "Major Snow": "2039-12-07T14:44:28+08:00",
    "Winter Solstice": "2039-12-22T08:39:59+08:00",
    "Minor Cold": "2040-01-06T02:03:00+08:00",
    "Major Cold": "2040-01-20T19:20:26+08:00"
  },
  
  // 2040
  2040: {
    "Start of Spring": "2040-02-04T13:39:17+08:00",
    "Rain Water": "2040-02-19T09:23:12+08:00",
    "Awakening of Insects": "2040-03-05T07:30:37+08:00",
    "Spring Equinox": "2040-03-20T08:11:05+08:00",
    "Pure Brightness": "2040-04-04T12:04:54+08:00",
    "Grain Rain": "2040-04-19T18:58:57+08:00",
    "Start of Summer": "2040-05-05T05:08:44+08:00",
    "Grain Buds": "2040-05-20T17:55:06+08:00",
    "Grain in Ear": "2040-06-05T09:07:24+08:00",
    "Summer Solstice": "2040-06-21T01:45:46+08:00",
    "Minor Heat": "2040-07-06T19:18:36+08:00",
    "Major Heat": "2040-07-22T12:40:11+08:00",
    "Start of Autumn": "2040-08-07T05:09:25+08:00",
    "End of Heat": "2040-08-22T19:52:41+08:00",
    "White Dew": "2040-09-07T08:13:28+08:00",
    "Autumn Equinox": "2040-09-22T17:44:17+08:00",
    "Cold Dew": "2040-10-08T00:04:54+08:00",
    "Frost's Descent": "2040-10-23T03:19:07+08:00",
    "Start of Winter": "2040-11-07T03:28:40+08:00",
    "Minor Snow": "2040-11-22T01:04:53+08:00",
    "Major Snow": "2040-12-06T20:29:25+08:00",
    "Winter Solstice": "2040-12-21T14:32:13+08:00",
    "Minor Cold": "2041-01-05T07:47:29+08:00",
    "Major Cold": "2041-01-20T01:12:40+08:00"
  },
  
  // 2041
  2041: {
    "Start of Spring": "2041-02-03T19:24:30+08:00",
    "Rain Water": "2041-02-18T15:16:38+08:00",
    "Awakening of Insects": "2041-03-05T13:17:12+08:00",
    "Spring Equinox": "2041-03-20T14:06:11+08:00",
    "Pure Brightness": "2041-04-04T17:51:58+08:00",
    "Grain Rain": "2041-04-20T00:54:18+08:00",
    "Start of Summer": "2041-05-05T10:53:52+08:00",
    "Grain Buds": "2041-05-20T23:48:12+08:00",
    "Grain in Ear": "2041-06-05T14:49:07+08:00",
    "Summer Solstice": "2041-06-21T07:35:12+08:00",
    "Minor Heat": "2041-07-07T00:57:50+08:00",
    "Major Heat": "2041-07-22T18:26:02+08:00",
    "Start of Autumn": "2041-08-07T10:48:02+08:00",
    "End of Heat": "2041-08-23T01:35:37+08:00",
    "White Dew": "2041-09-07T13:52:54+08:00",
    "Autumn Equinox": "2041-09-22T23:25:54+08:00",
    "Cold Dew": "2041-10-08T05:46:19+08:00",
    "Frost's Descent": "2041-10-23T09:01:18+08:00",
    "Start of Winter": "2041-11-07T09:12:27+08:00",
    "Minor Snow": "2041-11-22T06:48:39+08:00",
    "Major Snow": "2041-12-07T02:15:08+08:00",
    "Winter Solstice": "2041-12-21T20:17:40+08:00",
    "Minor Cold": "2042-01-05T13:34:29+08:00",
    "Major Cold": "2042-01-20T06:59:23+08:00"
  },
  
  // 2042
  2042: {
    "Start of Spring": "2042-02-04T01:12:11+08:00",
    "Rain Water": "2042-02-18T21:03:49+08:00",
    "Awakening of Insects": "2042-03-05T19:05:08+08:00",
    "Spring Equinox": "2042-03-20T19:52:39+08:00",
    "Pure Brightness": "2042-04-04T23:40:00+08:00",
    "Grain Rain": "2042-04-20T06:39:07+08:00",
    "Start of Summer": "2042-05-05T16:42:11+08:00",
    "Grain Buds": "2042-05-21T05:30:36+08:00",
    "Grain in Ear": "2042-06-05T20:37:33+08:00",
    "Summer Solstice": "2042-06-21T13:15:10+08:00",
    "Minor Heat": "2042-07-07T06:46:36+08:00",
    "Major Heat": "2042-07-23T00:05:39+08:00",
    "Start of Autumn": "2042-08-07T16:38:08+08:00",
    "End of Heat": "2042-08-23T07:17:26+08:00",
    "White Dew": "2042-09-07T19:44:48+08:00",
    "Autumn Equinox": "2042-09-23T05:10:52+08:00",
    "Cold Dew": "2042-10-08T11:39:54+08:00",
    "Frost's Descent": "2042-10-23T14:48:52+08:00",
    "Start of Winter": "2042-11-07T15:06:58+08:00",
    "Minor Snow": "2042-11-22T12:36:42+08:00",
    "Major Snow": "2042-12-07T08:08:33+08:00",
    "Winter Solstice": "2042-12-22T02:03:23+08:00",
    "Minor Cold": "2043-01-05T19:24:40+08:00",
    "Major Cold": "2043-01-20T12:40:55+08:00"
  },
  
  // 2043
  2043: {
    "Start of Spring": "2043-02-04T06:58:05+08:00",
    "Rain Water": "2043-02-19T02:41:00+08:00",
    "Awakening of Insects": "2043-03-06T00:47:05+08:00",
    "Spring Equinox": "2043-03-21T01:27:07+08:00",
    "Pure Brightness": "2043-04-05T05:19:35+08:00",
    "Grain Rain": "2043-04-20T12:13:46+08:00",
    "Start of Summer": "2043-05-05T22:21:24+08:00",
    "Grain Buds": "2043-05-21T11:08:28+08:00",
    "Grain in Ear": "2043-06-06T02:17:28+08:00",
    "Summer Solstice": "2043-06-21T18:57:42+08:00",
    "Minor Heat": "2043-07-07T12:27:09+08:00",
    "Major Heat": "2043-07-23T05:52:46+08:00",
    "Start of Autumn": "2043-08-07T22:20:04+08:00",
    "End of Heat": "2043-08-23T13:09:06+08:00",
    "White Dew": "2043-09-08T01:29:29+08:00",
    "Autumn Equinox": "2043-09-23T11:06:16+08:00",
    "Cold Dew": "2043-10-08T17:27:02+08:00",
    "Frost's Descent": "2043-10-23T20:46:09+08:00",
    "Start of Winter": "2043-11-07T20:55:08+08:00",
    "Minor Snow": "2043-11-22T18:34:23+08:00",
    "Major Snow": "2043-12-07T13:56:40+08:00",
    "Winter Solstice": "2043-12-22T08:00:33+08:00",
    "Minor Cold": "2044-01-06T01:11:49+08:00",
    "Major Cold": "2044-01-20T18:36:44+08:00"
  },
  
  // 2044
  2044: {
    "Start of Spring": "2044-02-04T12:43:36+08:00",
    "Rain Water": "2044-02-19T08:35:07+08:00",
    "Awakening of Insects": "2044-03-05T06:30:54+08:00",
    "Spring Equinox": "2044-03-20T07:19:52+08:00",
    "Pure Brightness": "2044-04-04T11:02:24+08:00",
    "Grain Rain": "2044-04-19T18:06:02+08:00",
    "Start of Summer": "2044-05-05T04:04:47+08:00",
    "Grain Buds": "2044-05-20T17:01:11+08:00",
    "Grain in Ear": "2044-06-05T08:03:18+08:00",
    "Summer Solstice": "2044-06-21T00:50:26+08:00",
    "Minor Heat": "2044-07-06T18:15:13+08:00",
    "Major Heat": "2044-07-22T11:42:38+08:00",
    "Start of Autumn": "2044-08-07T04:07:54+08:00",
    "End of Heat": "2044-08-22T18:53:58+08:00",
    "White Dew": "2044-09-07T07:15:49+08:00",
    "Autumn Equinox": "2044-09-22T16:47:09+08:00",
    "Cold Dew": "2044-10-07T23:12:36+08:00",
    "Frost's Descent": "2044-10-23T02:25:35+08:00",
    "Start of Winter": "2044-11-07T02:41:17+08:00",
    "Minor Snow": "2044-11-22T00:14:35+08:00",
    "Major Snow": "2044-12-06T19:44:30+08:00",
    "Winter Solstice": "2044-12-21T13:42:53+08:00",
    "Minor Cold": "2045-01-05T07:01:49+08:00",
    "Major Cold": "2045-01-20T00:21:30+08:00"
  },
  
  // 2045
  2045: {
    "Start of Spring": "2045-02-03T18:35:35+08:00",
    "Rain Water": "2045-02-18T14:21:40+08:00",
    "Awakening of Insects": "2045-03-05T12:24:20+08:00",
    "Spring Equinox": "2045-03-20T13:06:56+08:00",
    "Pure Brightness": "2045-04-04T16:56:35+08:00",
    "Grain Rain": "2045-04-19T23:52:10+08:00",
    "Start of Summer": "2045-05-05T09:58:48+08:00",
    "Grain Buds": "2045-05-20T22:45:17+08:00",
    "Grain in Ear": "2045-06-05T13:56:18+08:00",
    "Summer Solstice": "2045-06-21T06:33:11+08:00",
    "Minor Heat": "2045-07-07T00:07:21+08:00",
    "Major Heat": "2045-07-22T17:26:05+08:00",
    "Start of Autumn": "2045-08-07T09:58:56+08:00",
    "End of Heat": "2045-08-23T00:38:27+08:00",
    "White Dew": "2045-09-07T13:04:44+08:00",
    "Autumn Equinox": "2045-09-22T22:32:13+08:00",
    "Cold Dew": "2045-10-08T04:59:56+08:00",
    "Frost's Descent": "2045-10-23T08:11:48+08:00",
    "Start of Winter": "2045-11-07T08:29:07+08:00",
    "Minor Snow": "2045-11-22T06:03:07+08:00",
    "Major Snow": "2045-12-07T01:34:51+08:00",
    "Winter Solstice": "2045-12-21T19:34:23+08:00",
    "Minor Cold": "2046-01-05T12:55:16+08:00",
    "Major Cold": "2046-01-20T06:15:09+08:00"
  },
  
  // 2046
  2046: {
    "Start of Spring": "2046-02-04T00:30:22+08:00",
    "Rain Water": "2046-02-18T20:14:54+08:00",
    "Awakening of Insects": "2046-03-05T18:17:04+08:00",
    "Spring Equinox": "2046-03-20T18:57:10+08:00",
    "Pure Brightness": "2046-04-04T22:44:15+08:00",
    "Grain Rain": "2046-04-20T05:38:13+08:00",
    "Start of Summer": "2046-05-05T15:39:58+08:00",
    "Grain Buds": "2046-05-21T04:27:47+08:00",
    "Grain in Ear": "2046-06-05T19:31:31+08:00",
    "Summer Solstice": "2046-06-21T12:13:55+08:00",
    "Minor Heat": "2046-07-07T05:39:33+08:00",
    "Major Heat": "2046-07-22T23:07:57+08:00",
    "Start of Autumn": "2046-08-07T15:32:36+08:00",
    "End of Heat": "2046-08-23T06:23:47+08:00",
    "White Dew": "2046-09-07T18:42:35+08:00",
    "Autumn Equinox": "2046-09-23T04:20:59+08:00",
    "Cold Dew": "2046-10-08T10:41:42+08:00",
    "Frost's Descent": "2046-10-23T14:02:49+08:00",
    "Start of Winter": "2046-11-07T14:13:26+08:00",
    "Minor Snow": "2046-11-22T11:55:32+08:00",
    "Major Snow": "2046-12-07T07:20:33+08:00",
    "Winter Solstice": "2046-12-22T01:27:45+08:00",
    "Minor Cold": "2047-01-05T18:41:38+08:00",
    "Major Cold": "2047-01-20T12:09:13+08:00"
  },
  
  // 2047
  2047: {
    "Start of Spring": "2047-02-04T06:17:17+08:00",
    "Rain Water": "2047-02-19T02:09:40+08:00",
    "Awakening of Insects": "2047-03-06T00:04:33+08:00",
    "Spring Equinox": "2047-03-21T00:51:56+08:00",
    "Pure Brightness": "2047-04-05T04:31:57+08:00",
    "Grain Rain": "2047-04-20T11:31:48+08:00",
    "Start of Summer": "2047-05-05T21:27:47+08:00",
    "Grain Buds": "2047-05-21T10:19:11+08:00",
    "Grain in Ear": "2047-06-06T01:20:08+08:00",
    "Summer Solstice": "2047-06-21T18:02:45+08:00",
    "Minor Heat": "2047-07-07T11:29:44+08:00",
    "Major Heat": "2047-07-23T04:54:44+08:00",
    "Start of Autumn": "2047-08-07T21:25:08+08:00",
    "End of Heat": "2047-08-23T12:10:08+08:00",
    "White Dew": "2047-09-08T00:37:26+08:00",
    "Autumn Equinox": "2047-09-23T10:07:21+08:00",
    "Cold Dew": "2047-10-08T16:36:57+08:00",
    "Frost's Descent": "2047-10-23T19:47:50+08:00",
    "Start of Winter": "2047-11-07T20:06:36+08:00",
    "Minor Snow": "2047-11-22T17:37:32+08:00",
    "Major Snow": "2047-12-07T13:10:17+08:00",
    "Winter Solstice": "2047-12-22T07:06:29+08:00",
    "Minor Cold": "2048-01-06T00:28:38+08:00",
    "Major Cold": "2048-01-20T17:46:21+08:00"
  },
  
  // 2048
  2048: {
    "Start of Spring": "2048-02-04T12:03:52+08:00",
    "Rain Water": "2048-02-19T07:47:45+08:00",
    "Awakening of Insects": "2048-03-05T05:53:23+08:00",
    "Spring Equinox": "2048-03-20T06:33:05+08:00",
    "Pure Brightness": "2048-04-04T10:24:32+08:00",
    "Grain Rain": "2048-04-19T17:16:41+08:00",
    "Start of Summer": "2048-05-05T03:23:44+08:00",
    "Grain Buds": "2048-05-20T16:07:18+08:00",
    "Grain in Ear": "2048-06-05T07:17:32+08:00",
    "Summer Solstice": "2048-06-20T23:53:10+08:00",
    "Minor Heat": "2048-07-06T17:26:02+08:00",
    "Major Heat": "2048-07-22T10:46:11+08:00",
    "Start of Autumn": "2048-08-07T03:18:06+08:00",
    "End of Heat": "2048-08-22T18:01:44+08:00",
    "White Dew": "2048-09-07T06:27:20+08:00",
    "Autumn Equinox": "2048-09-22T15:59:53+08:00",
    "Cold Dew": "2048-10-07T22:25:59+08:00",
    "Frost's Descent": "2048-10-23T01:41:58+08:00",
    "Start of Winter": "2048-11-07T01:56:05+08:00",
    "Minor Snow": "2048-11-21T23:32:44+08:00",
    "Major Snow": "2048-12-06T19:00:03+08:00",
    "Winter Solstice": "2048-12-21T13:01:30+08:00",
    "Minor Cold": "2049-01-05T06:17:57+08:00",
    "Major Cold": "2049-01-19T23:40:27+08:00"
  },
  
  // 2049
  2049: {
    "Start of Spring": "2049-02-03T17:52:36+08:00",
    "Rain Water": "2049-02-18T13:41:32+08:00",
    "Awakening of Insects": "2049-03-05T11:42:10+08:00",
    "Spring Equinox": "2049-03-20T12:27:52+08:00",
    "Pure Brightness": "2049-04-04T16:13:37+08:00",
    "Grain Rain": "2049-04-19T23:12:43+08:00",
    "Start of Summer": "2049-05-05T09:11:52+08:00",
    "Grain Buds": "2049-05-20T22:03:03+08:00",
    "Grain in Ear": "2049-06-05T13:02:58+08:00",
    "Summer Solstice": "2049-06-21T05:46:32+08:00",
    "Minor Heat": "2049-07-06T23:08:03+08:00",
    "Major Heat": "2049-07-22T16:35:32+08:00",
    "Start of Autumn": "2049-08-07T08:57:09+08:00",
    "End of Heat": "2049-08-22T23:46:35+08:00",
    "White Dew": "2049-09-07T12:04:46+08:00",
    "Autumn Equinox": "2049-09-22T21:41:52+08:00",
    "Cold Dew": "2049-10-08T04:04:15+08:00",
    "Frost's Descent": "2049-10-23T07:24:26+08:00",
    "Start of Winter": "2049-11-07T07:37:38+08:00",
    "Minor Snow": "2049-11-22T05:18:31+08:00",
    "Major Snow": "2049-12-07T00:45:52+08:00",
    "Winter Solstice": "2049-12-21T18:51:23+08:00",
    "Minor Cold": "2050-01-05T12:07:06+08:00",
    "Major Cold": "2050-01-20T05:33:01+08:00"
  },
  
  // 2050
  2050: {
    "Start of Spring": "2050-02-03T23:43:00+08:00",
    "Rain Water": "2050-02-18T19:34:18+08:00",
    "Awakening of Insects": "2050-03-05T17:31:56+08:00",
    "Spring Equinox": "2050-03-20T18:18:49+08:00",
    "Pure Brightness": "2050-04-04T22:02:27+08:00",
    "Grain Rain": "2050-04-20T05:01:25+08:00",
    "Start of Summer": "2050-05-05T15:01:12+08:00",
    "Grain Buds": "2050-05-21T03:50:03+08:00",
    "Grain in Ear": "2050-06-05T18:54:03+08:00",
    "Summer Solstice": "2050-06-21T11:32:14+08:00",
    "Minor Heat": "2050-07-07T05:01:06+08:00",
    "Major Heat": "2050-07-22T22:20:37+08:00",
    "Start of Autumn": "2050-08-07T14:51:43+08:00",
    "End of Heat": "2050-08-23T05:31:54+08:00",
    "White Dew": "2050-09-07T17:59:53+08:00",
    "Autumn Equinox": "2050-09-23T03:27:45+08:00",
    "Cold Dew": "2050-10-08T09:59:23+08:00",
    "Frost's Descent": "2050-10-23T13:11:03+08:00",
    "Start of Winter": "2050-11-07T13:32:54+08:00",
    "Minor Snow": "2050-11-22T11:05:32+08:00",
    "Major Snow": "2050-12-07T06:41:00+08:00",
    "Winter Solstice": "2050-12-22T00:37:55+08:00",
    "Minor Cold": "2051-01-05T18:01:24+08:00",
    "Major Cold": "2051-01-20T11:18:00+08:00"
  },
  
  // 2051
  2051: {
    "Start of Spring": "2051-02-04T05:35:20+08:00",
    "Rain Water": "2051-02-19T01:16:41+08:00",
    "Awakening of Insects": "2051-03-05T23:21:17+08:00",
    "Spring Equinox": "2051-03-20T23:58:25+08:00",
    "Pure Brightness": "2051-04-05T03:48:54+08:00",
    "Grain Rain": "2051-04-20T10:39:53+08:00",
    "Start of Summer": "2051-05-05T20:46:20+08:00",
    "Grain Buds": "2051-05-21T09:30:39+08:00",
    "Grain in Ear": "2051-06-06T00:39:56+08:00",
    "Summer Solstice": "2051-06-21T17:17:53+08:00",
    "Minor Heat": "2051-07-07T10:48:41+08:00",
    "Major Heat": "2051-07-23T04:12:12+08:00",
    "Start of Autumn": "2051-08-07T20:41:04+08:00",
    "End of Heat": "2051-08-23T11:28:23+08:00",
    "White Dew": "2051-09-07T23:50:33+08:00",
    "Autumn Equinox": "2051-09-23T09:26:37+08:00",
    "Cold Dew": "2051-10-08T15:49:41+08:00",
    "Frost's Descent": "2051-10-23T19:09:20+08:00",
    "Start of Winter": "2051-11-07T19:21:22+08:00",
    "Minor Snow": "2051-11-22T17:02:05+08:00",
    "Major Snow": "2051-12-07T12:27:52+08:00",
    "Winter Solstice": "2051-12-22T06:33:21+08:00",
    "Minor Cold": "2052-01-05T23:47:46+08:00",
    "Major Cold": "2052-01-20T17:13:26+08:00"
  },
  
  // 2052
  2052: {
    "Start of Spring": "2052-02-04T11:22:11+08:00",
    "Rain Water": "2052-02-19T07:12:51+08:00",
    "Awakening of Insects": "2052-03-05T05:08:47+08:00",
    "Spring Equinox": "2052-03-20T05:55:20+08:00",
    "Pure Brightness": "2052-04-04T09:36:33+08:00",
    "Grain Rain": "2052-04-19T16:37:10+08:00",
    "Start of Summer": "2052-05-05T02:34:01+08:00",
    "Grain Buds": "2052-05-20T15:28:13+08:00",
    "Grain in Ear": "2052-06-05T06:28:41+08:00",
    "Summer Solstice": "2052-06-20T23:15:27+08:00",
    "Minor Heat": "2052-07-06T16:39:13+08:00",
    "Major Heat": "2052-07-22T10:08:05+08:00",
    "Start of Autumn": "2052-08-07T02:32:29+08:00",
    "End of Heat": "2052-08-22T17:20:43+08:00",
    "White Dew": "2052-09-07T05:41:23+08:00",
    "Autumn Equinox": "2052-09-22T15:14:55+08:00",
    "Cold Dew": "2052-10-07T21:39:03+08:00",
    "Frost's Descent": "2052-10-23T00:54:24+08:00",
    "Start of Winter": "2052-11-07T01:09:06+08:00",
    "Minor Snow": "2052-11-21T22:45:13+08:00",
    "Major Snow": "2052-12-06T18:14:43+08:00",
    "Winter Solstice": "2052-12-21T12:16:26+08:00",
    "Minor Cold": "2053-01-05T05:35:21+08:00",
    "Major Cold": "2053-01-19T22:58:28+08:00"
  },
  
  // 2053
  2053: {
    "Start of Spring": "2053-02-03T17:12:16+08:00",
    "Rain Water": "2053-02-18T13:01:08+08:00",
    "Awakening of Insects": "2053-03-05T11:02:31+08:00",
    "Spring Equinox": "2053-03-20T11:46:37+08:00",
    "Pure Brightness": "2053-04-04T15:33:43+08:00",
    "Grain Rain": "2053-04-19T22:29:30+08:00",
    "Start of Summer": "2053-05-05T08:32:48+08:00",
    "Grain Buds": "2053-05-20T21:18:47+08:00",
    "Grain in Ear": "2053-06-05T12:26:52+08:00",
    "Summer Solstice": "2053-06-21T05:03:22+08:00",
    "Minor Heat": "2053-07-06T22:36:22+08:00",
    "Major Heat": "2053-07-22T15:55:26+08:00",
    "Start of Autumn": "2053-08-07T08:29:14+08:00",
    "End of Heat": "2053-08-22T23:09:29+08:00",
    "White Dew": "2053-09-07T11:37:51+08:00",
    "Autumn Equinox": "2053-09-22T21:05:33+08:00",
    "Cold Dew": "2053-10-08T03:35:18+08:00",
    "Frost's Descent": "2053-10-23T06:46:29+08:00",
    "Start of Winter": "2053-11-07T07:05:22+08:00",
    "Minor Snow": "2053-11-22T04:38:01+08:00",
    "Major Snow": "2053-12-07T00:11:06+08:00",
    "Winter Solstice": "2053-12-21T18:09:11+08:00",
    "Minor Cold": "2054-01-05T11:31:31+08:00",
    "Major Cold": "2054-01-20T04:50:14+08:00"
  },
  
  // 2054
  2054: {
    "Start of Spring": "2054-02-03T23:07:09+08:00",
    "Rain Water": "2054-02-18T18:50:47+08:00",
    "Awakening of Insects": "2054-03-05T16:54:45+08:00",
    "Spring Equinox": "2054-03-20T17:33:42+08:00",
    "Pure Brightness": "2054-04-04T21:22:18+08:00",
    "Grain Rain": "2054-04-20T04:14:19+08:00",
    "Start of Summer": "2054-05-05T14:17:05+08:00",
    "Grain Buds": "2054-05-21T03:02:13+08:00",
    "Grain in Ear": "2054-06-05T18:06:43+08:00",
    "Summer Solstice": "2054-06-21T10:46:25+08:00",
    "Minor Heat": "2054-07-07T04:13:01+08:00",
    "Major Heat": "2054-07-22T21:39:52+08:00",
    "Start of Autumn": "2054-08-07T14:06:12+08:00",
    "End of Heat": "2054-08-23T04:57:41+08:00",
    "White Dew": "2054-09-07T17:18:48+08:00",
    "Autumn Equinox": "2054-09-23T02:58:44+08:00",
    "Cold Dew": "2054-10-08T09:21:26+08:00",
    "Frost's Descent": "2054-10-23T12:44:04+08:00",
    "Start of Winter": "2054-11-07T12:55:31+08:00",
    "Minor Snow": "2054-11-22T10:38:06+08:00",
    "Major Snow": "2054-12-07T06:02:38+08:00",
    "Winter Solstice": "2054-12-22T00:09:11+08:00",
    "Minor Cold": "2055-01-05T17:21:48+08:00",
    "Major Cold": "2055-01-20T10:48:15+08:00"
  },
  
  // 2055
  2055: {
    "Start of Spring": "2055-02-04T04:55:02+08:00",
    "Rain Water": "2055-02-19T00:46:33+08:00",
    "Awakening of Insects": "2055-03-05T22:40:40+08:00",
    "Spring Equinox": "2055-03-20T23:27:52+08:00",
    "Pure Brightness": "2055-04-05T03:07:27+08:00",
    "Grain Rain": "2055-04-20T10:07:47+08:00",
    "Start of Summer": "2055-05-05T20:03:05+08:00",
    "Grain Buds": "2055-05-21T08:55:27+08:00",
    "Grain in Ear": "2055-06-05T23:55:08+08:00",
    "Summer Solstice": "2055-06-21T16:39:08+08:00",
    "Minor Heat": "2055-07-07T10:04:27+08:00",
    "Major Heat": "2055-07-23T03:31:17+08:00",
    "Start of Autumn": "2055-08-07T20:00:16+08:00",
    "End of Heat": "2055-08-23T10:47:48+08:00",
    "White Dew": "2055-09-07T23:14:47+08:00",
    "Autumn Equinox": "2055-09-23T08:48:00+08:00",
    "Cold Dew": "2055-10-08T15:18:16+08:00",
    "Frost's Descent": "2055-10-23T18:32:33+08:00",
    "Start of Winter": "2055-11-07T18:51:59+08:00",
    "Minor Snow": "2055-11-22T16:25:24+08:00",
    "Major Snow": "2055-12-07T11:57:42+08:00",
    "Winter Solstice": "2055-12-22T05:54:51+08:00",
    "Minor Cold": "2056-01-05T23:14:54+08:00",
    "Major Cold": "2056-01-20T16:32:10+08:00"
  },
  
  // 2056
  2056: {
    "Start of Spring": "2056-02-04T10:46:23+08:00",
    "Rain Water": "2056-02-19T06:29:11+08:00",
    "Awakening of Insects": "2056-03-05T04:31:22+08:00",
    "Spring Equinox": "2056-03-20T05:10:18+08:00",
    "Pure Brightness": "2056-04-04T08:59:13+08:00",
    "Grain Rain": "2056-04-19T15:51:20+08:00",
    "Start of Summer": "2056-05-05T01:57:12+08:00",
    "Grain Buds": "2056-05-20T14:41:11+08:00",
    "Grain in Ear": "2056-06-05T05:51:34+08:00",
    "Summer Solstice": "2056-06-20T22:27:29+08:00",
    "Minor Heat": "2056-07-06T16:01:34+08:00",
    "Major Heat": "2056-07-22T09:21:29+08:00",
    "Start of Autumn": "2056-08-07T01:55:18+08:00",
    "End of Heat": "2056-08-22T16:38:18+08:00",
    "White Dew": "2056-09-07T05:06:32+08:00",
    "Autumn Equinox": "2056-09-22T14:38:45+08:00",
    "Cold Dew": "2056-10-07T21:08:20+08:00",
    "Frost's Descent": "2056-10-23T00:24:36+08:00",
    "Start of Winter": "2056-11-07T00:42:34+08:00",
    "Minor Snow": "2056-11-21T22:19:29+08:00",
    "Major Snow": "2056-12-06T17:50:09+08:00",
    "Winter Solstice": "2056-12-21T11:50:53+08:00",
    "Minor Cold": "2057-01-05T05:09:17+08:00",
    "Major Cold": "2057-01-19T22:29:25+08:00"
  },
  
  // 2057
  2057: {
    "Start of Spring": "2057-02-03T16:41:44+08:00",
    "Rain Water": "2057-02-18T12:26:39+08:00",
    "Awakening of Insects": "2057-03-05T10:26:14+08:00",
    "Spring Equinox": "2057-03-20T11:07:11+08:00",
    "Pure Brightness": "2057-04-04T14:51:50+08:00",
    "Grain Rain": "2057-04-19T21:46:46+08:00",
    "Start of Summer": "2057-05-05T07:45:52+08:00",
    "Grain Buds": "2057-05-20T20:34:29+08:00",
    "Grain in Ear": "2057-06-05T11:35:32+08:00",
    "Summer Solstice": "2057-06-21T04:18:20+08:00",
    "Minor Heat": "2057-07-06T21:41:40+08:00",
    "Major Heat": "2057-07-22T15:09:57+08:00",
    "Start of Autumn": "2057-08-07T07:33:10+08:00",
    "End of Heat": "2057-08-22T22:24:16+08:00",
    "White Dew": "2057-09-07T10:43:19+08:00",
    "Autumn Equinox": "2057-09-22T20:22:32+08:00",
    "Cold Dew": "2057-10-08T02:45:23+08:00",
    "Frost's Descent": "2057-10-23T06:08:15+08:00",
    "Start of Winter": "2057-11-07T06:22:02+08:00",
    "Minor Snow": "2057-11-22T04:05:56+08:00",
    "Major Snow": "2057-12-06T23:33:53+08:00",
    "Winter Solstice": "2057-12-21T17:42:07+08:00",
    "Minor Cold": "2058-01-05T10:57:47+08:00",
    "Major Cold": "2058-01-20T04:25:16+08:00"
  },
  
  // 2058
  2058: {
    "Start of Spring": "2058-02-03T22:33:44+08:00",
    "Rain Water": "2058-02-18T18:24:52+08:00",
    "Awakening of Insects": "2058-03-05T16:19:07+08:00",
    "Spring Equinox": "2058-03-20T17:04:16+08:00",
    "Pure Brightness": "2058-04-04T20:43:13+08:00",
    "Grain Rain": "2058-04-20T03:40:07+08:00",
    "Start of Summer": "2058-05-05T13:35:14+08:00",
    "Grain Buds": "2058-05-21T02:23:18+08:00",
    "Grain in Ear": "2058-06-05T17:23:58+08:00",
    "Summer Solstice": "2058-06-21T10:03:19+08:00",
    "Minor Heat": "2058-07-07T03:30:46+08:00",
    "Major Heat": "2058-07-22T20:53:03+08:00",
    "Start of Autumn": "2058-08-07T13:24:29+08:00",
    "End of Heat": "2058-08-23T04:07:59+08:00",
    "White Dew": "2058-09-07T16:37:15+08:00",
    "Autumn Equinox": "2058-09-23T02:07:40+08:00",
    "Cold Dew": "2058-10-08T08:40:28+08:00",
    "Frost's Descent": "2058-10-23T11:53:39+08:00",
    "Start of Winter": "2058-11-07T12:16:22+08:00",
    "Minor Snow": "2058-11-22T09:50:02+08:00",
    "Major Snow": "2058-12-07T05:26:20+08:00",
    "Winter Solstice": "2058-12-21T23:24:13+08:00",
    "Minor Cold": "2059-01-05T16:48:25+08:00",
    "Major Cold": "2059-01-20T10:05:47+08:00"
  },
  
  // 2059
  2059: {
    "Start of Spring": "2059-02-04T04:23:11+08:00",
    "Rain Water": "2059-02-19T00:04:28+08:00",
    "Awakening of Insects": "2059-03-05T22:07:58+08:00",
    "Spring Equinox": "2059-03-20T22:43:32+08:00",
    "Pure Brightness": "2059-04-05T02:31:40+08:00",
    "Grain Rain": "2059-04-20T09:19:31+08:00",
    "Start of Summer": "2059-05-05T19:23:12+08:00",
    "Grain Buds": "2059-05-21T08:03:49+08:00",
    "Grain in Ear": "2059-06-05T23:11:30+08:00",
    "Summer Solstice": "2059-06-21T15:46:32+08:00",
    "Minor Heat": "2059-07-07T09:18:03+08:00",
    "Major Heat": "2059-07-23T02:40:08+08:00",
    "Start of Autumn": "2059-08-07T19:11:57+08:00",
    "End of Heat": "2059-08-23T09:59:25+08:00",
    "White Dew": "2059-09-07T22:25:48+08:00",
    "Autumn Equinox": "2059-09-23T08:02:47+08:00",
    "Cold Dew": "2059-10-08T14:29:51+08:00",
    "Frost's Descent": "2059-10-23T17:50:02+08:00",
    "Start of Winter": "2059-11-07T18:04:54+08:00",
    "Minor Snow": "2059-11-22T15:45:12+08:00",
    "Major Snow": "2059-12-07T11:12:50+08:00",
    "Winter Solstice": "2059-12-22T05:17:13+08:00",
    "Minor Cold": "2060-01-05T22:33:05+08:00",
    "Major Cold": "2060-01-20T15:57:22+08:00"
  },

  // 2060
  2060: {
    "Start of Spring": "2060-02-04T10:07:24+08:00",
    "Rain Water": "2060-02-19T05:56:29+08:00",
    "Awakening of Insects": "2060-03-05T03:53:19+08:00",
    "Spring Equinox": "2060-03-20T04:37:46+08:00",
    "Pure Brightness": "2060-04-04T08:18:58+08:00",
    "Grain Rain": "2060-04-19T15:16:36+08:00",
    "Start of Summer": "2060-05-05T01:12:03+08:00",
    "Grain Buds": "2060-05-20T14:02:44+08:00",
    "Grain in Ear": "2060-06-05T05:00:48+08:00",
    "Summer Solstice": "2060-06-20T21:44:53+08:00",
    "Minor Heat": "2060-07-06T15:06:30+08:00",
    "Major Heat": "2060-07-22T08:35:00+08:00",
    "Start of Autumn": "2060-08-07T00:58:23+08:00",
    "End of Heat": "2060-08-22T15:48:48+08:00",
    "White Dew": "2060-09-07T04:09:51+08:00",
    "Autumn Equinox": "2060-09-22T13:47:26+08:00",
    "Cold Dew": "2060-10-07T20:12:45+08:00",
    "Frost's Descent": "2060-10-22T23:32:39+08:00",
    "Start of Winter": "2060-11-06T23:48:06+08:00",
    "Minor Snow": "2060-11-21T21:27:52+08:00",
    "Major Snow": "2060-12-06T16:56:48+08:00",
    "Winter Solstice": "2060-12-21T11:00:41+08:00",
    "Minor Cold": "2061-01-05T04:17:40+08:00",
    "Major Cold": "2061-01-19T21:41:52+08:00"
  },

  // 2061
  2061: {
    "Start of Spring": "2061-02-03T15:52:57+08:00",
    "Rain Water": "2061-02-18T11:42:25+08:00",
    "Awakening of Insects": "2061-03-05T09:40:53+08:00",
    "Spring Equinox": "2061-03-20T10:25:31+08:00",
    "Pure Brightness": "2061-04-04T14:09:37+08:00",
    "Grain Rain": "2061-04-19T21:05:46+08:00",
    "Start of Summer": "2061-05-05T07:05:43+08:00",
    "Grain Buds": "2061-05-20T19:51:31+08:00",
    "Grain in Ear": "2061-06-05T10:55:52+08:00",
    "Summer Solstice": "2061-06-21T03:31:29+08:00",
    "Minor Heat": "2061-07-06T21:01:19+08:00",
    "Major Heat": "2061-07-22T14:19:35+08:00",
    "Start of Autumn": "2061-08-07T06:52:04+08:00",
    "End of Heat": "2061-08-22T21:32:22+08:00",
    "White Dew": "2061-09-07T10:01:47+08:00",
    "Autumn Equinox": "2061-09-22T19:30:38+08:00",
    "Cold Dew": "2061-10-08T02:03:21+08:00",
    "Frost's Descent": "2061-10-23T05:16:28+08:00",
    "Start of Winter": "2061-11-07T05:39:06+08:00",
    "Minor Snow": "2061-11-22T03:13:26+08:00",
    "Major Snow": "2061-12-06T22:49:37+08:00",
    "Winter Solstice": "2061-12-21T16:48:06+08:00",
    "Minor Cold": "2062-01-05T10:11:57+08:00",
    "Major Cold": "2062-01-20T03:29:25+08:00"
  },

  // 2062
  2062: {
    "Start of Spring": "2062-02-03T21:46:16+08:00",
    "Rain Water": "2062-02-18T17:27:30+08:00",
    "Awakening of Insects": "2062-03-05T15:30:38+08:00",
    "Spring Equinox": "2062-03-20T16:06:44+08:00",
    "Pure Brightness": "2062-04-04T19:54:40+08:00",
    "Grain Rain": "2062-04-20T02:43:53+08:00",
    "Start of Summer": "2062-05-05T12:46:40+08:00",
    "Grain Buds": "2062-05-21T01:29:02+08:00",
    "Grain in Ear": "2062-06-05T16:34:00+08:00",
    "Summer Solstice": "2062-06-21T09:10:39+08:00",
    "Minor Heat": "2062-07-07T02:37:40+08:00",
    "Major Heat": "2062-07-22T20:01:26+08:00",
    "Start of Autumn": "2062-08-07T12:28:10+08:00",
    "End of Heat": "2062-08-23T03:17:33+08:00",
    "White Dew": "2062-09-07T15:39:39+08:00",
    "Autumn Equinox": "2062-09-23T01:19:10+08:00",
    "Cold Dew": "2062-10-08T07:43:48+08:00",
    "Frost's Descent": "2062-10-23T11:07:37+08:00",
    "Start of Winter": "2062-11-07T11:21:46+08:00",
    "Minor Snow": "2062-11-22T09:06:22+08:00",
    "Major Snow": "2062-12-07T04:33:42+08:00",
    "Winter Solstice": "2062-12-21T22:41:55+08:00",
    "Minor Cold": "2063-01-05T15:56:27+08:00",
    "Major Cold": "2063-01-20T09:23:13+08:00"
  },

  // 2063
  2063: {
    "Start of Spring": "2063-02-04T03:30:24+08:00",
    "Rain Water": "2063-02-18T23:20:35+08:00",
    "Awakening of Insects": "2063-03-05T21:13:37+08:00",
    "Spring Equinox": "2063-03-20T21:58:28+08:00",
    "Pure Brightness": "2063-04-05T01:36:09+08:00",
    "Grain Rain": "2063-04-20T08:34:14+08:00",
    "Start of Summer": "2063-05-05T18:27:33+08:00",
    "Grain Buds": "2063-05-21T07:18:53+08:00",
    "Grain in Ear": "2063-06-05T22:16:49+08:00",
    "Summer Solstice": "2063-06-21T15:01:10+08:00",
    "Minor Heat": "2063-07-07T08:24:42+08:00",
    "Major Heat": "2063-07-23T01:52:35+08:00",
    "Start of Autumn": "2063-08-07T18:19:20+08:00",
    "End of Heat": "2063-08-23T09:08:04+08:00",
    "White Dew": "2063-09-07T21:32:47+08:00",
    "Autumn Equinox": "2063-09-23T07:07:29+08:00",
    "Cold Dew": "2063-10-08T13:36:09+08:00",
    "Frost's Descent": "2063-10-23T16:52:34+08:00",
    "Start of Winter": "2063-11-07T17:11:20+08:00",
    "Minor Snow": "2063-11-22T14:47:37+08:00",
    "Major Snow": "2063-12-07T10:19:59+08:00",
    "Winter Solstice": "2063-12-22T04:20:21+08:00",
    "Minor Cold": "2064-01-05T21:40:30+08:00",
    "Major Cold": "2064-01-20T15:00:37+08:00"
  },

  // 2064
  2064: {
    "Start of Spring": "2064-02-04T09:14:04+08:00",
    "Rain Water": "2064-02-19T04:58:35+08:00",
    "Awakening of Insects": "2064-03-05T02:58:37+08:00",
    "Spring Equinox": "2064-03-20T03:37:54+08:00",
    "Pure Brightness": "2064-04-04T07:23:36+08:00",
    "Grain Rain": "2064-04-19T14:15:07+08:00",
    "Start of Summer": "2064-05-05T00:17:46+08:00",
    "Grain Buds": "2064-05-20T13:01:00+08:00",
    "Grain in Ear": "2064-06-05T04:09:22+08:00",
    "Summer Solstice": "2064-06-20T20:44:55+08:00",
    "Minor Heat": "2064-07-06T14:18:52+08:00",
    "Major Heat": "2064-07-22T07:38:38+08:00",
    "Start of Autumn": "2064-08-07T00:13:34+08:00",
    "End of Heat": "2064-08-22T14:55:56+08:00",
    "White Dew": "2064-09-07T03:25:36+08:00",
    "Autumn Equinox": "2064-09-22T12:56:20+08:00",
    "Cold Dew": "2064-10-07T19:27:13+08:00",
    "Frost's Descent": "2064-10-22T22:41:32+08:00",
    "Start of Winter": "2064-11-06T23:00:53+08:00",
    "Minor Snow": "2064-11-21T20:36:01+08:00",
    "Major Snow": "2064-12-06T16:08:31+08:00",
    "Winter Solstice": "2064-12-21T10:08:02+08:00",
    "Minor Cold": "2065-01-05T03:28:46+08:00",
    "Major Cold": "2065-01-19T20:48:07+08:00"
  },

  // 2065
  2065: {
    "Start of Spring": "2065-02-03T15:02:53+08:00",
    "Rain Water": "2065-02-18T10:46:51+08:00",
    "Awakening of Insects": "2065-03-05T08:48:22+08:00",
    "Spring Equinox": "2065-03-20T09:27:28+08:00",
    "Pure Brightness": "2065-04-04T13:13:10+08:00",
    "Grain Rain": "2065-04-19T20:05:09+08:00",
    "Start of Summer": "2065-05-05T06:04:39+08:00",
    "Grain Buds": "2065-05-20T18:49:58+08:00",
    "Grain in Ear": "2065-06-05T09:51:25+08:00",
    "Summer Solstice": "2065-06-21T02:31:45+08:00",
    "Minor Heat": "2065-07-06T19:56:05+08:00",
    "Major Heat": "2065-07-22T13:23:40+08:00",
    "Start of Autumn": "2065-08-07T05:48:32+08:00",
    "End of Heat": "2065-08-22T20:40:37+08:00",
    "White Dew": "2065-09-07T09:01:12+08:00",
    "Autumn Equinox": "2065-09-22T18:41:52+08:00",
    "Cold Dew": "2065-10-08T01:05:10+08:00",
    "Frost's Descent": "2065-10-23T04:28:56+08:00",
    "Start of Winter": "2065-11-07T04:41:50+08:00",
    "Minor Snow": "2065-11-22T02:25:50+08:00",
    "Major Snow": "2065-12-06T21:52:07+08:00",
    "Winter Solstice": "2065-12-21T16:00:02+08:00",
    "Minor Cold": "2066-01-05T09:14:02+08:00",
    "Major Cold": "2066-01-20T02:41:21+08:00"
  },

  // 2066
  2066: {
    "Start of Spring": "2066-02-03T20:48:35+08:00",
    "Rain Water": "2066-02-18T16:39:58+08:00",
    "Awakening of Insects": "2066-03-05T14:33:21+08:00",
    "Spring Equinox": "2066-03-20T15:19:05+08:00",
    "Pure Brightness": "2066-04-04T18:56:59+08:00",
    "Grain Rain": "2066-04-20T01:54:32+08:00",
    "Start of Summer": "2066-05-05T11:47:55+08:00",
    "Grain Buds": "2066-05-21T00:36:43+08:00",
    "Grain in Ear": "2066-06-05T15:35:07+08:00",
    "Summer Solstice": "2066-06-21T08:15:40+08:00",
    "Minor Heat": "2066-07-07T01:41:08+08:00",
    "Major Heat": "2066-07-22T19:05:33+08:00",
    "Start of Autumn": "2066-08-07T11:36:11+08:00",
    "End of Heat": "2066-08-23T02:22:45+08:00",
    "White Dew": "2066-09-07T14:52:34+08:00",
    "Autumn Equinox": "2066-09-23T00:26:17+08:00",
    "Cold Dew": "2066-10-08T07:00:06+08:00",
    "Frost's Descent": "2066-10-23T10:15:39+08:00",
    "Start of Winter": "2066-11-07T10:38:29+08:00",
    "Minor Snow": "2066-11-22T08:12:51+08:00",
    "Major Snow": "2066-12-07T03:47:43+08:00",
    "Winter Solstice": "2066-12-21T21:44:47+08:00",
    "Minor Cold": "2067-01-05T15:06:18+08:00",
    "Major Cold": "2067-01-20T08:22:09+08:00"
  },

  // 2067
  2067: {
    "Start of Spring": "2067-02-04T02:36:34+08:00",
    "Rain Water": "2067-02-18T22:16:36+08:00",
    "Awakening of Insects": "2067-03-05T20:17:46+08:00",
    "Spring Equinox": "2067-03-20T20:52:53+08:00",
    "Pure Brightness": "2067-04-05T00:39:51+08:00",
    "Grain Rain": "2067-04-20T07:27:52+08:00",
    "Start of Summer": "2067-05-05T17:31:26+08:00",
    "Grain Buds": "2067-05-21T06:12:11+08:00",
    "Grain in Ear": "2067-06-05T21:20:34+08:00",
    "Summer Solstice": "2067-06-21T13:55:16+08:00",
    "Minor Heat": "2067-07-07T07:28:24+08:00",
    "Major Heat": "2067-07-23T00:49:53+08:00",
    "Start of Autumn": "2067-08-07T17:24:20+08:00",
    "End of Heat": "2067-08-23T08:11:30+08:00",
    "White Dew": "2067-09-07T20:41:33+08:00",
    "Autumn Equinox": "2067-09-23T06:18:55+08:00",
    "Cold Dew": "2067-10-08T12:50:12+08:00",
    "Frost's Descent": "2067-10-23T16:11:03+08:00",
    "Start of Winter": "2067-11-07T16:29:41+08:00",
    "Minor Snow": "2067-11-22T14:09:52+08:00",
    "Major Snow": "2067-12-07T09:39:52+08:00",
    "Winter Solstice": "2067-12-22T03:42:22+08:00",
    "Minor Cold": "2068-01-05T20:58:41+08:00",
    "Major Cold": "2068-01-20T14:19:14+08:00"
  },

  // 2068
  2068: {
    "Start of Spring": "2068-02-04T08:28:16+08:00",
    "Rain Water": "2068-02-19T04:12:40+08:00",
    "Awakening of Insects": "2068-03-05T02:08:10+08:00",
    "Spring Equinox": "2068-03-20T02:48:16+08:00",
    "Pure Brightness": "2068-04-04T06:28:58+08:00",
    "Grain Rain": "2068-04-19T13:23:39+08:00",
    "Start of Summer": "2068-05-04T23:19:50+08:00",
    "Grain Buds": "2068-05-20T12:09:16+08:00",
    "Grain in Ear": "2068-06-05T03:08:48+08:00",
    "Summer Solstice": "2068-06-20T19:53:02+08:00",
    "Minor Heat": "2068-07-06T13:16:07+08:00",
    "Major Heat": "2068-07-22T06:45:56+08:00",
    "Start of Autumn": "2068-08-06T23:10:23+08:00",
    "End of Heat": "2068-08-22T14:03:12+08:00",
    "White Dew": "2068-09-07T02:25:05+08:00",
    "Autumn Equinox": "2068-09-22T12:06:02+08:00",
    "Cold Dew": "2068-10-07T18:32:19+08:00",
    "Frost's Descent": "2068-10-22T21:56:13+08:00",
    "Start of Winter": "2068-11-06T22:12:39+08:00",
    "Minor Snow": "2068-11-21T19:56:15+08:00",
    "Major Snow": "2068-12-06T15:25:25+08:00",
    "Winter Solstice": "2068-12-21T09:31:56+08:00",
    "Minor Cold": "2069-01-05T02:47:33+08:00",
    "Major Cold": "2069-01-19T20:12:23+08:00"
  },

  // 2069
  2069: {
    "Start of Spring": "2069-02-03T14:20:04+08:00",
    "Rain Water": "2069-02-18T10:08:16+08:00",
    "Awakening of Insects": "2069-03-05T08:01:48+08:00",
    "Spring Equinox": "2069-03-20T08:44:19+08:00",
    "Pure Brightness": "2069-04-04T12:23:14+08:00",
    "Grain Rain": "2069-04-19T19:17:59+08:00",
    "Start of Summer": "2069-05-05T05:13:57+08:00",
    "Grain Buds": "2069-05-20T18:00:16+08:00",
    "Grain in Ear": "2069-06-05T09:02:35+08:00",
    "Summer Solstice": "2069-06-21T01:40:33+08:00",
    "Minor Heat": "2069-07-06T19:10:13+08:00",
    "Major Heat": "2069-07-22T12:31:37+08:00",
    "Start of Autumn": "2069-08-07T05:05:15+08:00",
    "End of Heat": "2069-08-22T19:48:32+08:00",
    "White Dew": "2069-09-07T08:19:53+08:00",
    "Autumn Equinox": "2069-09-22T17:51:09+08:00",
    "Cold Dew": "2069-10-08T00:26:15+08:00",
    "Frost's Descent": "2069-10-23T03:41:25+08:00",
    "Start of Winter": "2069-11-07T04:06:43+08:00",
    "Minor Snow": "2069-11-22T01:42:53+08:00",
    "Major Snow": "2069-12-06T21:21:35+08:00",
    "Winter Solstice": "2069-12-21T15:21:19+08:00",
    "Minor Cold": "2070-01-05T08:46:46+08:00",
    "Major Cold": "2070-01-20T02:04:15+08:00"
  },

  // 2070
  2070: {
    "Start of Spring": "2070-02-03T20:21:03+08:00",
    "Rain Water": "2070-02-18T16:00:29+08:00",
    "Awakening of Insects": "2070-03-05T14:01:40+08:00",
    "Spring Equinox": "2070-03-20T14:34:10+08:00",
    "Pure Brightness": "2070-04-04T18:19:02+08:00",
    "Grain Rain": "2070-04-20T01:03:45+08:00",
    "Start of Summer": "2070-05-05T11:04:02+08:00",
    "Grain Buds": "2070-05-20T23:42:32+08:00",
    "Grain in Ear": "2070-06-05T14:47:15+08:00",
    "Summer Solstice": "2070-06-21T07:21:51+08:00",
    "Minor Heat": "2070-07-07T00:51:19+08:00",
    "Major Heat": "2070-07-22T18:14:57+08:00",
    "Start of Autumn": "2070-08-07T10:45:51+08:00",
    "End of Heat": "2070-08-23T01:36:25+08:00",
    "White Dew": "2070-09-07T14:03:03+08:00",
    "Autumn Equinox": "2070-09-22T23:44:06+08:00",
    "Cold Dew": "2070-10-08T06:12:36+08:00",
    "Frost's Descent": "2070-10-23T09:37:38+08:00",
    "Start of Winter": "2070-11-07T09:54:48+08:00",
    "Minor Snow": "2070-11-22T07:40:11+08:00",
    "Major Snow": "2070-12-07T03:10:00+08:00",
    "Winter Solstice": "2070-12-21T21:18:35+08:00",
    "Minor Cold": "2071-01-05T14:35:10+08:00",
    "Major Cold": "2071-01-20T08:01:40+08:00"
  },

  // 2071
  2071: {
    "Start of Spring": "2071-02-04T02:10:05+08:00",
    "Rain Water": "2071-02-18T21:58:56+08:00",
    "Awakening of Insects": "2071-03-05T19:51:51+08:00",
    "Spring Equinox": "2071-03-20T20:33:56+08:00",
    "Pure Brightness": "2071-04-05T00:09:51+08:00",
    "Grain Rain": "2071-04-20T07:04:08+08:00",
    "Start of Summer": "2071-05-05T16:54:28+08:00",
    "Grain Buds": "2071-05-21T05:42:14+08:00",
    "Grain in Ear": "2071-06-05T20:37:12+08:00",
    "Summer Solstice": "2071-06-21T13:20:05+08:00",
    "Minor Heat": "2071-07-07T06:42:02+08:00",
    "Major Heat": "2071-07-23T00:11:30+08:00",
    "Start of Autumn": "2071-08-07T16:38:24+08:00",
    "End of Heat": "2071-08-23T07:31:08+08:00",
    "White Dew": "2071-09-07T19:57:12+08:00",
    "Autumn Equinox": "2071-09-23T05:37:00+08:00",
    "Cold Dew": "2071-10-08T12:07:13+08:00",
    "Frost's Descent": "2071-10-23T15:28:25+08:00",
    "Start of Winter": "2071-11-07T15:47:57+08:00",
    "Minor Snow": "2071-11-22T13:27:57+08:00",
    "Major Snow": "2071-12-07T09:00:02+08:00",
    "Winter Solstice": "2071-12-22T03:03:07+08:00",
    "Minor Cold": "2072-01-05T20:22:12+08:00",
    "Major Cold": "2072-01-20T13:44:25+08:00"
  },

  // 2072
  2072: {
    "Start of Spring": "2072-02-04T07:56:15+08:00",
    "Rain Water": "2072-02-19T03:42:23+08:00",
    "Awakening of Insects": "2072-03-05T01:40:12+08:00",
    "Spring Equinox": "2072-03-20T02:20:20+08:00",
    "Pure Brightness": "2072-04-04T06:02:57+08:00",
    "Grain Rain": "2072-04-19T12:54:16+08:00",
    "Start of Summer": "2072-05-04T22:52:58+08:00",
    "Grain Buds": "2072-05-20T11:34:55+08:00",
    "Grain in Ear": "2072-06-05T02:39:12+08:00",
    "Summer Solstice": "2072-06-20T19:13:03+08:00",
    "Minor Heat": "2072-07-06T12:44:26+08:00",
    "Major Heat": "2072-07-22T06:03:24+08:00",
    "Start of Autumn": "2072-08-06T22:38:36+08:00",
    "End of Heat": "2072-08-22T13:21:45+08:00",
    "White Dew": "2072-09-07T01:54:23+08:00",
    "Autumn Equinox": "2072-09-22T11:27:06+08:00",
    "Cold Dew": "2072-10-07T18:02:32+08:00",
    "Frost's Descent": "2072-10-22T21:19:07+08:00",
    "Start of Winter": "2072-11-06T21:43:06+08:00",
    "Minor Snow": "2072-11-21T19:19:42+08:00",
    "Major Snow": "2072-12-06T14:55:43+08:00",
    "Winter Solstice": "2072-12-21T08:55:17+08:00",
    "Minor Cold": "2073-01-05T02:18:06+08:00",
    "Major Cold": "2073-01-19T19:36:14+08:00"
  },

  // 2073
  2073: {
    "Start of Spring": "2073-02-03T13:52:00+08:00",
    "Rain Water": "2073-02-18T09:34:01+08:00",
    "Awakening of Insects": "2073-03-05T07:35:58+08:00",
    "Spring Equinox": "2073-03-20T08:12:36+08:00",
    "Pure Brightness": "2073-04-04T11:58:32+08:00",
    "Grain Rain": "2073-04-19T18:47:29+08:00",
    "Start of Summer": "2073-05-05T04:47:03+08:00",
    "Grain Buds": "2073-05-20T17:28:44+08:00",
    "Grain in Ear": "2073-06-05T08:29:55+08:00",
    "Summer Solstice": "2073-06-21T01:06:16+08:00",
    "Minor Heat": "2073-07-06T18:30:07+08:00",
    "Major Heat": "2073-07-22T11:54:29+08:00",
    "Start of Autumn": "2073-08-07T04:19:29+08:00",
    "End of Heat": "2073-08-22T19:10:30+08:00",
    "White Dew": "2073-09-07T07:32:34+08:00",
    "Autumn Equinox": "2073-09-22T17:14:33+08:00",
    "Cold Dew": "2073-10-07T23:40:33+08:00",
    "Frost's Descent": "2073-10-23T03:07:18+08:00",
    "Start of Winter": "2073-11-07T03:23:22+08:00",
    "Minor Snow": "2073-11-22T01:10:43+08:00",
    "Major Snow": "2073-12-06T20:39:40+08:00",
    "Winter Solstice": "2073-12-21T14:49:58+08:00",
    "Minor Cold": "2074-01-05T08:05:20+08:00",
    "Major Cold": "2074-01-20T01:33:25+08:00"
  },

  // 2074
  2074: {
    "Start of Spring": "2074-02-03T19:40:32+08:00",
    "Rain Water": "2074-02-18T15:31:19+08:00",
    "Awakening of Insects": "2074-03-05T13:23:33+08:00",
    "Spring Equinox": "2074-03-20T14:08:08+08:00",
    "Pure Brightness": "2074-04-04T17:44:24+08:00",
    "Grain Rain": "2074-04-20T00:40:59+08:00",
    "Start of Summer": "2074-05-05T10:32:25+08:00",
    "Grain Buds": "2074-05-20T23:20:55+08:00",
    "Grain in Ear": "2074-06-05T14:16:56+08:00",
    "Summer Solstice": "2074-06-21T06:57:43+08:00",
    "Minor Heat": "2074-07-07T00:20:15+08:00",
    "Major Heat": "2074-07-22T17:45:00+08:00",
    "Start of Autumn": "2074-08-07T10:12:30+08:00",
    "End of Heat": "2074-08-23T00:59:50+08:00",
    "White Dew": "2074-09-07T13:27:32+08:00",
    "Autumn Equinox": "2074-09-22T23:03:03+08:00",
    "Cold Dew": "2074-10-08T05:36:30+08:00",
    "Frost's Descent": "2074-10-23T08:55:05+08:00",
    "Start of Winter": "2074-11-07T09:18:59+08:00",
    "Minor Snow": "2074-11-22T06:57:10+08:00",
    "Major Snow": "2074-12-07T02:33:41+08:00",
    "Winter Solstice": "2074-12-21T20:34:31+08:00",
    "Minor Cold": "2075-01-05T13:57:08+08:00",
    "Major Cold": "2075-01-20T07:15:47+08:00"
  },

  // 2075
  2075: {
    "Start of Spring": "2075-02-04T01:29:52+08:00",
    "Rain Water": "2075-02-18T21:11:16+08:00",
    "Awakening of Insects": "2075-03-05T19:10:38+08:00",
    "Spring Equinox": "2075-03-20T19:45:50+08:00",
    "Pure Brightness": "2075-04-04T23:30:17+08:00",
    "Grain Rain": "2075-04-20T06:17:40+08:00",
    "Start of Summer": "2075-05-05T16:18:58+08:00",
    "Grain Buds": "2075-05-21T04:58:52+08:00",
    "Grain in Ear": "2075-06-05T20:05:58+08:00",
    "Summer Solstice": "2075-06-21T12:39:43+08:00",
    "Minor Heat": "2075-07-07T06:12:45+08:00",
    "Major Heat": "2075-07-22T23:32:45+08:00",
    "Start of Autumn": "2075-08-07T16:07:39+08:00",
    "End of Heat": "2075-08-23T06:52:30+08:00",
    "White Dew": "2075-09-07T19:23:13+08:00",
    "Autumn Equinox": "2075-09-23T04:58:06+08:00",
    "Cold Dew": "2075-10-08T11:30:43+08:00",
    "Frost's Descent": "2075-10-23T14:49:53+08:00",
    "Start of Winter": "2075-11-07T15:10:53+08:00",
    "Minor Snow": "2075-11-22T12:50:27+08:00",
    "Major Snow": "2075-12-07T08:23:44+08:00",
    "Winter Solstice": "2075-12-22T02:26:21+08:00",
    "Minor Cold": "2076-01-05T19:46:20+08:00",
    "Major Cold": "2076-01-20T13:06:57+08:00"
  },

  // 2076
  2076: {
    "Start of Spring": "2076-02-04T07:19:09+08:00",
    "Rain Water": "2076-02-19T03:02:42+08:00",
    "Awakening of Insects": "2076-03-05T01:00:11+08:00",
    "Spring Equinox": "2076-03-20T01:38:08+08:00",
    "Pure Brightness": "2076-04-04T05:19:37+08:00",
    "Grain Rain": "2076-04-19T12:11:15+08:00",
    "Start of Summer": "2076-05-04T22:07:39+08:00",
    "Grain Buds": "2076-05-20T10:54:06+08:00",
    "Grain in Ear": "2076-06-05T01:53:50+08:00",
    "Summer Solstice": "2076-06-20T18:36:04+08:00",
    "Minor Heat": "2076-07-06T11:59:41+08:00",
    "Major Heat": "2076-07-22T05:28:57+08:00",
    "Start of Autumn": "2076-08-06T21:53:50+08:00",
    "End of Heat": "2076-08-22T12:46:59+08:00",
    "White Dew": "2076-09-07T01:08:18+08:00",
    "Autumn Equinox": "2076-09-22T10:49:32+08:00",
    "Cold Dew": "2076-10-07T17:14:10+08:00",
    "Frost's Descent": "2076-10-22T20:38:17+08:00",
    "Start of Winter": "2076-11-06T20:52:46+08:00",
    "Minor Snow": "2076-11-21T18:37:00+08:00",
    "Major Snow": "2076-12-06T14:04:47+08:00",
    "Winter Solstice": "2076-12-21T08:12:40+08:00",
    "Minor Cold": "2077-01-05T01:27:46+08:00",
    "Major Cold": "2077-01-19T18:54:40+08:00"
  },

  // 2077
  2077: {
    "Start of Spring": "2077-02-03T13:02:24+08:00",
    "Rain Water": "2077-02-18T08:52:50+08:00",
    "Awakening of Insects": "2077-03-05T06:46:07+08:00",
    "Spring Equinox": "2077-03-20T07:30:22+08:00",
    "Pure Brightness": "2077-04-04T11:08:01+08:00",
    "Grain Rain": "2077-04-19T18:03:42+08:00",
    "Start of Summer": "2077-05-05T03:57:21+08:00",
    "Grain Buds": "2077-05-20T16:44:18+08:00",
    "Grain in Ear": "2077-06-05T07:43:51+08:00",
    "Summer Solstice": "2077-06-21T00:22:45+08:00",
    "Minor Heat": "2077-07-06T17:50:09+08:00",
    "Major Heat": "2077-07-22T11:13:08+08:00",
    "Start of Autumn": "2077-08-07T03:45:47+08:00",
    "End of Heat": "2077-08-22T18:31:05+08:00",
    "White Dew": "2077-09-07T07:02:27+08:00",
    "Autumn Equinox": "2077-09-22T16:35:08+08:00",
    "Cold Dew": "2077-10-07T23:10:05+08:00",
    "Frost's Descent": "2077-10-23T02:25:17+08:00",
    "Start of Winter": "2077-11-07T02:49:34+08:00",
    "Minor Snow": "2077-11-22T00:24:38+08:00",
    "Major Snow": "2077-12-06T20:01:45+08:00",
    "Winter Solstice": "2077-12-21T14:00:06+08:00",
    "Minor Cold": "2078-01-05T07:24:04+08:00",
    "Major Cold": "2078-01-20T00:40:41+08:00"
  },

  // 2078
  2078: {
    "Start of Spring": "2078-02-03T18:56:39+08:00",
    "Rain Water": "2078-02-18T14:36:04+08:00",
    "Awakening of Insects": "2078-03-05T12:37:12+08:00",
    "Spring Equinox": "2078-03-20T13:10:09+08:00",
    "Pure Brightness": "2078-04-04T16:55:23+08:00",
    "Grain Rain": "2078-04-19T23:40:12+08:00",
    "Start of Summer": "2078-05-05T09:40:55+08:00",
    "Grain Buds": "2078-05-20T22:18:41+08:00",
    "Grain in Ear": "2078-06-05T13:24:03+08:00",
    "Summer Solstice": "2078-06-21T05:57:15+08:00",
    "Minor Heat": "2078-07-06T23:28:05+08:00",
    "Major Heat": "2078-07-22T16:50:14+08:00",
    "Start of Autumn": "2078-08-07T09:23:27+08:00",
    "End of Heat": "2078-08-23T00:13:12+08:00",
    "White Dew": "2078-09-07T12:42:56+08:00",
    "Autumn Equinox": "2078-09-22T22:23:49+08:00",
    "Cold Dew": "2078-10-08T04:55:18+08:00",
    "Frost's Descent": "2078-10-23T08:19:49+08:00",
    "Start of Winter": "2078-11-07T08:38:41+08:00",
    "Minor Snow": "2078-11-22T06:22:11+08:00",
    "Major Snow": "2078-12-07T01:52:03+08:00",
    "Winter Solstice": "2078-12-21T19:57:16+08:00",
    "Minor Cold": "2079-01-05T13:12:47+08:00",
    "Major Cold": "2079-01-20T06:35:13+08:00"
  },

  // 2079
  2079: {
    "Start of Spring": "2079-02-04T00:42:30+08:00",
    "Rain Water": "2079-02-18T20:27:42+08:00",
    "Awakening of Insects": "2079-03-05T18:20:17+08:00",
    "Spring Equinox": "2079-03-20T18:59:59+08:00",
    "Pure Brightness": "2079-04-04T22:36:42+08:00",
    "Grain Rain": "2079-04-20T05:29:52+08:00",
    "Start of Summer": "2079-05-05T15:21:37+08:00",
    "Grain Buds": "2079-05-21T04:09:10+08:00",
    "Grain in Ear": "2079-06-05T19:05:14+08:00",
    "Summer Solstice": "2079-06-21T11:48:37+08:00",
    "Minor Heat": "2079-07-07T05:11:01+08:00",
    "Major Heat": "2079-07-22T22:41:50+08:00",
    "Start of Autumn": "2079-08-07T15:08:39+08:00",
    "End of Heat": "2079-08-23T06:03:39+08:00",
    "White Dew": "2079-09-07T18:29:36+08:00",
    "Autumn Equinox": "2079-09-23T04:12:28+08:00",
    "Cold Dew": "2079-10-08T10:42:44+08:00",
    "Frost's Descent": "2079-10-23T14:07:16+08:00",
    "Start of Winter": "2079-11-07T14:26:25+08:00",
    "Minor Snow": "2079-11-22T12:08:58+08:00",
    "Major Snow": "2079-12-07T07:39:20+08:00",
    "Winter Solstice": "2079-12-22T01:43:19+08:00",
    "Minor Cold": "2080-01-05T18:58:54+08:00",
    "Major Cold": "2080-01-20T12:20:17+08:00"
  },

  // 2080
  2080: {
    "Start of Spring": "2080-02-04T06:27:16+08:00",
    "Rain Water": "2080-02-19T02:11:43+08:00",
    "Awakening of Insects": "2080-03-05T00:04:28+08:00",
    "Spring Equinox": "2080-03-20T00:43:27+08:00",
    "Pure Brightness": "2080-04-04T04:22:02+08:00",
    "Grain Rain": "2080-04-19T11:13:40+08:00",
    "Start of Summer": "2080-05-04T21:09:59+08:00",
    "Grain Buds": "2080-05-20T09:53:45+08:00",
    "Grain in Ear": "2080-06-05T00:57:06+08:00",
    "Summer Solstice": "2080-06-20T17:33:25+08:00",
    "Minor Heat": "2080-07-06T11:04:57+08:00",
    "Major Heat": "2080-07-22T04:26:10+08:00",
    "Start of Autumn": "2080-08-06T21:02:26+08:00",
    "End of Heat": "2080-08-22T11:47:18+08:00",
    "White Dew": "2080-09-07T00:21:45+08:00",
    "Autumn Equinox": "2080-09-22T09:55:45+08:00",
    "Cold Dew": "2080-10-07T16:33:39+08:00",
    "Frost's Descent": "2080-10-22T19:51:21+08:00",
    "Start of Winter": "2080-11-06T20:17:58+08:00",
    "Minor Snow": "2080-11-21T17:55:11+08:00",
    "Major Snow": "2080-12-06T13:33:11+08:00",
    "Winter Solstice": "2080-12-21T07:32:08+08:00",
    "Minor Cold": "2081-01-05T00:55:21+08:00",
    "Major Cold": "2081-01-19T18:11:03+08:00"
  },

  // 2081
  2081: {
    "Start of Spring": "2081-02-03T12:25:15+08:00",
    "Rain Water": "2081-02-18T08:03:04+08:00",
    "Awakening of Insects": "2081-03-05T06:02:03+08:00",
    "Spring Equinox": "2081-03-20T06:33:34+08:00",
    "Pure Brightness": "2081-04-04T10:16:34+08:00",
    "Grain Rain": "2081-04-19T17:00:52+08:00",
    "Start of Summer": "2081-05-05T02:59:17+08:00",
    "Grain Buds": "2081-05-20T15:37:58+08:00",
    "Grain in Ear": "2081-06-05T06:40:30+08:00",
    "Summer Solstice": "2081-06-20T23:15:43+08:00",
    "Minor Heat": "2081-07-06T16:42:50+08:00",
    "Major Heat": "2081-07-22T10:07:29+08:00",
    "Start of Autumn": "2081-08-07T02:36:22+08:00",
    "End of Heat": "2081-08-22T17:28:24+08:00",
    "White Dew": "2081-09-07T05:53:57+08:00",
    "Autumn Equinox": "2081-09-22T15:37:09+08:00",
    "Cold Dew": "2081-10-07T22:05:53+08:00",
    "Frost's Descent": "2081-10-23T01:33:52+08:00",
    "Start of Winter": "2081-11-07T01:52:06+08:00",
    "Minor Snow": "2081-11-21T23:40:32+08:00",
    "Major Snow": "2081-12-06T19:11:07+08:00",
    "Winter Solstice": "2081-12-21T13:21:51+08:00",
    "Minor Cold": "2082-01-05T06:37:56+08:00",
    "Major Cold": "2082-01-20T00:05:08+08:00"
  },

  // 2082
  2082: {
    "Start of Spring": "2082-02-03T18:11:32+08:00",
    "Rain Water": "2082-02-18T13:59:42+08:00",
    "Awakening of Insects": "2082-03-05T11:49:29+08:00",
    "Spring Equinox": "2082-03-20T12:29:59+08:00",
    "Pure Brightness": "2082-04-04T16:02:28+08:00",
    "Grain Rain": "2082-04-19T22:54:44+08:00",
    "Start of Summer": "2082-05-05T08:42:17+08:00",
    "Grain Buds": "2082-05-20T21:28:07+08:00",
    "Grain in Ear": "2082-06-05T12:21:31+08:00",
    "Summer Solstice": "2082-06-21T05:02:38+08:00",
    "Minor Heat": "2082-07-06T22:24:26+08:00",
    "Major Heat": "2082-07-22T15:52:22+08:00",
    "Start of Autumn": "2082-08-07T08:20:39+08:00",
    "End of Heat": "2082-08-22T23:12:47+08:00",
    "White Dew": "2082-09-07T11:41:55+08:00",
    "Autumn Equinox": "2082-09-22T21:22:18+08:00",
    "Cold Dew": "2082-10-08T03:56:51+08:00",
    "Frost's Descent": "2082-10-23T07:19:25+08:00",
    "Start of Winter": "2082-11-07T07:43:36+08:00",
    "Minor Snow": "2082-11-22T05:24:48+08:00",
    "Major Snow": "2082-12-07T01:00:54+08:00",
    "Winter Solstice": "2082-12-21T19:04:00+08:00",
    "Minor Cold": "2083-01-05T12:25:30+08:00",
    "Major Cold": "2083-01-20T05:45:40+08:00"
  },

  // 2083
  2083: {
    "Start of Spring": "2083-02-03T23:57:43+08:00",
    "Rain Water": "2083-02-18T19:39:34+08:00",
    "Awakening of Insects": "2083-03-05T17:35:35+08:00",
    "Spring Equinox": "2083-03-20T18:09:52+08:00",
    "Pure Brightness": "2083-04-04T21:49:38+08:00",
    "Grain Rain": "2083-04-20T04:34:48+08:00",
    "Start of Summer": "2083-05-05T14:30:57+08:00",
    "Grain Buds": "2083-05-21T03:08:10+08:00",
    "Grain in Ear": "2083-06-05T18:11:19+08:00",
    "Summer Solstice": "2083-06-21T10:43:14+08:00",
    "Minor Heat": "2083-07-07T04:15:10+08:00",
    "Major Heat": "2083-07-22T21:35:06+08:00",
    "Start of Autumn": "2083-08-07T14:12:11+08:00",
    "End of Heat": "2083-08-23T04:58:35+08:00",
    "White Dew": "2083-09-07T17:33:51+08:00",
    "Autumn Equinox": "2083-09-23T03:10:59+08:00",
    "Cold Dew": "2083-10-08T09:48:49+08:00",
    "Frost's Descent": "2083-10-23T13:09:42+08:00",
    "Start of Winter": "2083-11-07T13:35:03+08:00",
    "Minor Snow": "2083-11-22T11:14:58+08:00",
    "Major Snow": "2083-12-07T06:51:09+08:00",
    "Winter Solstice": "2083-12-22T00:52:43+08:00",
    "Minor Cold": "2084-01-05T18:14:21+08:00",
    "Major Cold": "2084-01-20T11:32:57+08:00"
  },

  // 2084
  2084: {
    "Start of Spring": "2084-02-04T05:45:58+08:00",
    "Rain Water": "2084-02-19T01:26:47+08:00",
    "Awakening of Insects": "2084-03-04T23:24:25+08:00",
    "Spring Equinox": "2084-03-19T23:58:51+08:00",
    "Pure Brightness": "2084-04-04T03:39:49+08:00",
    "Grain Rain": "2084-04-19T10:27:02+08:00",
    "Start of Summer": "2084-05-04T20:22:18+08:00",
    "Grain Buds": "2084-05-20T09:03:46+08:00",
    "Grain in Ear": "2084-06-05T00:02:05+08:00",
    "Summer Solstice": "2084-06-20T16:39:56+08:00",
    "Minor Heat": "2084-07-06T10:02:50+08:00",
    "Major Heat": "2084-07-22T03:29:56+08:00",
    "Start of Autumn": "2084-08-06T19:55:43+08:00",
    "End of Heat": "2084-08-22T10:49:49+08:00",
    "White Dew": "2084-09-06T23:13:43+08:00",
    "Autumn Equinox": "2084-09-22T08:58:29+08:00",
    "Cold Dew": "2084-10-07T15:26:36+08:00",
    "Frost's Descent": "2084-10-22T18:55:18+08:00",
    "Start of Winter": "2084-11-06T19:12:54+08:00",
    "Minor Snow": "2084-11-21T17:01:03+08:00",
    "Major Snow": "2084-12-06T12:30:32+08:00",
    "Winter Solstice": "2084-12-21T06:40:38+08:00",
    "Minor Cold": "2085-01-04T23:55:40+08:00",
    "Major Cold": "2085-01-19T17:22:59+08:00"
  },

  // 2085
  2085: {
    "Start of Spring": "2085-02-03T11:29:14+08:00",
    "Rain Water": "2085-02-18T07:18:55+08:00",
    "Awakening of Insects": "2085-03-05T05:09:52+08:00",
    "Spring Equinox": "2085-03-20T05:52:55+08:00",
    "Pure Brightness": "2085-04-04T09:27:41+08:00",
    "Grain Rain": "2085-04-19T16:22:11+08:00",
    "Start of Summer": "2085-05-05T02:12:25+08:00",
    "Grain Buds": "2085-05-20T14:58:20+08:00",
    "Grain in Ear": "2085-06-05T05:53:57+08:00",
    "Summer Solstice": "2085-06-20T22:32:12+08:00",
    "Minor Heat": "2085-07-06T15:55:42+08:00",
    "Major Heat": "2085-07-22T09:18:49+08:00",
    "Start of Autumn": "2085-08-07T01:48:49+08:00",
    "End of Heat": "2085-08-22T16:35:48+08:00",
    "White Dew": "2085-09-07T05:06:51+08:00",
    "Autumn Equinox": "2085-09-22T14:42:53+08:00",
    "Cold Dew": "2085-10-07T21:19:50+08:00",
    "Frost's Descent": "2085-10-23T00:39:33+08:00",
    "Start of Winter": "2085-11-07T01:06:59+08:00",
    "Minor Snow": "2085-11-21T22:46:36+08:00",
    "Major Snow": "2085-12-06T18:26:27+08:00",
    "Winter Solstice": "2085-12-21T12:28:07+08:00",
    "Minor Cold": "2086-01-05T05:53:02+08:00",
    "Major Cold": "2086-01-19T23:10:59+08:00"
  },

  // 2086
  2086: {
    "Start of Spring": "2086-02-03T17:25:48+08:00",
    "Rain Water": "2086-02-18T13:04:45+08:00",
    "Awakening of Insects": "2086-03-05T11:03:16+08:00",
    "Spring Equinox": "2086-03-20T11:34:42+08:00",
    "Pure Brightness": "2086-04-04T15:17:00+08:00",
    "Grain Rain": "2086-04-19T21:59:56+08:00",
    "Start of Summer": "2086-05-05T07:58:18+08:00",
    "Grain Buds": "2086-05-20T20:34:02+08:00",
    "Grain in Ear": "2086-06-05T11:38:02+08:00",
    "Summer Solstice": "2086-06-21T04:08:59+08:00",
    "Minor Heat": "2086-07-06T21:39:27+08:00",
    "Major Heat": "2086-07-22T14:59:03+08:00",
    "Start of Autumn": "2086-08-07T07:32:49+08:00",
    "End of Heat": "2086-08-22T22:20:17+08:00",
    "White Dew": "2086-09-07T10:51:49+08:00",
    "Autumn Equinox": "2086-09-22T20:31:37+08:00",
    "Cold Dew": "2086-10-08T03:06:27+08:00",
    "Frost's Descent": "2086-10-23T06:31:33+08:00",
    "Start of Winter": "2086-11-07T06:55:05+08:00",
    "Minor Snow": "2086-11-22T04:40:17+08:00",
    "Major Snow": "2086-12-07T00:15:16+08:00",
    "Winter Solstice": "2086-12-21T18:22:03+08:00",
    "Minor Cold": "2087-01-05T11:41:58+08:00",
    "Major Cold": "2087-01-20T05:04:38+08:00"
  },

  // 2087
  2087: {
    "Start of Spring": "2087-02-03T23:14:34+08:00",
    "Rain Water": "2087-02-18T18:58:03+08:00",
    "Awakening of Insects": "2087-03-05T16:51:22+08:00",
    "Spring Equinox": "2087-03-20T17:27:44+08:00",
    "Pure Brightness": "2087-04-04T21:03:54+08:00",
    "Grain Rain": "2087-04-20T03:53:12+08:00",
    "Start of Summer": "2087-05-05T13:44:06+08:00",
    "Grain Buds": "2087-05-21T02:28:25+08:00",
    "Grain in Ear": "2087-06-05T17:23:53+08:00",
    "Summer Solstice": "2087-06-21T10:05:23+08:00",
    "Minor Heat": "2087-07-07T03:27:22+08:00",
    "Major Heat": "2087-07-22T20:57:39+08:00",
    "Start of Autumn": "2087-08-07T13:23:42+08:00",
    "End of Heat": "2087-08-23T04:19:05+08:00",
    "White Dew": "2087-09-07T16:43:45+08:00",
    "Autumn Equinox": "2087-09-23T02:27:43+08:00",
    "Cold Dew": "2087-10-08T08:56:55+08:00",
    "Frost's Descent": "2087-10-23T12:23:38+08:00",
    "Start of Winter": "2087-11-07T12:42:36+08:00",
    "Minor Snow": "2087-11-22T10:28:34+08:00",
    "Major Snow": "2087-12-07T05:59:44+08:00",
    "Winter Solstice": "2087-12-22T00:07:54+08:00",
    "Minor Cold": "2088-01-05T17:24:39+08:00",
    "Major Cold": "2088-01-20T10:50:03+08:00"
  },

  // 2088
  2088: {
    "Start of Spring": "2088-02-04T04:57:31+08:00",
    "Rain Water": "2088-02-19T00:44:46+08:00",
    "Awakening of Insects": "2088-03-04T22:36:25+08:00",
    "Spring Equinox": "2088-03-19T23:16:29+08:00",
    "Pure Brightness": "2088-04-04T02:52:11+08:00",
    "Grain Rain": "2088-04-19T09:43:38+08:00",
    "Start of Summer": "2088-05-04T19:36:07+08:00",
    "Grain Buds": "2088-05-20T08:19:35+08:00",
    "Grain in Ear": "2088-06-04T23:19:24+08:00",
    "Summer Solstice": "2088-06-20T15:56:07+08:00",
    "Minor Heat": "2088-07-06T09:25:21+08:00",
    "Major Heat": "2088-07-22T02:47:36+08:00",
    "Start of Autumn": "2088-08-06T19:23:00+08:00",
    "End of Heat": "2088-08-22T10:08:56+08:00",
    "White Dew": "2088-09-06T22:43:22+08:00",
    "Autumn Equinox": "2088-09-22T08:17:43+08:00",
    "Cold Dew": "2088-10-07T14:55:44+08:00",
    "Frost's Descent": "2088-10-22T18:13:09+08:00",
    "Start of Winter": "2088-11-06T18:40:05+08:00",
    "Minor Snow": "2088-11-21T16:17:08+08:00",
    "Major Snow": "2088-12-06T11:56:06+08:00",
    "Winter Solstice": "2088-12-21T05:55:38+08:00",
    "Minor Cold": "2089-01-04T23:20:37+08:00",
    "Major Cold": "2089-01-19T16:37:38+08:00"
  },

  // 2089
  2089: {
    "Start of Spring": "2089-02-03T10:54:02+08:00",
    "Rain Water": "2089-02-18T06:33:15+08:00",
    "Awakening of Insects": "2089-03-05T04:34:03+08:00",
    "Spring Equinox": "2089-03-20T05:06:03+08:00",
    "Pure Brightness": "2089-04-04T08:49:49+08:00",
    "Grain Rain": "2089-04-19T15:32:57+08:00",
    "Start of Summer": "2089-05-05T01:31:14+08:00",
    "Grain Buds": "2089-05-20T14:07:24+08:00",
    "Grain in Ear": "2089-06-05T05:09:54+08:00",
    "Summer Solstice": "2089-06-20T21:42:24+08:00",
    "Minor Heat": "2089-07-06T15:10:30+08:00",
    "Major Heat": "2089-07-22T08:33:06+08:00",
    "Start of Autumn": "2089-08-07T01:04:04+08:00",
    "End of Heat": "2089-08-22T15:55:13+08:00",
    "White Dew": "2089-09-07T04:23:24+08:00",
    "Autumn Equinox": "2089-09-22T14:06:24+08:00",
    "Cold Dew": "2089-10-07T20:37:22+08:00",
    "Frost's Descent": "2089-10-23T00:04:48+08:00",
    "Start of Winter": "2089-11-07T00:24:11+08:00",
    "Minor Snow": "2089-11-21T22:11:21+08:00",
    "Major Snow": "2089-12-06T17:42:20+08:00",
    "Winter Solstice": "2089-12-21T11:51:30+08:00",
    "Minor Cold": "2090-01-05T05:08:05+08:00",
    "Major Cold": "2090-01-19T22:34:04+08:00"
  },

  // 2090
  2090: {
    "Start of Spring": "2090-02-03T16:41:40+08:00",
    "Rain Water": "2090-02-18T12:29:19+08:00",
    "Awakening of Insects": "2090-03-05T10:20:54+08:00",
    "Spring Equinox": "2090-03-20T11:01:23+08:00",
    "Pure Brightness": "2090-04-04T14:35:37+08:00",
    "Grain Rain": "2090-04-19T21:27:48+08:00",
    "Start of Summer": "2090-05-05T07:16:07+08:00",
    "Grain Buds": "2090-05-20T20:01:32+08:00",
    "Grain in Ear": "2090-06-05T10:54:21+08:00",
    "Summer Solstice": "2090-06-21T03:35:22+08:00",
    "Minor Heat": "2090-07-06T20:55:59+08:00",
    "Major Heat": "2090-07-22T14:24:56+08:00",
    "Start of Autumn": "2090-08-07T06:52:11+08:00",
    "End of Heat": "2090-08-22T21:46:37+08:00",
    "White Dew": "2090-09-07T10:15:14+08:00",
    "Autumn Equinox": "2090-09-22T19:58:49+08:00",
    "Cold Dew": "2090-10-08T02:33:08+08:00",
    "Frost's Descent": "2090-10-23T05:58:47+08:00",
    "Start of Winter": "2090-11-07T06:22:05+08:00",
    "Minor Snow": "2090-11-22T04:05:17+08:00",
    "Major Snow": "2090-12-06T23:39:14+08:00",
    "Winter Solstice": "2090-12-21T17:43:02+08:00",
    "Minor Cold": "2091-01-05T11:01:21+08:00",
    "Major Cold": "2091-01-20T04:21:33+08:00"
  },

  // 2091
  2091: {
    "Start of Spring": "2091-02-03T22:30:13+08:00",
    "Rain Water": "2091-02-18T18:12:24+08:00",
    "Awakening of Insects": "2091-03-05T16:05:44+08:00",
    "Spring Equinox": "2091-03-20T16:41:22+08:00",
    "Pure Brightness": "2091-04-04T20:19:33+08:00",
    "Grain Rain": "2091-04-20T03:07:02+08:00",
    "Start of Summer": "2091-05-05T13:02:29+08:00",
    "Grain Buds": "2091-05-21T01:42:09+08:00",
    "Grain in Ear": "2091-06-05T16:44:53+08:00",
    "Summer Solstice": "2091-06-21T09:18:26+08:00",
    "Minor Heat": "2091-07-07T02:50:17+08:00",
    "Major Heat": "2091-07-22T20:11:00+08:00",
    "Start of Autumn": "2091-08-07T12:48:52+08:00",
    "End of Heat": "2091-08-23T03:35:45+08:00",
    "White Dew": "2091-09-07T16:12:50+08:00",
    "Autumn Equinox": "2091-09-23T01:50:21+08:00",
    "Cold Dew": "2091-10-08T08:30:49+08:00",
    "Frost's Descent": "2091-10-23T11:51:59+08:00",
    "Start of Winter": "2091-11-07T12:20:06+08:00",
    "Minor Snow": "2091-11-22T09:59:47+08:00",
    "Major Snow": "2091-12-07T05:37:54+08:00",
    "Winter Solstice": "2091-12-21T23:38:02+08:00",
    "Minor Cold": "2092-01-05T17:00:11+08:00",
    "Major Cold": "2092-01-20T10:15:57+08:00"
  },

  // 2092
  2092: {
    "Start of Spring": "2092-02-04T04:28:13+08:00",
    "Rain Water": "2092-02-19T00:05:25+08:00",
    "Awakening of Insects": "2092-03-04T22:02:02+08:00",
    "Spring Equinox": "2092-03-19T22:33:05+08:00",
    "Pure Brightness": "2092-04-04T02:13:58+08:00",
    "Grain Rain": "2092-04-19T08:58:49+08:00",
    "Start of Summer": "2092-05-04T18:55:41+08:00",
    "Grain Buds": "2092-05-20T07:35:58+08:00",
    "Grain in Ear": "2092-06-04T22:37:09+08:00",
    "Summer Solstice": "2092-06-20T15:14:29+08:00",
    "Minor Heat": "2092-07-06T08:40:20+08:00",
    "Major Heat": "2092-07-22T02:07:11+08:00",
    "Start of Autumn": "2092-08-06T18:35:25+08:00",
    "End of Heat": "2092-08-22T09:29:46+08:00",
    "White Dew": "2092-09-06T21:55:37+08:00",
    "Autumn Equinox": "2092-09-22T07:41:18+08:00",
    "Cold Dew": "2092-10-07T14:11:04+08:00",
    "Frost's Descent": "2092-10-22T17:41:13+08:00",
    "Start of Winter": "2092-11-06T18:00:17+08:00",
    "Minor Snow": "2092-11-21T15:49:59+08:00",
    "Major Snow": "2092-12-06T11:20:28+08:00",
    "Winter Solstice": "2092-12-21T05:31:25+08:00",
    "Minor Cold": "2093-01-04T22:46:27+08:00",
    "Major Cold": "2093-01-19T16:13:11+08:00"
  },

  // 2093
  2093: {
    "Start of Spring": "2093-02-03T10:18:00+08:00",
    "Rain Water": "2093-02-18T06:05:35+08:00",
    "Awakening of Insects": "2093-03-05T03:53:49+08:00",
    "Spring Equinox": "2093-03-20T04:34:02+08:00",
    "Pure Brightness": "2093-04-04T08:05:39+08:00",
    "Grain Rain": "2093-04-19T14:58:00+08:00",
    "Start of Summer": "2093-05-05T00:45:44+08:00",
    "Grain Buds": "2093-05-20T13:31:33+08:00",
    "Grain in Ear": "2093-06-05T04:26:01+08:00",
    "Summer Solstice": "2093-06-20T21:06:34+08:00",
    "Minor Heat": "2093-07-06T14:30:02+08:00",
    "Major Heat": "2093-07-22T07:56:51+08:00",
    "Start of Autumn": "2093-08-07T00:27:07+08:00",
    "End of Heat": "2093-08-22T15:17:54+08:00",
    "White Dew": "2093-09-07T03:49:07+08:00",
    "Autumn Equinox": "2093-09-22T13:28:25+08:00",
    "Cold Dew": "2093-10-07T20:05:25+08:00",
    "Frost's Descent": "2093-10-22T23:27:47+08:00",
    "Start of Winter": "2093-11-06T23:55:12+08:00",
    "Minor Snow": "2093-11-21T21:37:04+08:00",
    "Major Snow": "2093-12-06T17:16:43+08:00",
    "Winter Solstice": "2093-12-21T11:20:15+08:00",
    "Minor Cold": "2094-01-05T04:44:24+08:00",
    "Major Cold": "2094-01-19T22:03:29+08:00"
  },

  // 2094
  2094: {
    "Start of Spring": "2094-02-03T16:16:28+08:00",
    "Rain Water": "2094-02-18T11:55:26+08:00",
    "Awakening of Insects": "2094-03-05T09:50:51+08:00",
    "Spring Equinox": "2094-03-20T10:21:04+08:00",
    "Pure Brightness": "2094-04-04T13:59:26+08:00",
    "Grain Rain": "2094-04-19T20:40:21+08:00",
    "Start of Summer": "2094-05-05T06:35:09+08:00",
    "Grain Buds": "2094-05-20T19:09:06+08:00",
    "Grain in Ear": "2094-06-05T10:11:23+08:00",
    "Summer Solstice": "2094-06-21T02:41:49+08:00",
    "Minor Heat": "2094-07-06T20:13:26+08:00",
    "Major Heat": "2094-07-22T13:33:51+08:00",
    "Start of Autumn": "2094-08-07T06:11:03+08:00",
    "End of Heat": "2094-08-22T20:59:44+08:00",
    "White Dew": "2094-09-07T09:35:29+08:00",
    "Autumn Equinox": "2094-09-22T19:16:02+08:00",
    "Cold Dew": "2094-10-08T01:54:44+08:00",
    "Frost's Descent": "2094-10-23T05:19:40+08:00",
    "Start of Winter": "2094-11-07T05:46:08+08:00",
    "Minor Snow": "2094-11-22T03:30:22+08:00",
    "Major Snow": "2094-12-06T23:07:31+08:00",
    "Winter Solstice": "2094-12-21T17:12:48+08:00",
    "Minor Cold": "2095-01-05T10:34:27+08:00",
    "Major Cold": "2095-01-20T03:55:13+08:00"
  },

  // 2095
  2095: {
    "Start of Spring": "2095-02-03T22:06:29+08:00",
    "Rain Water": "2095-02-18T17:47:30+08:00",
    "Awakening of Insects": "2095-03-05T15:41:26+08:00",
    "Spring Equinox": "2095-03-20T16:14:27+08:00",
    "Pure Brightness": "2095-04-04T19:50:19+08:00",
    "Grain Rain": "2095-04-20T02:35:25+08:00",
    "Start of Summer": "2095-05-05T12:25:20+08:00",
    "Grain Buds": "2095-05-21T01:05:20+08:00",
    "Grain in Ear": "2095-06-05T15:59:50+08:00",
    "Summer Solstice": "2095-06-21T08:38:21+08:00",
    "Minor Heat": "2095-07-07T02:00:26+08:00",
    "Major Heat": "2095-07-22T19:30:24+08:00",
    "Start of Autumn": "2095-08-07T11:58:04+08:00",
    "End of Heat": "2095-08-23T02:55:49+08:00",
    "White Dew": "2095-09-07T15:22:53+08:00",
    "Autumn Equinox": "2095-09-23T01:10:36+08:00",
    "Cold Dew": "2095-10-08T07:41:54+08:00",
    "Frost's Descent": "2095-10-23T11:12:14+08:00",
    "Start of Winter": "2095-11-07T11:32:05+08:00",
    "Minor Snow": "2095-11-22T09:20:29+08:00",
    "Major Snow": "2095-12-07T04:51:02+08:00",
    "Winter Solstice": "2095-12-21T23:00:18+08:00",
    "Minor Cold": "2096-01-05T16:15:22+08:00",
    "Major Cold": "2096-01-20T09:40:59+08:00"
  },

  // 2096
  2096: {
    "Start of Spring": "2096-02-04T03:46:18+08:00",
    "Rain Water": "2096-02-18T23:33:26+08:00",
    "Awakening of Insects": "2096-03-04T21:22:37+08:00",
    "Spring Equinox": "2096-03-19T22:02:23+08:00",
    "Pure Brightness": "2096-04-04T01:35:11+08:00",
    "Grain Rain": "2096-04-19T08:26:09+08:00",
    "Start of Summer": "2096-05-04T18:15:06+08:00",
    "Grain Buds": "2096-05-20T06:58:00+08:00",
    "Grain in Ear": "2096-06-04T21:53:52+08:00",
    "Summer Solstice": "2096-06-20T14:30:16+08:00",
    "Minor Heat": "2096-07-06T07:56:03+08:00",
    "Major Heat": "2096-07-22T01:18:57+08:00",
    "Start of Autumn": "2096-08-06T17:52:51+08:00",
    "End of Heat": "2096-08-22T08:41:01+08:00",
    "White Dew": "2096-09-06T21:16:27+08:00",
    "Autumn Equinox": "2096-09-22T06:54:12+08:00",
    "Cold Dew": "2096-10-07T13:34:49+08:00",
    "Frost's Descent": "2096-10-22T16:55:45+08:00",
    "Start of Winter": "2096-11-06T17:25:21+08:00",
    "Minor Snow": "2096-11-21T15:04:56+08:00",
    "Major Snow": "2096-12-06T10:45:17+08:00",
    "Winter Solstice": "2096-12-21T04:45:41+08:00",
    "Minor Cold": "2097-01-04T22:10:20+08:00",
    "Major Cold": "2097-01-19T15:26:41+08:00"
  },

  // 2097
  2097: {
    "Start of Spring": "2097-02-03T09:41:26+08:00",
    "Rain Water": "2097-02-18T05:19:06+08:00",
    "Awakening of Insects": "2097-03-05T03:17:46+08:00",
    "Spring Equinox": "2097-03-20T03:47:53+08:00",
    "Pure Brightness": "2097-04-04T07:29:41+08:00",
    "Grain Rain": "2097-04-19T14:10:49+08:00",
    "Start of Summer": "2097-05-05T00:07:39+08:00",
    "Grain Buds": "2097-05-20T12:41:29+08:00",
    "Grain in Ear": "2097-06-05T03:43:10+08:00",
    "Summer Solstice": "2097-06-20T20:12:51+08:00",
    "Minor Heat": "2097-07-06T13:40:50+08:00",
    "Major Heat": "2097-07-22T07:00:28+08:00",
    "Start of Autumn": "2097-08-06T23:32:21+08:00",
    "End of Heat": "2097-08-22T14:21:36+08:00",
    "White Dew": "2097-09-07T02:52:19+08:00",
    "Autumn Equinox": "2097-09-22T12:35:19+08:00",
    "Cold Dew": "2097-10-07T19:10:21+08:00",
    "Frost's Descent": "2097-10-22T22:39:16+08:00",
    "Start of Winter": "2097-11-06T23:03:19+08:00",
    "Minor Snow": "2097-11-21T20:52:11+08:00",
    "Major Snow": "2097-12-06T16:27:13+08:00",
    "Winter Solstice": "2097-12-21T10:36:53+08:00",
    "Minor Cold": "2098-01-05T03:55:53+08:00",
    "Major Cold": "2098-01-19T21:20:24+08:00"
  },

  // 2098
  2098: {
    "Start of Spring": "2098-02-03T15:28:27+08:00",
    "Rain Water": "2098-02-18T11:12:51+08:00",
    "Awakening of Insects": "2098-03-05T09:03:28+08:00",
    "Spring Equinox": "2098-03-20T09:39:55+08:00",
    "Pure Brightness": "2098-04-04T13:12:44+08:00",
    "Grain Rain": "2098-04-19T20:01:14+08:00",
    "Start of Summer": "2098-05-05T05:48:20+08:00",
    "Grain Buds": "2098-05-20T18:31:04+08:00",
    "Grain in Ear": "2098-06-05T09:22:51+08:00",
    "Summer Solstice": "2098-06-21T02:02:26+08:00",
    "Minor Heat": "2098-07-06T19:21:48+08:00",
    "Major Heat": "2098-07-22T12:50:25+08:00",
    "Start of Autumn": "2098-08-07T05:16:00+08:00",
    "End of Heat": "2098-08-22T20:11:05+08:00",
    "White Dew": "2098-09-07T08:38:09+08:00",
    "Autumn Equinox": "2098-09-22T18:23:39+08:00",
    "Cold Dew": "2098-10-08T00:57:23+08:00",
    "Frost's Descent": "2098-10-23T04:26:21+08:00",
    "Start of Winter": "2098-11-07T04:50:08+08:00",
    "Minor Snow": "2098-11-22T02:37:34+08:00",
    "Major Snow": "2098-12-06T22:12:21+08:00",
    "Winter Solstice": "2098-12-21T16:20:16+08:00",
    "Minor Cold": "2099-01-05T09:38:43+08:00",
    "Major Cold": "2099-01-20T03:01:46+08:00"
  },

  // 2099
  2099: {
    "Start of Spring": "2099-02-03T21:08:57+08:00",
    "Rain Water": "2099-02-18T16:52:06+08:00",
    "Awakening of Insects": "2099-03-05T14:42:05+08:00",
    "Spring Equinox": "2099-03-20T15:17:10+08:00",
    "Pure Brightness": "2099-04-04T18:50:53+08:00",
    "Grain Rain": "2099-04-20T01:37:25+08:00",
    "Start of Summer": "2099-05-05T11:28:31+08:00",
    "Grain Buds": "2099-05-21T00:07:46+08:00",
    "Grain in Ear": "2099-06-05T15:07:13+08:00",
    "Summer Solstice": "2099-06-21T07:41:05+08:00",
    "Minor Heat": "2099-07-07T01:11:09+08:00",
    "Major Heat": "2099-07-22T18:32:23+08:00",
    "Start of Autumn": "2099-08-07T11:09:40+08:00",
    "End of Heat": "2099-08-23T01:56:34+08:00",
    "White Dew": "2099-09-07T14:33:36+08:00",
    "Autumn Equinox": "2099-09-23T00:10:33+08:00",
    "Cold Dew": "2099-10-08T06:51:38+08:00",
    "Frost's Descent": "2099-10-23T10:12:22+08:00",
    "Start of Winter": "2099-11-07T10:42:05+08:00",
    "Minor Snow": "2099-11-22T08:22:04+08:00",
    "Major Snow": "2099-12-07T04:02:43+08:00",
    "Winter Solstice": "2099-12-21T22:03:47+08:00",
    "Minor Cold": "2100-01-05T15:28:44+08:00",
    "Major Cold": "2100-01-20T08:45:20+08:00"
  }
};

export function getAllSolarTermsForYear(year) {
  if (solarTermsData[year]) {
    return solarTermsData[year]; // Already using English keys
  }
  throw new Error(`Solar terms data for year ${year} not found`);
}

export function getSolarTerm(year, termName) {
  // Use English term directly as key
  if (solarTermsData[year] && solarTermsData[year][termName]) {
    return solarTermsData[year][termName];
  }
  throw new Error(`Solar term ${termName} for year ${year} not found`);
}

// Helper function to get major solar terms (for month pillars)
export function getMajorSolarTerms(year) {
  const majorTerms = [
    'Start of Spring',
    'Awakening of Insects',
    'Pure Brightness',
    'Start of Summer',
    'Grain in Ear',
    'Minor Heat',
    'Start of Autumn',
    'White Dew',
    'Cold Dew',
    'Start of Winter',
    'Major Snow',
    'Minor Cold'
  ];
  
  if (solarTermsData[year]) {
    return majorTerms.map(term => ({
      name: term,
      chineseName: solarTermsMap[term],
      date: solarTermsData[year][solarTermsMap[term]]
    }));
  }
  throw new Error(`Solar terms data for year ${year} not found`);
}

// Get Chinese name for English term
export function getChineseTermName(englishName) {
  return solarTermsMap[englishName] || englishName;
}

// Get English name for Chinese term
export function getEnglishTermName(chineseName) {
  return Object.keys(solarTermsMap).find(key => solarTermsMap[key] === chineseName) || chineseName;
}
